module.exports = {
    /**
     *    '眉州东坡酒楼（民族园店）'
     * https://brain.sankuai.com/brain-api/v2/getPoi3dGraph?subjectId=1008938503825825874&nearByPoiCount=3&simPoiCount=3&dishCount=2&tagCountPerPoi=2&envDistributionCount=1&topPoiListSize=2&tagPoiCount=2&envPoiCount=2
     */
    '1008938503825825874': {
        nodes: [
            {
                depth: '2',
                rootId: '1008936197508075588',
                name: '通威水煮鱼',
                id: '20_1045506407232716894',
                isleaf: '1',
                type: 'Food.Dish',
                group: 7
            },
            {
                depth: '2',
                rootId: '1008939065262755975',
                name: '菜品不错',
                id: '26_1031468355271299158',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '2',
                rootId: '1008937201171468320',
                name: '土豪 3%',
                id: '23_7170160245214524',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1000
            },
            {
                depth: '0',
                rootId: '1008936261286654001',
                name: '南北风味餐厅:鱼头泡饼筋头巴脑（小营路店）',
                id: '1008936261286654001',
                isleaf: '0',
                type: 'Organization.POI',
                group: 1
            },
            {
                depth: '2',
                rootId: '1008937426439151648',
                name: '撸串圣地 6%',
                id: '1_7170127937154830',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1500
            },
            {
                depth: '1',
                rootId: '1008936261286654001',
                name: '推荐菜',
                id: '2_7170128725895296',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 900
            },
            {
                depth: '2',
                rootId: '1008937201171468320',
                name: '味道赞',
                id: '23_1031468354713464917',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '1',
                rootId: '1008939065262755975',
                name: '环境偏好',
                id: '26_7170164719944258',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1500
            },
            {
                depth: '1',
                rootId: '1008937201171468320',
                name: '年龄分布',
                id: '23_7170160129224505',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1700
            },
            {
                depth: '2',
                rootId: '1008936261286654001',
                name: '亲子餐厅',
                id: '2_1031468354373709875',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '2',
                rootId: '1008938067865645135',
                name: '无辣不欢 9%',
                id: '35_7170178733326010',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1500
            },
            {
                depth: '2',
                rootId: '1008939065262755975',
                name: '老北京炸酱面',
                id: '26_1007587919700979981',
                isleaf: '1',
                type: 'Food.Dish',
                group: 3
            },
            {
                depth: '2',
                rootId: '1008937426439151648',
                name: '天津市:天津 1%',
                id: '1_7170128705322238',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1900
            },
            {
                depth: '2',
                rootId: '1008938503825825874',
                name: '35-45岁 40%',
                id: '7170124452978373',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1700
            },
            {
                depth: '2',
                rootId: '1008938699888549935',
                name: '花花的口水鸡',
                id: '59_1007588033542770807',
                isleaf: '1',
                type: 'Food.Dish',
                group: 4
            },
            {
                depth: '2',
                rootId: '1008937099551838291',
                name: '快速方便 8%',
                id: '62_7170217876159330',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1500
            },
            {
                depth: '2',
                rootId: '1008938699888549935',
                name: '酸菜小鱼',
                id: '59_1007588033542770805',
                isleaf: '1',
                type: 'Food.Dish',
                group: 5
            },
            {
                depth: '2',
                rootId: '1008938699888549935',
                name: '花花番茄鱼',
                id: '59_1007588033542770806',
                isleaf: '1',
                type: 'Food.Dish',
                group: 3
            },
            {
                depth: '1',
                rootId: '1008938755635040295',
                name: '标签',
                id: '56_7170209896226007',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '2',
                rootId: '1008937201171468320',
                name: '山西省:太原 1%',
                id: '23_7170161227316237',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1900
            },
            {
                depth: '2',
                rootId: '1008938503825825874',
                name: '普通 37%',
                id: '7170124569581715',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1000
            },
            {
                depth: '2',
                rootId: '1008938067865645135',
                name: '小资 45%',
                id: '35_7170178602396024',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1000
            },
            {
                depth: '1',
                rootId: '1008936197508075588',
                name: '消费水平分布',
                id: '20_7170155908705201',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1800
            },
            {
                depth: '0',
                rootId: '1008937201171468320',
                name: '蜀中仙川味大酒楼',
                id: '1008937201171468320',
                isleaf: '0',
                type: 'Organization.POI',
                group: 1
            },
            {
                depth: '2',
                rootId: '1008936699692069011',
                name: '上海市:上海 1%',
                id: '16_7170151317559866',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1900
            },
            {
                depth: '2',
                rootId: '1008938067865645135',
                name: '亲子餐厅',
                id: '35_1031468354373709875',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '2',
                rootId: '1008936261286654001',
                name: '普通 36%',
                id: '2_7170129120038628',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1000
            },
            {
                depth: '2',
                rootId: '1008937746309345364',
                name: '35-45岁 29%',
                id: '44_7170191138927621',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1700
            },
            {
                depth: '2',
                rootId: '1008938699888549935',
                name: '女 73%',
                id: '59_7170213807837257',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1600
            },
            {
                depth: '2',
                rootId: '1008937746309345364',
                name: '实惠 9%',
                id: '44_7170191255300012',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1000
            },
            {
                depth: '1',
                rootId: '1008937201171468320',
                name: '环境偏好',
                id: '23_7170160245226607',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1500
            },
            {
                depth: '1',
                rootId: '1008939065262755975',
                name: '标签',
                id: '26_7170165447631623',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '1',
                rootId: null,
                name: '相似餐厅',
                id: '2_7170129384547296',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 2000
            },
            {
                depth: '1',
                rootId: '1008939065262755975',
                name: '消费水平分布',
                id: '26_7170164719891531',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1800
            },
            {
                depth: '2',
                rootId: '1008936197508075588',
                name: '三椒美容猪蹄',
                id: '20_1007587952798224614',
                isleaf: '1',
                type: 'Food.Dish',
                group: 6
            },
            {
                depth: '1',
                rootId: '1008938503825825874',
                name: '用户常驻城市',
                id: '7170125736873287',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1900
            },
            {
                depth: '2',
                rootId: '1008939065262755975',
                name: '北京菜',
                id: '26_1031468354713464871',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '2',
                rootId: '1008938699888549935',
                name: '高档 8%',
                id: '59_7170213543079934',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1000
            },
            {
                depth: '2',
                rootId: '1008936699692069011',
                name: '普通 42%',
                id: '16_7170150375842543',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1000
            },
            {
                depth: '1',
                rootId: '1008936197508075588',
                name: '性别分布',
                id: '20_7170156174784451',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1600
            },
            {
                depth: '1',
                rootId: '1008937099551838291',
                name: '环境偏好',
                id: '62_7170217740685132',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1500
            },
            {
                depth: '2',
                rootId: '1008936699692069011',
                name: '北京市:北京 98%',
                id: '16_7170151317557335',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1900
            },
            {
                depth: '1',
                rootId: '1008936699692069011',
                name: '环境偏好',
                id: '16_7170150375852236',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1500
            },
            {
                depth: '2',
                rootId: '1008938503825825874',
                name: '土豪 5%',
                id: '7170124569580409',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1000
            },
            {
                depth: '2',
                rootId: '1008937426439151648',
                name: '普通 28%',
                id: '1_7170127807956212',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1000
            },
            {
                depth: '2',
                rootId: '1008938755635040295',
                name: '16-25岁 4%',
                id: '56_7170208960355846',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1700
            },
            {
                depth: '1',
                rootId: '1008936620096786509',
                name: '环境偏好',
                id: '63_7170219092245106',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1500
            },
            {
                depth: '0',
                rootId: '1008938755635040295',
                name: '眉州小吃（回龙观西大街店）',
                id: '1008938755635040295',
                isleaf: '0',
                type: 'Organization.POI',
                group: 1
            },
            {
                depth: '2',
                rootId: '1008938699888549935',
                name: '45岁以上 11%',
                id: '59_7170213427105162',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1700
            },
            {
                depth: '2',
                rootId: '1008938699888549935',
                name: '干净卫生 7%',
                id: '59_7170213684803033',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1500
            },
            {
                depth: '1',
                rootId: '1008937746309345364',
                name: '环境偏好',
                id: '44_7170191255310270',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1500
            },
            {
                depth: '1',
                rootId: '1008938503825825874',
                name: '推荐菜',
                id: '7170124028611590',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 900
            },
            {
                depth: '2',
                rootId: '1008938699888549935',
                name: '25-35岁 54%',
                id: '59_7170213427107468',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1700
            },
            {
                depth: '2',
                rootId: '1008938755635040295',
                name: '服务热情',
                id: '56_1031468354918940782',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '2',
                rootId: '1008937099551838291',
                name: '鲜香',
                id: '62_1031468355036397638',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '2',
                rootId: '1008936261286654001',
                name: '撸串圣地 20%',
                id: '2_7170129236053229',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1500
            },
            {
                depth: '2',
                rootId: '1008936197508075588',
                name: '25-35岁 56%',
                id: '20_7170155792085661',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1700
            },
            {
                depth: '2',
                rootId: '1008936699692069011',
                name: '原味奶茶',
                id: '16_1007587739626922079',
                isleaf: '1',
                type: 'Food.Dish',
                group: 6
            },
            {
                depth: '2',
                rootId: '1008936197508075588',
                name: '45岁以上 6%',
                id: '20_7170155792090083',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1700
            },
            {
                depth: '2',
                rootId: '1008938503825825874',
                name: '25-35岁 36%',
                id: '7170124452983632',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1700
            },
            {
                depth: '2',
                rootId: '1008939065262755975',
                name: '服务热情',
                id: '26_1031468354918940782',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '2',
                rootId: '1008936620096786509',
                name: '重庆老开县冰薄桔红月饼礼盒',
                id: '63_1038831313160777889',
                isleaf: '1',
                type: 'Food.Dish',
                group: 7
            },
            {
                depth: '2',
                rootId: '1008937099551838291',
                name: '北京市:北京 100%',
                id: '62_7170218653324128',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1900
            },
            {
                depth: '2',
                rootId: '1008937426439151648',
                name: '高逼格自助餐 4%',
                id: '1_7170127943294606',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1500
            },
            {
                depth: '2',
                rootId: '1008936620096786509',
                name: '无辣不欢 22%',
                id: '63_7170219208596778',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1500
            },
            {
                depth: '1',
                rootId: '1008936620096786509',
                name: '年龄分布',
                id: '63_7170218975663392',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1700
            },
            {
                depth: '2',
                rootId: '1008936620096786509',
                name: '35-45岁 32%',
                id: '63_7170218975701750',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1700
            },
            {
                depth: '2',
                rootId: '1008938755635040295',
                name: '25-35岁 48%',
                id: '56_7170208960352002',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1700
            },
            {
                depth: '2',
                rootId: '1008936261286654001',
                name: '土豪 2%',
                id: '2_7170129120039407',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1000
            },
            {
                depth: '1',
                rootId: '1008937746309345364',
                name: '年龄分布',
                id: '44_7170191138868634',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1700
            },
            {
                depth: '2',
                rootId: '1008937426439151648',
                name: '干炒牛河',
                id: '1_1007588278339154087',
                isleaf: '1',
                type: 'Food.Dish',
                group: 6
            },
            {
                depth: '2',
                rootId: '1008937426439151648',
                name: '45岁以上 8%',
                id: '1_7170127691556994',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1700
            },
            {
                depth: '2',
                rootId: '1008936261286654001',
                name: '菜品不错',
                id: '2_1031468355271299158',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '2',
                rootId: '1008937201171468320',
                name: '女 72%',
                id: '23_7170160508019265',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1600
            },
            {
                depth: '2',
                rootId: '1008937426439151648',
                name: '鹅夫人招牌烧鹅（含腿）',
                id: '1_1007588278339154083',
                isleaf: '1',
                type: 'Food.Dish',
                group: 4
            },
            {
                depth: '0',
                rootId: '1008936197508075588',
                name: '麻小丨麻辣诱惑（君太店）',
                id: '1008936197508075588',
                isleaf: '0',
                type: 'Organization.POI',
                group: 1
            },
            {
                depth: '2',
                rootId: '1008938503825825874',
                name: '鸿运年糕',
                id: '1007588332554694661',
                isleaf: '1',
                type: 'Food.Dish',
                group: 6
            },
            {
                depth: '1',
                rootId: '1008938755635040295',
                name: '消费水平分布',
                id: '56_7170209078092413',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1800
            },
            {
                depth: '2',
                rootId: '1008939065262755975',
                name: '25-35岁 54%',
                id: '26_7170164603274581',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1700
            },
            {
                depth: '1',
                rootId: null,
                name: '相似餐厅',
                id: '7170124835824829',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 2000
            },
            {
                depth: '2',
                rootId: '1008938067865645135',
                name: '小笼包',
                id: '35_1044629405588000875',
                isleaf: '1',
                type: 'Food.Dish',
                group: 4
            },
            {
                depth: '2',
                rootId: '1008938067865645135',
                name: '浙江省:杭州 2%',
                id: '35_7170179615146761',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1900
            },
            {
                depth: '2',
                rootId: '1008939065262755975',
                name: '甜味',
                id: '26_1031468355036397670',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '1',
                rootId: null,
                name: '相似餐厅',
                id: '35_7170178868957416',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 2000
            },
            {
                depth: '2',
                rootId: '1008937426439151648',
                name: '女 51%',
                id: '1_7170128072344001',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1600
            },
            {
                depth: '1',
                rootId: '1008936261286654001',
                name: '标签',
                id: '2_7170129957342225',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '2',
                rootId: '1008936197508075588',
                name: '河北省:廊坊 1%',
                id: '20_7170156848478146',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1900
            },
            {
                depth: '2',
                rootId: '1008937099551838291',
                name: '菜品不错',
                id: '62_1031468355271299158',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '2',
                rootId: '1008936699692069011',
                name: '撸串圣地 12%',
                id: '16_7170150499642793',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1500
            },
            {
                depth: '1',
                rootId: '1008937099551838291',
                name: '用户常驻城市',
                id: '62_7170218653303445',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1900
            },
            {
                depth: '2',
                rootId: '1008937426439151648',
                name: '粤式早茶',
                id: '1_1031468355141263390',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '2',
                rootId: '1008937201171468320',
                name: '16-25岁 14%',
                id: '23_7170160129268545',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1700
            },
            {
                depth: '1',
                rootId: '1008936197508075588',
                name: '环境偏好',
                id: '20_7170155908756813',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1500
            },
            {
                depth: '2',
                rootId: '1008937099551838291',
                name: '朋友聚餐',
                id: '62_1031468354918940778',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '2',
                rootId: '1008938699888549935',
                name: '普通 39%',
                id: '59_7170213543077315',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1000
            },
            {
                depth: '2',
                rootId: '1008938067865645135',
                name: '女 74%',
                id: '35_7170178868947097',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1600
            },
            {
                depth: '2',
                rootId: '1008937099551838291',
                name: '有酒有肉',
                id: '62_1031468354918940774',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '2',
                rootId: '1008936699692069011',
                name: '高档 9%',
                id: '16_7170150375845612',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1000
            },
            {
                depth: '2',
                rootId: '1008937201171468320',
                name: '普通 43%',
                id: '23_7170160245219273',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1000
            },
            {
                depth: '2',
                rootId: '1008936620096786509',
                name: '高档 6%',
                id: '63_7170219092241062',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1000
            },
            {
                depth: '1',
                rootId: '1008937201171468320',
                name: '附近餐厅',
                id: '23_7170160928510872',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 2100
            },
            {
                depth: '2',
                rootId: '1008937201171468320',
                name: '撸串圣地 11%',
                id: '23_7170160368630941',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1500
            },
            {
                depth: '1',
                rootId: '1008936261286654001',
                name: '用户常驻城市',
                id: '2_7170130131575867',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1900
            },
            {
                depth: '2',
                rootId: '1008937746309345364',
                name: '上海市:上海 1%',
                id: '44_7170192214974910',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1900
            },
            {
                depth: '2',
                rootId: '1008936261286654001',
                name: '有表演 9%',
                id: '2_7170129256389123',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1500
            },
            {
                depth: '2',
                rootId: '1008938067865645135',
                name: '名人出没 9%',
                id: '35_7170178740365162',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1500
            },
            {
                depth: '1',
                rootId: '1008938699888549935',
                name: '年龄分布',
                id: '59_7170213427059138',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1700
            },
            {
                depth: '1',
                rootId: '1008938699888549935',
                name: '用户常驻城市',
                id: '59_7170214405164842',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1900
            },
            {
                depth: '2',
                rootId: '1008939065262755975',
                name: '广东省:广州 1%',
                id: '26_7170165642221014',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1900
            },
            {
                depth: '0',
                rootId: '1008937099551838291',
                name: '郁陵岛炭火烤肉（恩济庄店）',
                id: '1008937099551838291',
                isleaf: '0',
                type: 'Organization.POI',
                group: 1
            },
            {
                depth: '2',
                rootId: '1008936699692069011',
                name: '实惠 11%',
                id: '16_7170150375844776',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1000
            },
            {
                depth: '2',
                rootId: '1008936261286654001',
                name: '上海市:上海 1%',
                id: '2_7170130131593045',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1900
            },
            {
                depth: '2',
                rootId: '1008936197508075588',
                name: '35-45岁 28%',
                id: '20_7170155792088082',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1700
            },
            {
                depth: '2',
                rootId: '1008937201171468320',
                name: '菜品不错 10%',
                id: '23_7170160381191652',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1500
            },
            {
                depth: '2',
                rootId: '1008937201171468320',
                name: '香辣蟹',
                id: '23_1044994168289521811',
                isleaf: '1',
                type: 'Food.Dish',
                group: 4
            },
            {
                depth: '2',
                rootId: '1008936261286654001',
                name: '服务热情',
                id: '2_1031468354918940782',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '0',
                rootId: '1008937426439151648',
                name: '鹅夫人（合生汇店）',
                id: '1008937426439151648',
                isleaf: '0',
                type: 'Organization.POI',
                group: 1
            },
            {
                depth: '1',
                rootId: '1008938755635040295',
                name: '环境偏好',
                id: '56_7170209078133635',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1500
            },
            {
                depth: '1',
                rootId: '1008938699888549935',
                name: '推荐菜',
                id: '59_7170213153497567',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 900
            },
            {
                depth: '2',
                rootId: '1008936620096786509',
                name: '酸甜',
                id: '63_1031468355141263369',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '2',
                rootId: '1008936699692069011',
                name: '小资 35%',
                id: '16_7170150375843816',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1000
            },
            {
                depth: '2',
                rootId: '1008938067865645135',
                name: '精品烤鸭',
                id: '35_1007587622295445640',
                isleaf: '1',
                type: 'Food.Dish',
                group: 6
            },
            {
                depth: '2',
                rootId: '1008938699888549935',
                name: '菜品不错 10%',
                id: '59_7170213678846807',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1500
            },
            {
                depth: '2',
                rootId: '1008937426439151648',
                name: '河北省:廊坊 1%',
                id: '1_7170128705321547',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1900
            },
            {
                depth: '1',
                rootId: '1008938503825825874',
                name: '标签',
                id: '7170125535440144',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '2',
                rootId: '1008938699888549935',
                name: '土豪 1%',
                id: '59_7170213543081871',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1000
            },
            {
                depth: '2',
                rootId: '1008937201171468320',
                name: '实惠 16%',
                id: '23_7170160245220133',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1000
            },
            {
                depth: '2',
                rootId: '1008938755635040295',
                name: '土豪 2%',
                id: '56_7170209078128034',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1000
            },
            {
                depth: '2',
                rootId: '1008938755635040295',
                name: '干净卫生 13%',
                id: '56_7170209201270665',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1500
            },
            {
                depth: '2',
                rootId: '1008938067865645135',
                name: '广东省:深圳 2%',
                id: '35_7170179615147648',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1900
            },
            {
                depth: '1',
                rootId: '1008938755635040295',
                name: '性别分布',
                id: '56_7170209343916347',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1600
            },
            {
                depth: '2',
                rootId: '1008937099551838291',
                name: '冷面',
                id: '62_1007587636593836140',
                isleaf: '1',
                type: 'Food.Dish',
                group: 6
            },
            {
                depth: '2',
                rootId: '1008938755635040295',
                name: '高档 6%',
                id: '56_7170209078129126',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1000
            },
            {
                depth: '2',
                rootId: '1008937746309345364',
                name: '串串火锅',
                id: '44_1031468354373709860',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '1',
                rootId: '1008937426439151648',
                name: '年龄分布',
                id: '1_7170127691517999',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1700
            },
            {
                depth: '2',
                rootId: '1008938503825825874',
                name: '北京市:北京 96%',
                id: '7170125736893169',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1900
            },
            {
                depth: '2',
                rootId: '1008937426439151648',
                name: '菜品不错 22%',
                id: '1_7170127930871449',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1500
            },
            {
                depth: '2',
                rootId: '1008938755635040295',
                name: '味道赞',
                id: '56_1031468354713464917',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '2',
                rootId: '1008938755635040295',
                name: '男 38%',
                id: '56_7170209343928214',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1600
            },
            {
                depth: '2',
                rootId: '1008936620096786509',
                name: '上海市:上海 1%',
                id: '63_7170219994738098',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1900
            },
            {
                depth: '2',
                rootId: '1008936620096786509',
                name: '土豪 2%',
                id: '63_7170219092239975',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1000
            },
            {
                depth: '2',
                rootId: '1008937746309345364',
                name: '快速方便 20%',
                id: '44_7170191372176634',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1500
            },
            {
                depth: '2',
                rootId: '1008936699692069011',
                name: '35-45岁 36%',
                id: '16_7170150259058217',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1700
            },
            {
                depth: '2',
                rootId: '1008937201171468320',
                name: '渝北烤羊腿',
                id: '23_1007587857562341473',
                isleaf: '1',
                type: 'Food.Dish',
                group: 6
            },
            {
                depth: '2',
                rootId: '1008936197508075588',
                name: '天津市:天津 1%',
                id: '20_7170156848475998',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1900
            },
            {
                depth: '2',
                rootId: '1008939065262755975',
                name: '褡裢火烧',
                id: '26_1044994406525980716',
                isleaf: '1',
                type: 'Food.Dish',
                group: 6
            },
            {
                depth: '2',
                rootId: '1008939065262755975',
                name: '寿司达人 6%',
                id: '26_7170164854490764',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1500
            },
            {
                depth: '2',
                rootId: '1008936197508075588',
                name: '老坛酸菜鱼',
                id: '20_1045506996784095353',
                isleaf: '1',
                type: 'Food.Dish',
                group: 3
            },
            {
                depth: '2',
                rootId: '1008938503825825874',
                name: '16-25岁 3%',
                id: '7170124452982003',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1700
            },
            {
                depth: '1',
                rootId: '1008938755635040295',
                name: '附近餐厅',
                id: '56_7170209810432416',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 2100
            },
            {
                depth: '2',
                rootId: '1008936699692069011',
                name: '鲜香',
                id: '16_1031468354713464923',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '2',
                rootId: '1008938067865645135',
                name: '实惠 6%',
                id: '35_7170178602397169',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1000
            },
            {
                depth: '2',
                rootId: '1008937426439151648',
                name: '有舞台表演 3%',
                id: '1_7170127948608441',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1500
            },
            {
                depth: '2',
                rootId: '1008936261286654001',
                name: '女 64%',
                id: '2_7170129384536673',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1600
            },
            {
                depth: '2',
                rootId: '1008936620096786509',
                name: '服务热情',
                id: '63_1031468354918940782',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '1',
                rootId: '1008937746309345364',
                name: '消费水平分布',
                id: '44_7170191255254078',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1800
            },
            {
                depth: '2',
                rootId: '1008938067865645135',
                name: '糖醋小排',
                id: '35_1007587622266122372',
                isleaf: '1',
                type: 'Food.Dish',
                group: 5
            },
            {
                depth: '2',
                rootId: '1008938699888549935',
                name: '撸串圣地 12%',
                id: '59_7170213672461407',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1500
            },
            {
                depth: '2',
                rootId: '1008938067865645135',
                name: '响油鳝糊',
                id: '35_1007587622266122370',
                isleaf: '1',
                type: 'Food.Dish',
                group: 3
            },
            {
                depth: '2',
                rootId: '1008936197508075588',
                name: '北京市:北京 95%',
                id: '20_7170156848473208',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1900
            },
            {
                depth: '2',
                rootId: '1008938067865645135',
                name: '大煮干丝',
                id: '35_1007587622266122375',
                isleaf: '1',
                type: 'Food.Dish',
                group: 7
            },
            {
                depth: '1',
                rootId: null,
                name: '相似餐厅',
                id: '16_7170150639029821',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 2000
            },
            {
                depth: '1',
                rootId: '1008936699692069011',
                name: '用户常驻城市',
                id: '16_7170151317537643',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1900
            },
            {
                depth: '2',
                rootId: '1008938755635040295',
                name: '女 62%',
                id: '56_7170209343930519',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1600
            },
            {
                depth: '2',
                rootId: '1008936699692069011',
                name: '轻食餐厅 8%',
                id: '16_7170150511345213',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1500
            },
            {
                depth: '2',
                rootId: '1008938503825825874',
                name: '麻辣',
                id: '1031468355271299221',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '2',
                rootId: '1008936699692069011',
                name: '甜味',
                id: '16_1031468355036397670',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '2',
                rootId: '1008937426439151648',
                name: '热奶茶',
                id: '1_1045506553450361013',
                isleaf: '1',
                type: 'Food.Dish',
                group: 3
            },
            {
                depth: '2',
                rootId: '1008936620096786509',
                name: '撸串圣地 14%',
                id: '63_7170219222364605',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1500
            },
            {
                depth: '2',
                rootId: '1008937099551838291',
                name: '35-45岁 36%',
                id: '62_7170217624326530',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1700
            },
            {
                depth: '2',
                rootId: '1008939065262755975',
                name: '三文鱼',
                id: '26_1007587919717761084',
                isleaf: '1',
                type: 'Food.Dish',
                group: 7
            },
            {
                depth: '2',
                rootId: '1008937746309345364',
                name: '味道赞',
                id: '44_1031468354713464917',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '2',
                rootId: '1008938503825825874',
                name: '女 57%',
                id: '7170124835816634',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1600
            },
            {
                depth: '2',
                rootId: '1008937201171468320',
                name: '口水鸡',
                id: '23_1045506902689116299',
                isleaf: '1',
                type: 'Food.Dish',
                group: 5
            },
            {
                depth: '2',
                rootId: '1008936197508075588',
                name: '小资 39%',
                id: '20_7170155908745710',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1000
            },
            {
                depth: '2',
                rootId: '1008936261286654001',
                name: '高档 21%',
                id: '2_7170129120036744',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1000
            },
            {
                depth: '2',
                rootId: '1008937746309345364',
                name: '撸串圣地 14%',
                id: '44_7170191384865061',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1500
            },
            {
                depth: '2',
                rootId: '1008938067865645135',
                name: '俄罗斯风情 18%',
                id: '35_7170178718955452',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1500
            },
            {
                depth: '2',
                rootId: '1008938755635040295',
                name: '撸串圣地 13%',
                id: '56_7170209207298314',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1500
            },
            {
                depth: '2',
                rootId: '1008938755635040295',
                name: '鸡丝凉面',
                id: '56_1007588091872952343',
                isleaf: '1',
                type: 'Food.Dish',
                group: 5
            },
            {
                depth: '2',
                rootId: '1008937099551838291',
                name: '寿司',
                id: '62_1044629450831994950',
                isleaf: '1',
                type: 'Food.Dish',
                group: 4
            },
            {
                depth: '1',
                rootId: '1008938503825825874',
                name: '性别分布',
                id: '7170124835802233',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1600
            },
            {
                depth: '2',
                rootId: '1008936197508075588',
                name: '土豪 2%',
                id: '20_7170155908743009',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1000
            },
            {
                depth: '2',
                rootId: '1008938067865645135',
                name: '16-25岁 4%',
                id: '35_7170178485737220',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1700
            },
            {
                depth: '2',
                rootId: '1008937746309345364',
                name: '男 26%',
                id: '44_7170191518065701',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1600
            },
            {
                depth: '2',
                rootId: '1008938755635040295',
                name: '牛肉面',
                id: '56_1045506931466215486',
                isleaf: '1',
                type: 'Food.Dish',
                group: 7
            },
            {
                depth: '2',
                rootId: '1008938503825825874',
                name: '男 43%',
                id: '7170124835818921',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1600
            },
            {
                depth: '2',
                rootId: '1008936261286654001',
                name: '干净卫生 11%',
                id: '2_7170129249601591',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1500
            },
            {
                depth: '2',
                rootId: '1008936620096786509',
                name: '味道赞',
                id: '63_1031468354713464917',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '2',
                rootId: '1008938503825825874',
                name: '服务热情',
                id: '1031468354918940782',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '2',
                rootId: '1008938755635040295',
                name: '45岁以上 12%',
                id: '56_7170208960354389',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1700
            },
            {
                depth: '2',
                rootId: '1008937746309345364',
                name: '16-25岁 12%',
                id: '44_7170191138934346',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1700
            },
            {
                depth: '1',
                rootId: '1008938755635040295',
                name: '用户常驻城市',
                id: '56_7170210079482772',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1900
            },
            {
                depth: '2',
                rootId: '1008936699692069011',
                name: '亲子餐厅',
                id: '16_1031468354373709875',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '2',
                rootId: '1008937746309345364',
                name: '高档 11%',
                id: '44_7170191255299006',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1000
            },
            {
                depth: '1',
                rootId: '1008937746309345364',
                name: '标签',
                id: '44_7170191996637541',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '2',
                rootId: '1008938503825825874',
                name: '小资 34%',
                id: '7170124569577715',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1000
            },
            {
                depth: '2',
                rootId: '1008936261286654001',
                name: '快速方便 19%',
                id: '2_7170129243551069',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1500
            },
            {
                depth: '2',
                rootId: '1008936197508075588',
                name: '麻辣',
                id: '20_1031468354918940725',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '1',
                rootId: '1008936197508075588',
                name: '标签',
                id: '20_7170156659618694',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '2',
                rootId: '1008938755635040295',
                name: '麻辣',
                id: '56_1031468355271299221',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '2',
                rootId: '1008937099551838291',
                name: '俄罗斯风情 7%',
                id: '62_7170217882983992',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1500
            },
            {
                depth: '2',
                rootId: '1008937099551838291',
                name: '高档 7%',
                id: '62_7170217740682278',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1000
            },
            {
                depth: '1',
                rootId: '1008937426439151648',
                name: '标签',
                id: '1_7170128522789636',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '2',
                rootId: '1008936699692069011',
                name: '土豪 3%',
                id: '16_7170150375840232',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1000
            },
            {
                depth: '2',
                rootId: '1008938699888549935',
                name: '北京市:北京 98%',
                id: '59_7170214405185027',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1900
            },
            {
                depth: '2',
                rootId: '1008938755635040295',
                name: '无辣不欢 9%',
                id: '56_7170209220781902',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1500
            },
            {
                depth: '2',
                rootId: '1008936699692069011',
                name: '鲜香',
                id: '16_1031468355271299196',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '2',
                rootId: '1008938755635040295',
                name: '小吃',
                id: '56_1031468354814115900',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '2',
                rootId: '1008938067865645135',
                name: '上海菜',
                id: '35_1031468354373709834',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '1',
                rootId: '1008939065262755975',
                name: '附近餐厅',
                id: '26_7170165342062421',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 2100
            },
            {
                depth: '1',
                rootId: '1008937746309345364',
                name: '性别分布',
                id: '44_7170191518047285',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1600
            },
            {
                depth: '2',
                rootId: '1008936197508075588',
                name: '上海市:上海 1%',
                id: '20_7170156848476809',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1900
            },
            {
                depth: '2',
                rootId: '1008936699692069011',
                name: '生啫鸡球年糕',
                id: '16_1007587739614331041',
                isleaf: '1',
                type: 'Food.Dish',
                group: 4
            },
            {
                depth: '2',
                rootId: '1008938067865645135',
                name: '广东省:广州 2%',
                id: '35_7170179615148300',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1900
            },
            {
                depth: '1',
                rootId: '1008938699888549935',
                name: '环境偏好',
                id: '59_7170213543084832',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1500
            },
            {
                depth: '2',
                rootId: '1008936699692069011',
                name: '味道赞',
                id: '16_1031468354713464917',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '2',
                rootId: '1008938067865645135',
                name: '土豪 6%',
                id: '35_7170178602395090',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1000
            },
            {
                depth: '2',
                rootId: '1008937099551838291',
                name: '16-25岁 6%',
                id: '62_7170217624327897',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1700
            },
            {
                depth: '2',
                rootId: '1008937746309345364',
                name: '浙江省:杭州 1%',
                id: '44_7170192214975851',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1900
            },
            {
                depth: '2',
                rootId: '1008937201171468320',
                name: '45岁以上 13%',
                id: '23_7170160129272093',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1700
            },
            {
                depth: '2',
                rootId: '1008938699888549935',
                name: '午餐',
                id: '59_1031468354713464875',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '2',
                rootId: '1008938699888549935',
                name: '河北省:廊坊 1%',
                id: '59_7170214405187774',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1900
            },
            {
                depth: '2',
                rootId: '1008937099551838291',
                name: '土豪 2%',
                id: '62_7170217740676740',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1000
            },
            {
                depth: '2',
                rootId: '1008938699888549935',
                name: '重庆老开县冰薄桔红月饼礼盒',
                id: '59_1038831627666481270',
                isleaf: '1',
                type: 'Food.Dish',
                group: 7
            },
            {
                depth: '2',
                rootId: '1008938755635040295',
                name: '酸辣',
                id: '56_1031468355271299238',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '2',
                rootId: '1008938067865645135',
                name: '服务热情',
                id: '35_1031468354918940782',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '2',
                rootId: '1008936699692069011',
                name: '无辣不欢 9%',
                id: '16_7170150505371746',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1500
            },
            {
                depth: '2',
                rootId: '1008936261286654001',
                name: '味道赞',
                id: '2_1031468354713464917',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '2',
                rootId: '1008939065262755975',
                name: '16-25岁 10%',
                id: '26_7170164603264265',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1700
            },
            {
                depth: '1',
                rootId: '1008936699692069011',
                name: '推荐菜',
                id: '16_7170149789481645',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 900
            },
            {
                depth: '2',
                rootId: '1008939065262755975',
                name: '35-45岁 27%',
                id: '26_7170164603272091',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1700
            },
            {
                depth: '2',
                rootId: '1008939065262755975',
                name: '上海市:上海 6%',
                id: '26_7170165642219211',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1900
            },
            {
                depth: '1',
                rootId: '1008937201171468320',
                name: '推荐菜',
                id: '23_7170159787941736',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 900
            },
            {
                depth: '1',
                rootId: '1008936261286654001',
                name: '年龄分布',
                id: '2_7170129003957886',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1700
            },
            {
                depth: '2',
                rootId: '1008938067865645135',
                name: '25-35岁 33%',
                id: '35_7170178485729410',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1700
            },
            {
                depth: '1',
                rootId: '1008938699888549935',
                name: '性别分布',
                id: '59_7170213807820625',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1600
            },
            {
                depth: '2',
                rootId: '1008936261286654001',
                name: '实惠 7%',
                id: '2_7170129120037640',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1000
            },
            {
                depth: '2',
                rootId: '1008939065262755975',
                name: '广东省:深圳 2%',
                id: '26_7170165642220339',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1900
            },
            {
                depth: '2',
                rootId: '1008937746309345364',
                name: '重庆小酥肉',
                id: '44_1007588129957249166',
                isleaf: '1',
                type: 'Food.Dish',
                group: 7
            },
            {
                depth: '2',
                rootId: '1008937746309345364',
                name: '红糖糍粑',
                id: '44_1007588129957249165',
                isleaf: '1',
                type: 'Food.Dish',
                group: 4
            },
            {
                depth: '2',
                rootId: '1008938067865645135',
                name: '高档 12%',
                id: '35_7170178602398222',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1000
            },
            {
                depth: '2',
                rootId: '1008937201171468320',
                name: '老字号 8%',
                id: '23_7170160386363786',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1500
            },
            {
                depth: '2',
                rootId: '1008938699888549935',
                name: '酸甜',
                id: '59_1031468355141263369',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '2',
                rootId: '1008937746309345364',
                name: '成都串串香',
                id: '44_1007588129957249164',
                isleaf: '1',
                type: 'Food.Dish',
                group: 6
            },
            {
                depth: '2',
                rootId: '1008936261286654001',
                name: '家常菜',
                id: '2_1031468354814115896',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '2',
                rootId: '1008936197508075588',
                name: '毛血旺迷你',
                id: '20_1022524990899118132',
                isleaf: '1',
                type: 'Food.Dish',
                group: 5
            },
            {
                depth: '2',
                rootId: '1008937746309345364',
                name: '北京市:北京 97%',
                id: '44_7170192214972212',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1900
            },
            {
                depth: '2',
                rootId: '1008939065262755975',
                name: '小资 38%',
                id: '26_7170164719929421',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1000
            },
            {
                depth: '2',
                rootId: '1008937099551838291',
                name: '五花肉',
                id: '62_1007587636593836138',
                isleaf: '1',
                type: 'Food.Dish',
                group: 7
            },
            {
                depth: '2',
                rootId: '1008937099551838291',
                name: '羊肉串',
                id: '62_1007587636593836137',
                isleaf: '1',
                type: 'Food.Dish',
                group: 5
            },
            {
                depth: '1',
                rootId: '1008938067865645135',
                name: '推荐菜',
                id: '35_7170178191640425',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 900
            },
            {
                depth: '2',
                rootId: '1008937426439151648',
                name: '名厨掌勺 44%',
                id: '1_7170127924206360',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1500
            },
            {
                depth: '2',
                rootId: '1008938067865645135',
                name: '菜品不错',
                id: '35_1031468355271299158',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '2',
                rootId: '1008937099551838291',
                name: '南瓜粥',
                id: '62_1007587636593836133',
                isleaf: '1',
                type: 'Food.Dish',
                group: 3
            },
            {
                depth: '2',
                rootId: '1008936699692069011',
                name: '老字号 7%',
                id: '16_7170150516648410',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1500
            },
            {
                depth: '2',
                rootId: '1008937426439151648',
                name: '小资 44%',
                id: '1_7170127807953651',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1000
            },
            {
                depth: '2',
                rootId: '1008936197508075588',
                name: '朋友聚餐',
                id: '20_1031468354918940778',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '2',
                rootId: '1008936620096786509',
                name: '女 71%',
                id: '63_7170219358265151',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1600
            },
            {
                depth: '1',
                rootId: '1008939065262755975',
                name: '年龄分布',
                id: '26_7170164603221279',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1700
            },
            {
                depth: '2',
                rootId: '1008937201171468320',
                name: '小资 33%',
                id: '23_7170160245217232',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1000
            },
            {
                depth: '2',
                rootId: '1008936197508075588',
                name: '金牌水煮鱼',
                id: '20_1012385915978407980',
                isleaf: '1',
                type: 'Food.Dish',
                group: 4
            },
            {
                depth: '1',
                rootId: '1008937201171468320',
                name: '性别分布',
                id: '23_7170160507997879',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1600
            },
            {
                depth: '2',
                rootId: '1008938067865645135',
                name: '味道赞',
                id: '35_1031468354713464917',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '2',
                rootId: '1008938755635040295',
                name: '菜品不错 9%',
                id: '56_7170209212968085',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1500
            },
            {
                depth: '1',
                rootId: null,
                name: '相似餐厅',
                id: '62_7170218005839828',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 2000
            },
            {
                depth: '2',
                rootId: '1008938699888549935',
                name: '奶茶',
                id: '59_1044994417854779502',
                isleaf: '1',
                type: 'Food.Dish',
                group: 6
            },
            {
                depth: '2',
                rootId: '1008937099551838291',
                name: '男 43%',
                id: '62_7170218005837407',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1600
            },
            {
                depth: '2',
                rootId: '1008936197508075588',
                name: '女 64%',
                id: '20_7170156174794721',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1600
            },
            {
                depth: '2',
                rootId: '1008937426439151648',
                name: '服务热情',
                id: '1_1031468354918940782',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '2',
                rootId: '1008939065262755975',
                name: '紫薯烤鸭',
                id: '26_1007587919747088440',
                isleaf: '1',
                type: 'Food.Dish',
                group: 5
            },
            {
                depth: '2',
                rootId: '1008939065262755975',
                name: '男 57%',
                id: '26_7170164983922567',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1600
            },
            {
                depth: '2',
                rootId: '1008938699888549935',
                name: '小资 35%',
                id: '59_7170213543082683',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1000
            },
            {
                depth: '1',
                rootId: null,
                name: '相似餐厅',
                id: '63_7170219358269754',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 2000
            },
            {
                depth: '1',
                rootId: '1008937746309345364',
                name: '用户常驻城市',
                id: '44_7170192214952245',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1900
            },
            {
                depth: '2',
                rootId: '1008937426439151648',
                name: '男 49%',
                id: '1_7170128072346183',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1600
            },
            {
                depth: '2',
                rootId: '1008938755635040295',
                name: '快速方便 27%',
                id: '56_7170209194407749',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1500
            },
            {
                depth: '2',
                rootId: '1008937201171468320',
                name: '35-45岁 25%',
                id: '23_7170160129264878',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1700
            },
            {
                depth: '1',
                rootId: '1008939065262755975',
                name: '用户常驻城市',
                id: '26_7170165642196642',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1900
            },
            {
                depth: '1',
                rootId: '1008938699888549935',
                name: '标签',
                id: '59_7170214224603247',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '2',
                rootId: '1008936197508075588',
                name: '无辣不欢 25%',
                id: '20_7170156025311382',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1500
            },
            {
                depth: '2',
                rootId: '1008937746309345364',
                name: '干净卫生 8%',
                id: '44_7170191390186656',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1500
            },
            {
                depth: '1',
                rootId: '1008938067865645135',
                name: '年龄分布',
                id: '35_7170178485688852',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1700
            },
            {
                depth: '2',
                rootId: '1008938699888549935',
                name: '实惠 17%',
                id: '59_7170213543081002',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1000
            },
            {
                depth: '1',
                rootId: null,
                name: '相似餐厅',
                id: '20_7170156174802430',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 2000
            },
            {
                depth: '1',
                rootId: '1008937201171468320',
                name: '用户常驻城市',
                id: '23_7170161227292612',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1900
            },
            {
                depth: '2',
                rootId: '1008937201171468320',
                name: '高档 5%',
                id: '23_7170160245218422',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1000
            },
            {
                depth: '2',
                rootId: '1008938503825825874',
                name: '上海市:上海 2%',
                id: '7170125736895710',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1900
            },
            {
                depth: '2',
                rootId: '1008936699692069011',
                name: '16-25岁 9%',
                id: '16_7170150259062085',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1700
            },
            {
                depth: '1',
                rootId: '1008936620096786509',
                name: '消费水平分布',
                id: '63_7170219092205894',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1800
            },
            {
                depth: '2',
                rootId: '1008937746309345364',
                name: '麻辣',
                id: '44_1031468355271299221',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '2',
                rootId: '1008936620096786509',
                name: '花先生口水鸡',
                id: '63_1045506921651560632',
                isleaf: '1',
                type: 'Food.Dish',
                group: 4
            },
            {
                depth: '2',
                rootId: '1008938699888549935',
                name: '快速方便 22%',
                id: '59_7170213658977775',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1500
            },
            {
                depth: '2',
                rootId: '1008939065262755975',
                name: '北京市:北京 83%',
                id: '26_7170165642216428',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1900
            },
            {
                depth: '2',
                rootId: '1008937746309345364',
                name: '小龙虾',
                id: '44_1044994349743493269',
                isleaf: '1',
                type: 'Food.Dish',
                group: 5
            },
            {
                depth: '1',
                rootId: '1008938067865645135',
                name: '用户常驻城市',
                id: '35_7170179615127611',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1900
            },
            {
                depth: '1',
                rootId: '1008937099551838291',
                name: '附近餐厅',
                id: '62_7170218397963902',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 2100
            },
            {
                depth: '1',
                rootId: '1008937099551838291',
                name: '消费水平分布',
                id: '62_7170217740642046',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1800
            },
            {
                depth: '1',
                rootId: null,
                name: '相似餐厅',
                id: '1_7170128072353815',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 2000
            },
            {
                depth: '2',
                rootId: '1008936197508075588',
                name: '普通 38%',
                id: '20_7170155908746784',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1000
            },
            {
                depth: '2',
                rootId: '1008938755635040295',
                name: '老红糖醪糟炖黑芝麻汤圆',
                id: '56_1011842175962480710',
                isleaf: '1',
                type: 'Food.Dish',
                group: 4
            },
            {
                depth: '1',
                rootId: '1008936620096786509',
                name: '推荐菜',
                id: '63_7170218671985479',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 900
            },
            {
                depth: '2',
                rootId: '1008936620096786509',
                name: '夫妻肺片',
                id: '63_1007588082242830392',
                isleaf: '1',
                type: 'Food.Dish',
                group: 5
            },
            {
                depth: '1',
                rootId: null,
                name: '相似餐厅',
                id: '26_7170164983931250',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 2000
            },
            {
                depth: '2',
                rootId: '1008937201171468320',
                name: '北京市:北京 98%',
                id: '23_7170161227312998',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1900
            },
            {
                depth: '2',
                rootId: '1008938503825825874',
                name: '45岁以上 21%',
                id: '7170124452985475',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1700
            },
            {
                depth: '2',
                rootId: '1008936699692069011',
                name: '45岁以上 15%',
                id: '16_7170150259066696',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1700
            },
            {
                depth: '2',
                rootId: '1008936197508075588',
                name: '服务热情',
                id: '20_1031468354918940782',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '1',
                rootId: '1008937099551838291',
                name: '推荐菜',
                id: '62_7170217272356881',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 900
            },
            {
                depth: '2',
                rootId: '1008937099551838291',
                name: '45岁以上 14%',
                id: '62_7170217624330188',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1700
            },
            {
                depth: '2',
                rootId: '1008936620096786509',
                name: '16-25岁 6%',
                id: '63_7170218975710744',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1700
            },
            {
                depth: '2',
                rootId: '1008936261286654001',
                name: '16-25岁 9%',
                id: '2_7170129004015036',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1700
            },
            {
                depth: '2',
                rootId: '1008936197508075588',
                name: '弄堂小店 7%',
                id: '20_7170156051812429',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1500
            },
            {
                depth: '2',
                rootId: '1008938755635040295',
                name: '35-45岁 36%',
                id: '56_7170208960347459',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1700
            },
            {
                depth: '2',
                rootId: '1008936261286654001',
                name: '男 36%',
                id: '2_7170129384538914',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1600
            },
            {
                depth: '2',
                rootId: '1008937201171468320',
                name: '快速方便 26%',
                id: '23_7170160361309599',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1500
            },
            {
                depth: '1',
                rootId: '1008938503825825874',
                name: '附近餐厅',
                id: '7170125435697864',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 2100
            },
            {
                depth: '2',
                rootId: '1008936699692069011',
                name: '快速方便 28%',
                id: '16_7170150492339582',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1500
            },
            {
                depth: '2',
                rootId: '1008938699888549935',
                name: '男 27%',
                id: '59_7170213807833639',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1600
            },
            {
                depth: '2',
                rootId: '1008936620096786509',
                name: '小资 28%',
                id: '63_7170219092241845',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1000
            },
            {
                depth: '2',
                rootId: '1008936197508075588',
                name: '实惠 12%',
                id: '20_7170155908748420',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1000
            },
            {
                depth: '2',
                rootId: '1008937201171468320',
                name: '干净卫生 11%',
                id: '23_7170160374768238',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1500
            },
            {
                depth: '2',
                rootId: '1008936197508075588',
                name: '撸串圣地 12%',
                id: '20_7170156045855462',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1500
            },
            {
                depth: '2',
                rootId: '1008937099551838291',
                name: '有酒有肉 24%',
                id: '62_7170217857039689',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1500
            },
            {
                depth: '0',
                rootId: '1008936699692069011',
                name: '日昌餐馆（五道口店）',
                id: '1008936699692069011',
                isleaf: '0',
                type: 'Organization.POI',
                group: 1
            },
            {
                depth: '1',
                rootId: '1008936620096786509',
                name: '标签',
                id: '63_7170219819094440',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '1',
                rootId: '1008936197508075588',
                name: '附近餐厅',
                id: '20_7170156563536369',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 2100
            },
            {
                depth: '1',
                rootId: '1008936261286654001',
                name: '环境偏好',
                id: '2_7170129120047930',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1500
            },
            {
                depth: '2',
                rootId: '1008938503825825874',
                name: '广东省:深圳 1%',
                id: '7170125736896757',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1900
            },
            {
                depth: '1',
                rootId: '1008937201171468320',
                name: '标签',
                id: '23_7170161044377737',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '2',
                rootId: '1008937201171468320',
                name: '25-35岁 48%',
                id: '23_7170160129270280',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1700
            },
            {
                depth: '2',
                rootId: '1008939065262755975',
                name: '女 43%',
                id: '26_7170164983920199',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1600
            },
            {
                depth: '1',
                rootId: null,
                name: '相似餐厅',
                id: '59_7170213807840052',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 2000
            },
            {
                depth: '2',
                rootId: '1008938067865645135',
                name: '男 26%',
                id: '35_7170178868949479',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1600
            },
            {
                depth: '0',
                rootId: '1008939065262755975',
                name: '那家小馆（中关村店）',
                id: '1008939065262755975',
                isleaf: '0',
                type: 'Organization.POI',
                group: 1
            },
            {
                depth: '2',
                rootId: '1008937201171468320',
                name: '水煮鱼',
                id: '23_1007587857545568482',
                isleaf: '1',
                type: 'Food.Dish',
                group: 3
            },
            {
                depth: '2',
                rootId: '1008938699888549935',
                name: '服务热情',
                id: '59_1031468354918940782',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '2',
                rootId: '1008936197508075588',
                name: '味道赞',
                id: '20_1031468354713464917',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '1',
                rootId: '1008938755635040295',
                name: '年龄分布',
                id: '56_7170208960309322',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1700
            },
            {
                depth: '2',
                rootId: '1008937746309345364',
                name: '45岁以上 8%',
                id: '44_7170191138932213',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1700
            },
            {
                depth: '2',
                rootId: '1008936620096786509',
                name: '菜品不错',
                id: '63_1031468355271299158',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '2',
                rootId: '1008936620096786509',
                name: '酸菜小鱼',
                id: '63_1007588082230251687',
                isleaf: '1',
                type: 'Food.Dish',
                group: 3
            },
            {
                depth: '2',
                rootId: '1008936261286654001',
                name: '北京市:北京 96%',
                id: '2_7170130131590673',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1900
            },
            {
                depth: '2',
                rootId: '1008936261286654001',
                name: '35-45岁 41%',
                id: '2_7170129004017515',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1700
            },
            {
                depth: '2',
                rootId: '1008937201171468320',
                name: '火锅',
                id: '23_1007587857545568487',
                isleaf: '1',
                type: 'Food.Dish',
                group: 7
            },
            {
                depth: '1',
                rootId: null,
                name: '相似餐厅',
                id: '56_7170209343933270',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 2000
            },
            {
                depth: '2',
                rootId: '1008936620096786509',
                name: '快速方便 18%',
                id: '63_7170219215818122',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1500
            },
            {
                depth: '1',
                rootId: '1008936197508075588',
                name: '年龄分布',
                id: '20_7170155792041053',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1700
            },
            {
                depth: '2',
                rootId: '1008937746309345364',
                name: '奶茶',
                id: '44_1044994349743493226',
                isleaf: '1',
                type: 'Food.Dish',
                group: 3
            },
            {
                depth: '2',
                rootId: '1008936197508075588',
                name: '16-25岁 10%',
                id: '20_7170155792081704',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1700
            },
            {
                depth: '2',
                rootId: '1008936699692069011',
                name: '菠萝油',
                id: '16_1044994158265151553',
                isleaf: '1',
                type: 'Food.Dish',
                group: 5
            },
            {
                depth: '2',
                rootId: '1008936261286654001',
                name: '小资 34%',
                id: '2_7170129120033683',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1000
            },
            {
                depth: '0',
                rootId: '1008937746309345364',
                name: '付小姐在成都（六道口店）',
                id: '1008937746309345364',
                isleaf: '0',
                type: 'Organization.POI',
                group: 1
            },
            {
                depth: '2',
                rootId: '1008938699888549935',
                name: '味道赞',
                id: '59_1031468354713464917',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '2',
                rootId: '1008936620096786509',
                name: '男 29%',
                id: '63_7170219358267475',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1600
            },
            {
                depth: '2',
                rootId: '1008936620096786509',
                name: '花花的口水鸡',
                id: '63_1007588082230251677',
                isleaf: '1',
                type: 'Food.Dish',
                group: 6
            },
            {
                depth: '1',
                rootId: '1008936699692069011',
                name: '附近餐厅',
                id: '16_7170151037294285',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 2100
            },
            {
                depth: '2',
                rootId: '1008937746309345364',
                name: '女 74%',
                id: '44_7170191518068229',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1600
            },
            {
                depth: '2',
                rootId: '1008936620096786509',
                name: '干净卫生 10%',
                id: '63_7170219235782379',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1500
            },
            {
                depth: '2',
                rootId: '1008936197508075588',
                name: '高档 9%',
                id: '20_7170155908747656',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1000
            },
            {
                depth: '2',
                rootId: '1008938067865645135',
                name: '高逼格自助餐 9%',
                id: '35_7170178746287137',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1500
            },
            {
                depth: '2',
                rootId: '1008937746309345364',
                name: '无辣不欢 16%',
                id: '44_7170191379329173',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1500
            },
            {
                depth: '2',
                rootId: '1008937746309345364',
                name: '普通 39%',
                id: '44_7170191255290612',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1000
            },
            {
                depth: '1',
                rootId: '1008937426439151648',
                name: '用户常驻城市',
                id: '1_7170128705298856',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1900
            },
            {
                depth: '2',
                rootId: '1008939065262755975',
                name: '撸串圣地 8%',
                id: '26_7170164848927212',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1500
            },
            {
                depth: '2',
                rootId: '1008936261286654001',
                name: '25-35岁 23%',
                id: '2_7170129003997355',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1700
            },
            {
                depth: '2',
                rootId: '1008936197508075588',
                name: '快速方便 12%',
                id: '20_7170156039572736',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1500
            },
            {
                depth: '1',
                rootId: '1008936197508075588',
                name: '推荐菜',
                id: '20_7170155476978995',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 900
            },
            {
                depth: '2',
                rootId: '1008937099551838291',
                name: '女 57%',
                id: '62_7170218005834461',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1600
            },
            {
                depth: '2',
                rootId: '1008936620096786509',
                name: '实惠 26%',
                id: '63_7170219092237258',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1000
            },
            {
                depth: '2',
                rootId: '1008937746309345364',
                name: '25-35岁 51%',
                id: '44_7170191138935820',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1700
            },
            {
                depth: '2',
                rootId: '1008937426439151648',
                name: '上海市:上海 1%',
                id: '1_7170128705320700',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1900
            },
            {
                depth: '2',
                rootId: '1008939065262755975',
                name: '天津市:天津 1%',
                id: '26_7170165642221938',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1900
            },
            {
                depth: '2',
                rootId: '1008939065262755975',
                name: '菜品不错 27%',
                id: '26_7170164836312800',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1500
            },
            {
                depth: '2',
                rootId: '1008937746309345364',
                name: '土豪 3%',
                id: '44_7170191255297495',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1000
            },
            {
                depth: '2',
                rootId: '1008937099551838291',
                name: '菜品不错 18%',
                id: '62_7170217863579699',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1500
            },
            {
                depth: '2',
                rootId: '1008937746309345364',
                name: '小资 38%',
                id: '44_7170191255300871',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1000
            },
            {
                depth: '2',
                rootId: '1008936699692069011',
                name: '粽子',
                id: '16_1044629631971401842',
                isleaf: '1',
                type: 'Food.Dish',
                group: 3
            },
            {
                depth: '2',
                rootId: '1008936620096786509',
                name: '麻辣',
                id: '63_1031468355271299221',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '2',
                rootId: '1008937099551838291',
                name: '实惠 14%',
                id: '62_7170217740679630',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1000
            },
            {
                depth: '2',
                rootId: '1008936197508075588',
                name: '男 36%',
                id: '20_7170156174796980',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1600
            },
            {
                depth: '2',
                rootId: '1008936261286654001',
                name: '红烧带鱼',
                id: '2_1007587991058653313',
                isleaf: '1',
                type: 'Food.Dish',
                group: 7
            },
            {
                depth: '1',
                rootId: '1008936620096786509',
                name: '性别分布',
                id: '63_7170219358252473',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1600
            },
            {
                depth: '2',
                rootId: '1008936699692069011',
                name: '鸭血粉丝汤',
                id: '16_1007587739576611034',
                isleaf: '1',
                type: 'Food.Dish',
                group: 7
            },
            {
                depth: '2',
                rootId: '1008936197508075588',
                name: '麻辣',
                id: '20_1031468355367760011',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '2',
                rootId: '1008936620096786509',
                name: '北京市:北京 98%',
                id: '63_7170219994735013',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1900
            },
            {
                depth: '1',
                rootId: '1008937426439151648',
                name: '环境偏好',
                id: '1_7170127807963612',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1500
            },
            {
                depth: '2',
                rootId: '1008936620096786509',
                name: '菜品不错 12%',
                id: '63_7170219229437965',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1500
            },
            {
                depth: '1',
                rootId: '1008936261286654001',
                name: '消费水平分布',
                id: '2_7170129119989598',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1800
            },
            {
                depth: '2',
                rootId: '1008938755635040295',
                name: '小资 26%',
                id: '56_7170209078130929',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1000
            },
            {
                depth: '1',
                rootId: '1008936261286654001',
                name: '附近餐厅',
                id: '2_7170129881203058',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 2100
            },
            {
                depth: '1',
                rootId: '1008938699888549935',
                name: '附近餐厅',
                id: '59_7170214145202106',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 2100
            },
            {
                depth: '1',
                rootId: '1008937099551838291',
                name: '性别分布',
                id: '62_7170218005821691',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1600
            },
            {
                depth: '2',
                rootId: '1008937426439151648',
                name: '16-25岁 8%',
                id: '1_7170127691562568',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1700
            },
            {
                depth: '2',
                rootId: '1008936261286654001',
                name: '京酱肉丝',
                id: '2_1007587991058653306',
                isleaf: '1',
                type: 'Food.Dish',
                group: 4
            },
            {
                depth: '2',
                rootId: '1008936261286654001',
                name: '酸菜鱼',
                id: '2_1007587991058653307',
                isleaf: '1',
                type: 'Food.Dish',
                group: 3
            },
            {
                depth: '1',
                rootId: '1008937099551838291',
                name: '年龄分布',
                id: '62_7170217624284256',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1700
            },
            {
                depth: '2',
                rootId: '1008936261286654001',
                name: '筋头巴脑一锅鲜',
                id: '2_1007587991058653305',
                isleaf: '1',
                type: 'Food.Dish',
                group: 5
            },
            {
                depth: '2',
                rootId: '1008936261286654001',
                name: '鱼头泡饼',
                id: '2_1007587991058653303',
                isleaf: '1',
                type: 'Food.Dish',
                group: 6
            },
            {
                depth: '2',
                rootId: '1008936699692069011',
                name: '25-35岁 40%',
                id: '16_7170150259064697',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1700
            },
            {
                depth: '2',
                rootId: '1008937099551838291',
                name: '25-35岁 44%',
                id: '62_7170217624322879',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1700
            },
            {
                depth: '2',
                rootId: '1008938699888549935',
                name: '无辣不欢 20%',
                id: '59_7170213665792651',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1500
            },
            {
                depth: '2',
                rootId: '1008937201171468320',
                name: '服务热情',
                id: '23_1031468354918940782',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '1',
                rootId: '1008936699692069011',
                name: '消费水平分布',
                id: '16_7170150375810691',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1800
            },
            {
                depth: '1',
                rootId: '1008937746309345364',
                name: '附近餐厅',
                id: '44_7170191909356591',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 2100
            },
            {
                depth: '2',
                rootId: '1008938699888549935',
                name: '16-25岁 7%',
                id: '59_7170213427102839',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1700
            },
            {
                depth: '2',
                rootId: '1008938755635040295',
                name: '普通 44%',
                id: '56_7170209078129931',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1000
            },
            {
                depth: '2',
                rootId: '1008937426439151648',
                name: '35-45岁 31%',
                id: '1_7170127691563785',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1700
            },
            {
                depth: '1',
                rootId: '1008938503825825874',
                name: '消费水平分布',
                id: '7170124569542065',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1800
            },
            {
                depth: '1',
                rootId: '1008938503825825874',
                name: '年龄分布',
                id: '7170124452939814',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1700
            },
            {
                depth: '0',
                rootId: '1008938067865645135',
                name: '悦府.夜上海',
                id: '1008938067865645135',
                isleaf: '0',
                type: 'Organization.POI',
                group: 1
            },
            {
                depth: '1',
                rootId: '1008939065262755975',
                name: '推荐菜',
                id: '26_7170164292344174',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 900
            },
            {
                depth: '1',
                rootId: '1008937426439151648',
                name: '附近餐厅',
                id: '1_7170128443777671',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 2100
            },
            {
                depth: '2',
                rootId: '1008937426439151648',
                name: '名厨掌勺',
                id: '1_1031468354713464911',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '2',
                rootId: '1008937426439151648',
                name: '味道赞',
                id: '1_1031468354713464917',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '2',
                rootId: '1008938755635040295',
                name: '担担面',
                id: '56_1007588091856199783',
                isleaf: '1',
                type: 'Food.Dish',
                group: 6
            },
            {
                depth: '1',
                rootId: null,
                name: '相似餐厅',
                id: '44_7170191518076457',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 2000
            },
            {
                depth: '2',
                rootId: '1008939065262755975',
                name: '密制猪蹄',
                id: '26_1045506971014303876',
                isleaf: '1',
                type: 'Food.Dish',
                group: 4
            },
            {
                depth: '2',
                rootId: '1008938755635040295',
                name: '北京市:北京 100%',
                id: '56_7170210079502327',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1900
            },
            {
                depth: '2',
                rootId: '1008937746309345364',
                name: '麻辣',
                id: '44_1031468354918940725',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '1',
                rootId: '1008937426439151648',
                name: '推荐菜',
                id: '1_7170127365419287',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 900
            },
            {
                depth: '2',
                rootId: '1008939065262755975',
                name: '味道赞',
                id: '26_1031468354713464917',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '2',
                rootId: '1008936197508075588',
                name: '广东省:深圳 1%',
                id: '20_7170156848477485',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1900
            },
            {
                depth: '2',
                rootId: '1008937426439151648',
                name: '北京市:北京 96%',
                id: '1_7170128705317972',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1900
            },
            {
                depth: '2',
                rootId: '1008938067865645135',
                name: '35-45岁 33%',
                id: '35_7170178485733254',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1700
            },
            {
                depth: '2',
                rootId: '1008937426439151648',
                name: '亲子餐厅',
                id: '1_1031468354373709875',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '1',
                rootId: '1008938699888549935',
                name: '消费水平分布',
                id: '59_7170213543043705',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1800
            },
            {
                depth: '2',
                rootId: '1008937426439151648',
                name: '烤鸭',
                id: '1_1044994313508937815',
                isleaf: '1',
                type: 'Food.Dish',
                group: 7
            },
            {
                depth: '1',
                rootId: '1008938067865645135',
                name: '标签',
                id: '35_7170179435280162',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '2',
                rootId: '1008939065262755975',
                name: '高档 12%',
                id: '26_7170164719935613',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1000
            },
            {
                depth: '2',
                rootId: '1008939065262755975',
                name: '土豪 5%',
                id: '26_7170164719932467',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1000
            },
            {
                depth: '2',
                rootId: '1008938503825825874',
                name: '实惠 16%',
                id: '7170124569583520',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1000
            },
            {
                depth: '1',
                rootId: '1008938067865645135',
                name: '附近餐厅',
                id: '35_7170179354921533',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 2100
            },
            {
                depth: '0',
                rootId: '1008936620096786509',
                name: '渝是乎酸菜小鱼（天通苑华联店）',
                id: '1008936620096786509',
                isleaf: '0',
                type: 'Organization.POI',
                group: 1
            },
            {
                depth: '2',
                rootId: '1008936261286654001',
                name: '菜品不错 9%',
                id: '2_7170129262606110',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1500
            },
            {
                depth: '2',
                rootId: '1008939065262755975',
                name: '无辣不欢 5%',
                id: '26_7170164861464933',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1500
            },
            {
                depth: '2',
                rootId: '1008936699692069011',
                name: '女 66%',
                id: '16_7170150639021599',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1600
            },
            {
                depth: '2',
                rootId: '1008936620096786509',
                name: '45岁以上 15%',
                id: '63_7170218975707189',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1700
            },
            {
                depth: '2',
                rootId: '1008937426439151648',
                name: '25-35岁 53%',
                id: '1_7170127691561026',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1700
            },
            {
                depth: '2',
                rootId: '1008937099551838291',
                name: '普通 35%',
                id: '62_7170217740680666',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1000
            },
            {
                depth: '2',
                rootId: '1008937099551838291',
                name: '味道赞',
                id: '62_1031468354713464917',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '2',
                rootId: '1008938067865645135',
                name: '上海市:上海 2%',
                id: '35_7170179615149182',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1900
            },
            {
                depth: '2',
                rootId: '1008936197508075588',
                name: '菜品不错 13%',
                id: '20_7170156032580016',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1500
            },
            {
                depth: '2',
                rootId: '1008937201171468320',
                name: '川菜',
                id: '23_1031468354814115910',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '1',
                rootId: '1008937426439151648',
                name: '消费水平分布',
                id: '1_7170127807913560',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1800
            },
            {
                depth: '1',
                rootId: '1008937746309345364',
                name: '推荐菜',
                id: '44_7170190823572909',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 900
            },
            {
                depth: '1',
                rootId: '1008936699692069011',
                name: '年龄分布',
                id: '16_7170150259020658',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1700
            },
            {
                depth: '2',
                rootId: '1008938503825825874',
                name: '酸辣粉',
                id: '1007588332416315540',
                isleaf: '1',
                type: 'Food.Dish',
                group: 3
            },
            {
                depth: '2',
                rootId: '1008936620096786509',
                name: '25-35岁 47%',
                id: '63_7170218975709374',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1700
            },
            {
                depth: '2',
                rootId: '1008938067865645135',
                name: '菜品不错 11%',
                id: '35_7170178727160612',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1500
            },
            {
                depth: '2',
                rootId: '1008936620096786509',
                name: '普通 38%',
                id: '63_7170219092242770',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1000
            },
            {
                depth: '1',
                rootId: '1008938067865645135',
                name: '环境偏好',
                id: '35_7170178602405385',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1500
            },
            {
                depth: '2',
                rootId: '1008937201171468320',
                name: '男 28%',
                id: '23_7170160508017105',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1600
            },
            {
                depth: '2',
                rootId: '1008937426439151648',
                name: '土豪 5%',
                id: '1_7170127807955068',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1000
            },
            {
                depth: '1',
                rootId: null,
                name: '相似餐厅',
                id: '23_7170160508026063',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 2000
            },
            {
                depth: '0',
                rootId: '1008938503825825874',
                name: '眉州东坡酒楼（民族园店）',
                id: '1008938503825825874',
                isleaf: '0',
                type: 'Organization.POI',
                group: 1
            },
            {
                depth: '2',
                rootId: '1008937746309345364',
                name: '高人气',
                id: '44_1031468355367759987',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '2',
                rootId: '1008939065262755975',
                name: '45岁以上 9%',
                id: '26_7170164603269486',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1700
            },
            {
                depth: '2',
                rootId: '1008937426439151648',
                name: '高档 15%',
                id: '1_7170127807957009',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1000
            },
            {
                depth: '1',
                rootId: '1008936197508075588',
                name: '用户常驻城市',
                id: '20_7170156848447948',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1900
            },
            {
                depth: '1',
                rootId: '1008936699692069011',
                name: '性别分布',
                id: '16_7170150638998444',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1600
            },
            {
                depth: '2',
                rootId: '1008937746309345364',
                name: '轻食餐厅 8%',
                id: '44_7170191395562610',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1500
            },
            {
                depth: '1',
                rootId: '1008938067865645135',
                name: '消费水平分布',
                id: '35_7170178602360319',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1800
            },
            {
                depth: '2',
                rootId: '1008936699692069011',
                name: '男 34%',
                id: '16_7170150639019015',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1600
            },
            {
                depth: '2',
                rootId: '1008937099551838291',
                name: '小资 42%',
                id: '62_7170217740681531',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1000
            },
            {
                depth: '2',
                rootId: '1008937099551838291',
                name: '撸串圣地 13%',
                id: '62_7170217869514897',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1500
            },
            {
                depth: '2',
                rootId: '1008938503825825874',
                name: '菜品不错 24%',
                id: '7170124686361990',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1500
            },
            {
                depth: '2',
                rootId: '1008938067865645135',
                name: '普通 31%',
                id: '35_7170178602392113',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1000
            },
            {
                depth: '2',
                rootId: '1008938755635040295',
                name: '馄饨',
                id: '56_1044994293804048532',
                isleaf: '1',
                type: 'Food.Dish',
                group: 3
            },
            {
                depth: '2',
                rootId: '1008937426439151648',
                name: '实惠 8%',
                id: '1_7170127807950725',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1000
            },
            {
                depth: '1',
                rootId: '1008938755635040295',
                name: '推荐菜',
                id: '56_7170208696193453',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 900
            },
            {
                depth: '2',
                rootId: '1008938755635040295',
                name: '实惠 22%',
                id: '56_7170209078125309',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1000
            },
            {
                depth: '1',
                rootId: '1008936699692069011',
                name: '标签',
                id: '16_7170151122472186',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '1',
                rootId: '1008936620096786509',
                name: '用户常驻城市',
                id: '63_7170219994715468',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1900
            },
            {
                depth: '1',
                rootId: '1008936620096786509',
                name: '附近餐厅',
                id: '63_7170219730447621',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 2100
            },
            {
                depth: '1',
                rootId: '1008938503825825874',
                name: '环境偏好',
                id: '7170124569589030',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1500
            },
            {
                depth: '2',
                rootId: '1008937201171468320',
                name: '火锅',
                id: '23_1031468355036397629',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '2',
                rootId: '1008936261286654001',
                name: '45岁以上 27%',
                id: '2_7170129004019448',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1700
            },
            {
                depth: '2',
                rootId: '1008939065262755975',
                name: '精选餐厅 26%',
                id: '26_7170164842440068',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1500
            },
            {
                depth: '1',
                rootId: '1008937426439151648',
                name: '性别分布',
                id: '1_7170128072330356',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1600
            },
            {
                depth: '2',
                rootId: '1008938067865645135',
                name: '北京市:北京 92%',
                id: '35_7170179615143688',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1900
            },
            {
                depth: '2',
                rootId: '1008937201171468320',
                name: '麻辣',
                id: '23_1031468355271299221',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '2',
                rootId: '1008938699888549935',
                name: '麻辣',
                id: '59_1031468355271299221',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '1',
                rootId: '1008937099551838291',
                name: '标签',
                id: '62_7170218470547795',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '2',
                rootId: '1008938699888549935',
                name: '35-45岁 28%',
                id: '59_7170213427098549',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1700
            },
            {
                depth: '2',
                rootId: '1008938503825825874',
                name: '高档 8%',
                id: '7170124569582623',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1000
            },
            {
                depth: '0',
                rootId: '1008938699888549935',
                name: '渝是乎酸菜小鱼（慈云寺店）',
                id: '1008938699888549935',
                isleaf: '0',
                type: 'Organization.POI',
                group: 1
            },
            {
                depth: '2',
                rootId: '1008937426439151648',
                name: '港味秘制猪手',
                id: '1_1007588278339154118',
                isleaf: '1',
                type: 'Food.Dish',
                group: 5
            },
            {
                depth: '1',
                rootId: '1008936261286654001',
                name: '性别分布',
                id: '2_7170129384522645',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1600
            },
            {
                depth: '2',
                rootId: '1008939065262755975',
                name: '普通 35%',
                id: '26_7170164719934688',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1000
            },
            {
                depth: '2',
                rootId: '1008938067865645135',
                name: '45岁以上 30%',
                id: '35_7170178485735516',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1700
            },
            {
                depth: '1',
                rootId: '1008937201171468320',
                name: '消费水平分布',
                id: '23_7170160245185153',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1800
            },
            {
                depth: '2',
                rootId: '1008939065262755975',
                name: '实惠 10%',
                id: '26_7170164719933590',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1000
            },
            {
                depth: '1',
                rootId: '1008938067865645135',
                name: '性别分布',
                id: '35_7170178868933402',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1600
            },
            {
                depth: '1',
                rootId: '1008939065262755975',
                name: '性别分布',
                id: '26_7170164983906606',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1600
            },
            {
                depth: '2',
                rootId: '1008936261286654001',
                name: '广东省:深圳 1%',
                id: '2_7170130131594099',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1900
            }
        ],
        links: [
            {
                source: '1008938503825825874',
                value: 1,
                target: '7170125435697864'
            },
            {
                source: '1008938503825825874',
                value: 1,
                target: '7170124569542065'
            },
            {
                source: '7170124569542065',
                value: 1,
                target: '7170124569583520'
            },
            {
                source: '7170124569542065',
                value: 1,
                target: '7170124569577715'
            },
            {
                source: '7170124569542065',
                value: 1,
                target: '7170124569582623'
            },
            {
                source: '7170124569542065',
                value: 1,
                target: '7170124569581715'
            },
            {
                source: '7170124569542065',
                value: 1,
                target: '7170124569580409'
            },
            {
                source: '1008938503825825874',
                value: 1,
                target: '7170124452939814'
            },
            {
                source: '7170124452939814',
                value: 1,
                target: '7170124452985475'
            },
            {
                source: '7170124452939814',
                value: 1,
                target: '7170124452983632'
            },
            {
                source: '7170124452939814',
                value: 1,
                target: '7170124452982003'
            },
            {
                source: '7170124452939814',
                value: 1,
                target: '7170124452978373'
            },
            {
                source: '1008938503825825874',
                value: 1,
                target: '7170124835802233'
            },
            {
                source: '7170124835802233',
                value: 1,
                target: '7170124835816634'
            },
            {
                source: '7170124835802233',
                value: 1,
                target: '7170124835818921'
            },
            {
                source: '1008938503825825874',
                value: 1,
                target: '7170124028611590'
            },
            {
                source: '7170124028611590',
                value: 1,
                target: '1007588332554694661'
            },
            {
                source: '1007588332554694661',
                value: 1,
                target: '1008936699692069011'
            },
            {
                source: '1008936699692069011',
                value: 1,
                target: '16_7170149789481645'
            },
            {
                source: '16_7170149789481645',
                value: 1,
                target: '16_1044629631971401842'
            },
            {
                source: '16_7170149789481645',
                value: 1,
                target: '16_1007587739614331041'
            },
            {
                source: '16_7170149789481645',
                value: 1,
                target: '16_1044994158265151553'
            },
            {
                source: '16_7170149789481645',
                value: 1,
                target: '16_1007587739626922079'
            },
            {
                source: '16_7170149789481645',
                value: 1,
                target: '16_1007587739576611034'
            },
            {
                source: '1008936699692069011',
                value: 1,
                target: '16_7170150259020658'
            },
            {
                source: '16_7170150259020658',
                value: 1,
                target: '16_7170150259058217'
            },
            {
                source: '16_7170150259020658',
                value: 1,
                target: '16_7170150259062085'
            },
            {
                source: '16_7170150259020658',
                value: 1,
                target: '16_7170150259064697'
            },
            {
                source: '16_7170150259020658',
                value: 1,
                target: '16_7170150259066696'
            },
            {
                source: '1008936699692069011',
                value: 1,
                target: '16_7170150375810691'
            },
            {
                source: '16_7170150375810691',
                value: 1,
                target: '16_7170150375840232'
            },
            {
                source: '16_7170150375810691',
                value: 1,
                target: '16_7170150375842543'
            },
            {
                source: '16_7170150375810691',
                value: 1,
                target: '16_7170150375843816'
            },
            {
                source: '16_7170150375810691',
                value: 1,
                target: '16_7170150375844776'
            },
            {
                source: '16_7170150375810691',
                value: 1,
                target: '16_7170150375845612'
            },
            {
                source: '1008936699692069011',
                value: 1,
                target: '16_7170150375852236'
            },
            {
                source: '16_7170150375852236',
                value: 1,
                target: '16_7170150492339582'
            },
            {
                source: '16_7170150375852236',
                value: 1,
                target: '16_7170150499642793'
            },
            {
                source: '16_7170150375852236',
                value: 1,
                target: '16_7170150505371746'
            },
            {
                source: '16_7170150375852236',
                value: 1,
                target: '16_7170150511345213'
            },
            {
                source: '16_7170150375852236',
                value: 1,
                target: '16_7170150516648410'
            },
            {
                source: '1008936699692069011',
                value: 1,
                target: '16_7170150638998444'
            },
            {
                source: '16_7170150638998444',
                value: 1,
                target: '16_7170150639019015'
            },
            {
                source: '16_7170150638998444',
                value: 1,
                target: '16_7170150639021599'
            },
            {
                source: '1008936699692069011',
                value: 1,
                target: '16_7170150639029821'
            },
            {
                source: '1008936699692069011',
                value: 1,
                target: '16_7170151037294285'
            },
            {
                source: '1008936699692069011',
                value: 1,
                target: '16_7170151122472186'
            },
            {
                source: '16_7170151122472186',
                value: 1,
                target: '16_1031468354713464917'
            },
            {
                source: '16_7170151122472186',
                value: 1,
                target: '16_1031468355271299196'
            },
            {
                source: '16_7170151122472186',
                value: 1,
                target: '16_1031468354373709875'
            },
            {
                source: '16_7170151122472186',
                value: 1,
                target: '16_1031468355036397670'
            },
            {
                source: '16_7170151122472186',
                value: 1,
                target: '16_1031468354713464923'
            },
            {
                source: '1008936699692069011',
                value: 1,
                target: '16_7170151317537643'
            },
            {
                source: '16_7170151317537643',
                value: 1,
                target: '16_7170151317557335'
            },
            {
                source: '16_7170151317537643',
                value: 1,
                target: '16_7170151317559866'
            },
            {
                source: '1007588332554694661',
                value: 1,
                target: '1008938067865645135'
            },
            {
                source: '1008938067865645135',
                value: 1,
                target: '35_7170178191640425'
            },
            {
                source: '35_7170178191640425',
                value: 1,
                target: '35_1007587622266122370'
            },
            {
                source: '35_7170178191640425',
                value: 1,
                target: '35_1044629405588000875'
            },
            {
                source: '35_7170178191640425',
                value: 1,
                target: '35_1007587622266122372'
            },
            {
                source: '35_7170178191640425',
                value: 1,
                target: '35_1007587622295445640'
            },
            {
                source: '35_7170178191640425',
                value: 1,
                target: '35_1007587622266122375'
            },
            {
                source: '1008938067865645135',
                value: 1,
                target: '35_7170178485688852'
            },
            {
                source: '35_7170178485688852',
                value: 1,
                target: '35_7170178485729410'
            },
            {
                source: '35_7170178485688852',
                value: 1,
                target: '35_7170178485733254'
            },
            {
                source: '35_7170178485688852',
                value: 1,
                target: '35_7170178485735516'
            },
            {
                source: '35_7170178485688852',
                value: 1,
                target: '35_7170178485737220'
            },
            {
                source: '1008938067865645135',
                value: 1,
                target: '35_7170178602360319'
            },
            {
                source: '35_7170178602360319',
                value: 1,
                target: '35_7170178602392113'
            },
            {
                source: '35_7170178602360319',
                value: 1,
                target: '35_7170178602395090'
            },
            {
                source: '35_7170178602360319',
                value: 1,
                target: '35_7170178602396024'
            },
            {
                source: '35_7170178602360319',
                value: 1,
                target: '35_7170178602397169'
            },
            {
                source: '35_7170178602360319',
                value: 1,
                target: '35_7170178602398222'
            },
            {
                source: '1008938067865645135',
                value: 1,
                target: '35_7170178602405385'
            },
            {
                source: '35_7170178602405385',
                value: 1,
                target: '35_7170178718955452'
            },
            {
                source: '35_7170178602405385',
                value: 1,
                target: '35_7170178727160612'
            },
            {
                source: '35_7170178602405385',
                value: 1,
                target: '35_7170178733326010'
            },
            {
                source: '35_7170178602405385',
                value: 1,
                target: '35_7170178740365162'
            },
            {
                source: '35_7170178602405385',
                value: 1,
                target: '35_7170178746287137'
            },
            {
                source: '1008938067865645135',
                value: 1,
                target: '35_7170178868933402'
            },
            {
                source: '35_7170178868933402',
                value: 1,
                target: '35_7170178868947097'
            },
            {
                source: '35_7170178868933402',
                value: 1,
                target: '35_7170178868949479'
            },
            {
                source: '1008938067865645135',
                value: 1,
                target: '35_7170178868957416'
            },
            {
                source: '1008938067865645135',
                value: 1,
                target: '35_7170179354921533'
            },
            {
                source: '1008938067865645135',
                value: 1,
                target: '35_7170179435280162'
            },
            {
                source: '35_7170179435280162',
                value: 1,
                target: '35_1031468354713464917'
            },
            {
                source: '35_7170179435280162',
                value: 1,
                target: '35_1031468354373709834'
            },
            {
                source: '35_7170179435280162',
                value: 1,
                target: '35_1031468354918940782'
            },
            {
                source: '35_7170179435280162',
                value: 1,
                target: '35_1031468355271299158'
            },
            {
                source: '35_7170179435280162',
                value: 1,
                target: '35_1031468354373709875'
            },
            {
                source: '1008938067865645135',
                value: 1,
                target: '35_7170179615127611'
            },
            {
                source: '35_7170179615127611',
                value: 1,
                target: '35_7170179615143688'
            },
            {
                source: '35_7170179615127611',
                value: 1,
                target: '35_7170179615146761'
            },
            {
                source: '35_7170179615127611',
                value: 1,
                target: '35_7170179615147648'
            },
            {
                source: '35_7170179615127611',
                value: 1,
                target: '35_7170179615148300'
            },
            {
                source: '35_7170179615127611',
                value: 1,
                target: '35_7170179615149182'
            },
            {
                source: '7170124028611590',
                value: 1,
                target: '1007588332416315540'
            },
            {
                source: '1007588332416315540',
                value: 1,
                target: '1008938699888549935'
            },
            {
                source: '1008938699888549935',
                value: 1,
                target: '59_7170213153497567'
            },
            {
                source: '59_7170213153497567',
                value: 1,
                target: '59_1007588033542770806'
            },
            {
                source: '59_7170213153497567',
                value: 1,
                target: '59_1007588033542770807'
            },
            {
                source: '59_7170213153497567',
                value: 1,
                target: '59_1007588033542770805'
            },
            {
                source: '59_7170213153497567',
                value: 1,
                target: '59_1044994417854779502'
            },
            {
                source: '59_7170213153497567',
                value: 1,
                target: '59_1038831627666481270'
            },
            {
                source: '1008938699888549935',
                value: 1,
                target: '59_7170213427059138'
            },
            {
                source: '59_7170213427059138',
                value: 1,
                target: '59_7170213427098549'
            },
            {
                source: '59_7170213427059138',
                value: 1,
                target: '59_7170213427102839'
            },
            {
                source: '59_7170213427059138',
                value: 1,
                target: '59_7170213427105162'
            },
            {
                source: '59_7170213427059138',
                value: 1,
                target: '59_7170213427107468'
            },
            {
                source: '1008938699888549935',
                value: 1,
                target: '59_7170213543043705'
            },
            {
                source: '59_7170213543043705',
                value: 1,
                target: '59_7170213543077315'
            },
            {
                source: '59_7170213543043705',
                value: 1,
                target: '59_7170213543079934'
            },
            {
                source: '59_7170213543043705',
                value: 1,
                target: '59_7170213543081002'
            },
            {
                source: '59_7170213543043705',
                value: 1,
                target: '59_7170213543081871'
            },
            {
                source: '59_7170213543043705',
                value: 1,
                target: '59_7170213543082683'
            },
            {
                source: '1008938699888549935',
                value: 1,
                target: '59_7170213543084832'
            },
            {
                source: '59_7170213543084832',
                value: 1,
                target: '59_7170213658977775'
            },
            {
                source: '59_7170213543084832',
                value: 1,
                target: '59_7170213665792651'
            },
            {
                source: '59_7170213543084832',
                value: 1,
                target: '59_7170213672461407'
            },
            {
                source: '59_7170213543084832',
                value: 1,
                target: '59_7170213678846807'
            },
            {
                source: '59_7170213543084832',
                value: 1,
                target: '59_7170213684803033'
            },
            {
                source: '1008938699888549935',
                value: 1,
                target: '59_7170213807820625'
            },
            {
                source: '59_7170213807820625',
                value: 1,
                target: '59_7170213807833639'
            },
            {
                source: '59_7170213807820625',
                value: 1,
                target: '59_7170213807837257'
            },
            {
                source: '1008938699888549935',
                value: 1,
                target: '59_7170213807840052'
            },
            {
                source: '1008938699888549935',
                value: 1,
                target: '59_7170214145202106'
            },
            {
                source: '1008938699888549935',
                value: 1,
                target: '59_7170214224603247'
            },
            {
                source: '59_7170214224603247',
                value: 1,
                target: '59_1031468354713464917'
            },
            {
                source: '59_7170214224603247',
                value: 1,
                target: '59_1031468355141263369'
            },
            {
                source: '59_7170214224603247',
                value: 1,
                target: '59_1031468354713464875'
            },
            {
                source: '59_7170214224603247',
                value: 1,
                target: '59_1031468354918940782'
            },
            {
                source: '59_7170214224603247',
                value: 1,
                target: '59_1031468355271299221'
            },
            {
                source: '1008938699888549935',
                value: 1,
                target: '59_7170214405164842'
            },
            {
                source: '59_7170214405164842',
                value: 1,
                target: '59_7170214405185027'
            },
            {
                source: '59_7170214405164842',
                value: 1,
                target: '59_7170214405187774'
            },
            {
                source: '1007588332416315540',
                value: 1,
                target: '1008936620096786509'
            },
            {
                source: '1008936620096786509',
                value: 1,
                target: '63_7170218671985479'
            },
            {
                source: '63_7170218671985479',
                value: 1,
                target: '63_1007588082230251687'
            },
            {
                source: '63_7170218671985479',
                value: 1,
                target: '63_1045506921651560632'
            },
            {
                source: '63_7170218671985479',
                value: 1,
                target: '63_1007588082242830392'
            },
            {
                source: '63_7170218671985479',
                value: 1,
                target: '63_1007588082230251677'
            },
            {
                source: '63_7170218671985479',
                value: 1,
                target: '63_1038831313160777889'
            },
            {
                source: '1008936620096786509',
                value: 1,
                target: '63_7170218975663392'
            },
            {
                source: '63_7170218975663392',
                value: 1,
                target: '63_7170218975701750'
            },
            {
                source: '63_7170218975663392',
                value: 1,
                target: '63_7170218975707189'
            },
            {
                source: '63_7170218975663392',
                value: 1,
                target: '63_7170218975709374'
            },
            {
                source: '63_7170218975663392',
                value: 1,
                target: '63_7170218975710744'
            },
            {
                source: '1008936620096786509',
                value: 1,
                target: '63_7170219092205894'
            },
            {
                source: '63_7170219092205894',
                value: 1,
                target: '63_7170219092237258'
            },
            {
                source: '63_7170219092205894',
                value: 1,
                target: '63_7170219092239975'
            },
            {
                source: '63_7170219092205894',
                value: 1,
                target: '63_7170219092241062'
            },
            {
                source: '63_7170219092205894',
                value: 1,
                target: '63_7170219092241845'
            },
            {
                source: '63_7170219092205894',
                value: 1,
                target: '63_7170219092242770'
            },
            {
                source: '1008936620096786509',
                value: 1,
                target: '63_7170219092245106'
            },
            {
                source: '63_7170219092245106',
                value: 1,
                target: '63_7170219208596778'
            },
            {
                source: '63_7170219092245106',
                value: 1,
                target: '63_7170219215818122'
            },
            {
                source: '63_7170219092245106',
                value: 1,
                target: '63_7170219222364605'
            },
            {
                source: '63_7170219092245106',
                value: 1,
                target: '63_7170219229437965'
            },
            {
                source: '63_7170219092245106',
                value: 1,
                target: '63_7170219235782379'
            },
            {
                source: '1008936620096786509',
                value: 1,
                target: '63_7170219358252473'
            },
            {
                source: '63_7170219358252473',
                value: 1,
                target: '63_7170219358265151'
            },
            {
                source: '63_7170219358252473',
                value: 1,
                target: '63_7170219358267475'
            },
            {
                source: '1008936620096786509',
                value: 1,
                target: '63_7170219358269754'
            },
            {
                source: '1008936620096786509',
                value: 1,
                target: '63_7170219730447621'
            },
            {
                source: '1008936620096786509',
                value: 1,
                target: '63_7170219819094440'
            },
            {
                source: '63_7170219819094440',
                value: 1,
                target: '63_1031468354713464917'
            },
            {
                source: '63_7170219819094440',
                value: 1,
                target: '63_1031468355141263369'
            },
            {
                source: '63_7170219819094440',
                value: 1,
                target: '63_1031468355271299221'
            },
            {
                source: '63_7170219819094440',
                value: 1,
                target: '63_1031468354918940782'
            },
            {
                source: '63_7170219819094440',
                value: 1,
                target: '63_1031468355271299158'
            },
            {
                source: '1008936620096786509',
                value: 1,
                target: '63_7170219994715468'
            },
            {
                source: '63_7170219994715468',
                value: 1,
                target: '63_7170219994735013'
            },
            {
                source: '63_7170219994715468',
                value: 1,
                target: '63_7170219994738098'
            },
            {
                source: '1008938503825825874',
                value: 1,
                target: '7170125535440144'
            },
            {
                source: '7170125535440144',
                value: 1,
                target: '1031468355271299221'
            },
            {
                source: '1031468355271299221',
                value: 1,
                target: '1008937746309345364'
            },
            {
                source: '1008937746309345364',
                value: 1,
                target: '44_7170190823572909'
            },
            {
                source: '44_7170190823572909',
                value: 1,
                target: '44_1044994349743493226'
            },
            {
                source: '44_7170190823572909',
                value: 1,
                target: '44_1007588129957249165'
            },
            {
                source: '44_7170190823572909',
                value: 1,
                target: '44_1044994349743493269'
            },
            {
                source: '44_7170190823572909',
                value: 1,
                target: '44_1007588129957249164'
            },
            {
                source: '44_7170190823572909',
                value: 1,
                target: '44_1007588129957249166'
            },
            {
                source: '1008937746309345364',
                value: 1,
                target: '44_7170191138868634'
            },
            {
                source: '44_7170191138868634',
                value: 1,
                target: '44_7170191138927621'
            },
            {
                source: '44_7170191138868634',
                value: 1,
                target: '44_7170191138932213'
            },
            {
                source: '44_7170191138868634',
                value: 1,
                target: '44_7170191138934346'
            },
            {
                source: '44_7170191138868634',
                value: 1,
                target: '44_7170191138935820'
            },
            {
                source: '1008937746309345364',
                value: 1,
                target: '44_7170191255254078'
            },
            {
                source: '44_7170191255254078',
                value: 1,
                target: '44_7170191255290612'
            },
            {
                source: '44_7170191255254078',
                value: 1,
                target: '44_7170191255297495'
            },
            {
                source: '44_7170191255254078',
                value: 1,
                target: '44_7170191255299006'
            },
            {
                source: '44_7170191255254078',
                value: 1,
                target: '44_7170191255300012'
            },
            {
                source: '44_7170191255254078',
                value: 1,
                target: '44_7170191255300871'
            },
            {
                source: '1008937746309345364',
                value: 1,
                target: '44_7170191255310270'
            },
            {
                source: '44_7170191255310270',
                value: 1,
                target: '44_7170191372176634'
            },
            {
                source: '44_7170191255310270',
                value: 1,
                target: '44_7170191379329173'
            },
            {
                source: '44_7170191255310270',
                value: 1,
                target: '44_7170191384865061'
            },
            {
                source: '44_7170191255310270',
                value: 1,
                target: '44_7170191390186656'
            },
            {
                source: '44_7170191255310270',
                value: 1,
                target: '44_7170191395562610'
            },
            {
                source: '1008937746309345364',
                value: 1,
                target: '44_7170191518047285'
            },
            {
                source: '44_7170191518047285',
                value: 1,
                target: '44_7170191518065701'
            },
            {
                source: '44_7170191518047285',
                value: 1,
                target: '44_7170191518068229'
            },
            {
                source: '1008937746309345364',
                value: 1,
                target: '44_7170191518076457'
            },
            {
                source: '1008937746309345364',
                value: 1,
                target: '44_7170191909356591'
            },
            {
                source: '1008937746309345364',
                value: 1,
                target: '44_7170191996637541'
            },
            {
                source: '44_7170191996637541',
                value: 1,
                target: '44_1031468355271299221'
            },
            {
                source: '44_7170191996637541',
                value: 1,
                target: '44_1031468354373709860'
            },
            {
                source: '44_7170191996637541',
                value: 1,
                target: '44_1031468354713464917'
            },
            {
                source: '44_7170191996637541',
                value: 1,
                target: '44_1031468354918940725'
            },
            {
                source: '44_7170191996637541',
                value: 1,
                target: '44_1031468355367759987'
            },
            {
                source: '1008937746309345364',
                value: 1,
                target: '44_7170192214952245'
            },
            {
                source: '44_7170192214952245',
                value: 1,
                target: '44_7170192214972212'
            },
            {
                source: '44_7170192214952245',
                value: 1,
                target: '44_7170192214974910'
            },
            {
                source: '44_7170192214952245',
                value: 1,
                target: '44_7170192214975851'
            },
            {
                source: '7170125535440144',
                value: 1,
                target: '1031468354918940782'
            },
            {
                source: '1031468354918940782',
                value: 1,
                target: '1008936197508075588'
            },
            {
                source: '1008936197508075588',
                value: 1,
                target: '20_7170155476978995'
            },
            {
                source: '20_7170155476978995',
                value: 1,
                target: '20_1045506996784095353'
            },
            {
                source: '20_7170155476978995',
                value: 1,
                target: '20_1012385915978407980'
            },
            {
                source: '20_7170155476978995',
                value: 1,
                target: '20_1022524990899118132'
            },
            {
                source: '20_7170155476978995',
                value: 1,
                target: '20_1007587952798224614'
            },
            {
                source: '20_7170155476978995',
                value: 1,
                target: '20_1045506407232716894'
            },
            {
                source: '1008936197508075588',
                value: 1,
                target: '20_7170155792041053'
            },
            {
                source: '20_7170155792041053',
                value: 1,
                target: '20_7170155792081704'
            },
            {
                source: '20_7170155792041053',
                value: 1,
                target: '20_7170155792085661'
            },
            {
                source: '20_7170155792041053',
                value: 1,
                target: '20_7170155792088082'
            },
            {
                source: '20_7170155792041053',
                value: 1,
                target: '20_7170155792090083'
            },
            {
                source: '1008936197508075588',
                value: 1,
                target: '20_7170155908705201'
            },
            {
                source: '20_7170155908705201',
                value: 1,
                target: '20_7170155908743009'
            },
            {
                source: '20_7170155908705201',
                value: 1,
                target: '20_7170155908745710'
            },
            {
                source: '20_7170155908705201',
                value: 1,
                target: '20_7170155908746784'
            },
            {
                source: '20_7170155908705201',
                value: 1,
                target: '20_7170155908747656'
            },
            {
                source: '20_7170155908705201',
                value: 1,
                target: '20_7170155908748420'
            },
            {
                source: '1008936197508075588',
                value: 1,
                target: '20_7170155908756813'
            },
            {
                source: '20_7170155908756813',
                value: 1,
                target: '20_7170156025311382'
            },
            {
                source: '20_7170155908756813',
                value: 1,
                target: '20_7170156032580016'
            },
            {
                source: '20_7170155908756813',
                value: 1,
                target: '20_7170156039572736'
            },
            {
                source: '20_7170155908756813',
                value: 1,
                target: '20_7170156045855462'
            },
            {
                source: '20_7170155908756813',
                value: 1,
                target: '20_7170156051812429'
            },
            {
                source: '1008936197508075588',
                value: 1,
                target: '20_7170156174784451'
            },
            {
                source: '20_7170156174784451',
                value: 1,
                target: '20_7170156174794721'
            },
            {
                source: '20_7170156174784451',
                value: 1,
                target: '20_7170156174796980'
            },
            {
                source: '1008936197508075588',
                value: 1,
                target: '20_7170156174802430'
            },
            {
                source: '1008936197508075588',
                value: 1,
                target: '20_7170156563536369'
            },
            {
                source: '1008936197508075588',
                value: 1,
                target: '20_7170156659618694'
            },
            {
                source: '20_7170156659618694',
                value: 1,
                target: '20_1031468354918940778'
            },
            {
                source: '20_7170156659618694',
                value: 1,
                target: '20_1031468354918940725'
            },
            {
                source: '20_7170156659618694',
                value: 1,
                target: '20_1031468355367760011'
            },
            {
                source: '20_7170156659618694',
                value: 1,
                target: '20_1031468354918940782'
            },
            {
                source: '20_7170156659618694',
                value: 1,
                target: '20_1031468354713464917'
            },
            {
                source: '1008936197508075588',
                value: 1,
                target: '20_7170156848447948'
            },
            {
                source: '20_7170156848447948',
                value: 1,
                target: '20_7170156848473208'
            },
            {
                source: '20_7170156848447948',
                value: 1,
                target: '20_7170156848475998'
            },
            {
                source: '20_7170156848447948',
                value: 1,
                target: '20_7170156848476809'
            },
            {
                source: '20_7170156848447948',
                value: 1,
                target: '20_7170156848477485'
            },
            {
                source: '20_7170156848447948',
                value: 1,
                target: '20_7170156848478146'
            },
            {
                source: '1031468354918940782',
                value: 1,
                target: '1008937099551838291'
            },
            {
                source: '1008937099551838291',
                value: 1,
                target: '62_7170217272356881'
            },
            {
                source: '62_7170217272356881',
                value: 1,
                target: '62_1007587636593836133'
            },
            {
                source: '62_7170217272356881',
                value: 1,
                target: '62_1044629450831994950'
            },
            {
                source: '62_7170217272356881',
                value: 1,
                target: '62_1007587636593836137'
            },
            {
                source: '62_7170217272356881',
                value: 1,
                target: '62_1007587636593836140'
            },
            {
                source: '62_7170217272356881',
                value: 1,
                target: '62_1007587636593836138'
            },
            {
                source: '1008937099551838291',
                value: 1,
                target: '62_7170217624284256'
            },
            {
                source: '62_7170217624284256',
                value: 1,
                target: '62_7170217624322879'
            },
            {
                source: '62_7170217624284256',
                value: 1,
                target: '62_7170217624326530'
            },
            {
                source: '62_7170217624284256',
                value: 1,
                target: '62_7170217624327897'
            },
            {
                source: '62_7170217624284256',
                value: 1,
                target: '62_7170217624330188'
            },
            {
                source: '1008937099551838291',
                value: 1,
                target: '62_7170217740642046'
            },
            {
                source: '62_7170217740642046',
                value: 1,
                target: '62_7170217740676740'
            },
            {
                source: '62_7170217740642046',
                value: 1,
                target: '62_7170217740679630'
            },
            {
                source: '62_7170217740642046',
                value: 1,
                target: '62_7170217740680666'
            },
            {
                source: '62_7170217740642046',
                value: 1,
                target: '62_7170217740681531'
            },
            {
                source: '62_7170217740642046',
                value: 1,
                target: '62_7170217740682278'
            },
            {
                source: '1008937099551838291',
                value: 1,
                target: '62_7170217740685132'
            },
            {
                source: '62_7170217740685132',
                value: 1,
                target: '62_7170217857039689'
            },
            {
                source: '62_7170217740685132',
                value: 1,
                target: '62_7170217863579699'
            },
            {
                source: '62_7170217740685132',
                value: 1,
                target: '62_7170217869514897'
            },
            {
                source: '62_7170217740685132',
                value: 1,
                target: '62_7170217876159330'
            },
            {
                source: '62_7170217740685132',
                value: 1,
                target: '62_7170217882983992'
            },
            {
                source: '1008937099551838291',
                value: 1,
                target: '62_7170218005821691'
            },
            {
                source: '62_7170218005821691',
                value: 1,
                target: '62_7170218005834461'
            },
            {
                source: '62_7170218005821691',
                value: 1,
                target: '62_7170218005837407'
            },
            {
                source: '1008937099551838291',
                value: 1,
                target: '62_7170218005839828'
            },
            {
                source: '1008937099551838291',
                value: 1,
                target: '62_7170218397963902'
            },
            {
                source: '1008937099551838291',
                value: 1,
                target: '62_7170218470547795'
            },
            {
                source: '62_7170218470547795',
                value: 1,
                target: '62_1031468354918940778'
            },
            {
                source: '62_7170218470547795',
                value: 1,
                target: '62_1031468355036397638'
            },
            {
                source: '62_7170218470547795',
                value: 1,
                target: '62_1031468354713464917'
            },
            {
                source: '62_7170218470547795',
                value: 1,
                target: '62_1031468354918940774'
            },
            {
                source: '62_7170218470547795',
                value: 1,
                target: '62_1031468355271299158'
            },
            {
                source: '1008937099551838291',
                value: 1,
                target: '62_7170218653303445'
            },
            {
                source: '62_7170218653303445',
                value: 1,
                target: '62_7170218653324128'
            },
            {
                source: '1008938503825825874',
                value: 1,
                target: '7170125736873287'
            },
            {
                source: '7170125736873287',
                value: 1,
                target: '7170125736893169'
            },
            {
                source: '7170125736873287',
                value: 1,
                target: '7170125736896757'
            },
            {
                source: '7170125736873287',
                value: 1,
                target: '7170125736895710'
            },
            {
                source: '1008938503825825874',
                value: 1,
                target: '7170124569589030'
            },
            {
                source: '7170124569589030',
                value: 1,
                target: '7170124686361990'
            },
            {
                source: '7170124686361990',
                value: 1,
                target: '1008939065262755975'
            },
            {
                source: '1008939065262755975',
                value: 1,
                target: '26_7170164292344174'
            },
            {
                source: '26_7170164292344174',
                value: 1,
                target: '26_1007587919700979981'
            },
            {
                source: '26_7170164292344174',
                value: 1,
                target: '26_1045506971014303876'
            },
            {
                source: '26_7170164292344174',
                value: 1,
                target: '26_1007587919747088440'
            },
            {
                source: '26_7170164292344174',
                value: 1,
                target: '26_1044994406525980716'
            },
            {
                source: '26_7170164292344174',
                value: 1,
                target: '26_1007587919717761084'
            },
            {
                source: '1008939065262755975',
                value: 1,
                target: '26_7170164603221279'
            },
            {
                source: '26_7170164603221279',
                value: 1,
                target: '26_7170164603264265'
            },
            {
                source: '26_7170164603221279',
                value: 1,
                target: '26_7170164603269486'
            },
            {
                source: '26_7170164603221279',
                value: 1,
                target: '26_7170164603272091'
            },
            {
                source: '26_7170164603221279',
                value: 1,
                target: '26_7170164603274581'
            },
            {
                source: '1008939065262755975',
                value: 1,
                target: '26_7170164719891531'
            },
            {
                source: '26_7170164719891531',
                value: 1,
                target: '26_7170164719929421'
            },
            {
                source: '26_7170164719891531',
                value: 1,
                target: '26_7170164719932467'
            },
            {
                source: '26_7170164719891531',
                value: 1,
                target: '26_7170164719933590'
            },
            {
                source: '26_7170164719891531',
                value: 1,
                target: '26_7170164719934688'
            },
            {
                source: '26_7170164719891531',
                value: 1,
                target: '26_7170164719935613'
            },
            {
                source: '1008939065262755975',
                value: 1,
                target: '26_7170164719944258'
            },
            {
                source: '26_7170164719944258',
                value: 1,
                target: '26_7170164836312800'
            },
            {
                source: '26_7170164719944258',
                value: 1,
                target: '26_7170164842440068'
            },
            {
                source: '26_7170164719944258',
                value: 1,
                target: '26_7170164848927212'
            },
            {
                source: '26_7170164719944258',
                value: 1,
                target: '26_7170164854490764'
            },
            {
                source: '26_7170164719944258',
                value: 1,
                target: '26_7170164861464933'
            },
            {
                source: '1008939065262755975',
                value: 1,
                target: '26_7170164983906606'
            },
            {
                source: '26_7170164983906606',
                value: 1,
                target: '26_7170164983920199'
            },
            {
                source: '26_7170164983906606',
                value: 1,
                target: '26_7170164983922567'
            },
            {
                source: '1008939065262755975',
                value: 1,
                target: '26_7170164983931250'
            },
            {
                source: '1008939065262755975',
                value: 1,
                target: '26_7170165342062421'
            },
            {
                source: '1008939065262755975',
                value: 1,
                target: '26_7170165447631623'
            },
            {
                source: '26_7170165447631623',
                value: 1,
                target: '26_1031468354713464917'
            },
            {
                source: '26_7170165447631623',
                value: 1,
                target: '26_1031468354918940782'
            },
            {
                source: '26_7170165447631623',
                value: 1,
                target: '26_1031468355271299158'
            },
            {
                source: '26_7170165447631623',
                value: 1,
                target: '26_1031468354713464871'
            },
            {
                source: '26_7170165447631623',
                value: 1,
                target: '26_1031468355036397670'
            },
            {
                source: '1008939065262755975',
                value: 1,
                target: '26_7170165642196642'
            },
            {
                source: '26_7170165642196642',
                value: 1,
                target: '26_7170165642216428'
            },
            {
                source: '26_7170165642196642',
                value: 1,
                target: '26_7170165642219211'
            },
            {
                source: '26_7170165642196642',
                value: 1,
                target: '26_7170165642220339'
            },
            {
                source: '26_7170165642196642',
                value: 1,
                target: '26_7170165642221014'
            },
            {
                source: '26_7170165642196642',
                value: 1,
                target: '26_7170165642221938'
            },
            {
                source: '7170124686361990',
                value: 1,
                target: '1008937426439151648'
            },
            {
                source: '1008937426439151648',
                value: 1,
                target: '1_7170127365419287'
            },
            {
                source: '1_7170127365419287',
                value: 1,
                target: '1_1045506553450361013'
            },
            {
                source: '1_7170127365419287',
                value: 1,
                target: '1_1007588278339154083'
            },
            {
                source: '1_7170127365419287',
                value: 1,
                target: '1_1007588278339154118'
            },
            {
                source: '1_7170127365419287',
                value: 1,
                target: '1_1007588278339154087'
            },
            {
                source: '1_7170127365419287',
                value: 1,
                target: '1_1044994313508937815'
            },
            {
                source: '1008937426439151648',
                value: 1,
                target: '1_7170127691517999'
            },
            {
                source: '1_7170127691517999',
                value: 1,
                target: '1_7170127691556994'
            },
            {
                source: '1_7170127691517999',
                value: 1,
                target: '1_7170127691561026'
            },
            {
                source: '1_7170127691517999',
                value: 1,
                target: '1_7170127691562568'
            },
            {
                source: '1_7170127691517999',
                value: 1,
                target: '1_7170127691563785'
            },
            {
                source: '1008937426439151648',
                value: 1,
                target: '1_7170127807913560'
            },
            {
                source: '1_7170127807913560',
                value: 1,
                target: '1_7170127807950725'
            },
            {
                source: '1_7170127807913560',
                value: 1,
                target: '1_7170127807953651'
            },
            {
                source: '1_7170127807913560',
                value: 1,
                target: '1_7170127807955068'
            },
            {
                source: '1_7170127807913560',
                value: 1,
                target: '1_7170127807956212'
            },
            {
                source: '1_7170127807913560',
                value: 1,
                target: '1_7170127807957009'
            },
            {
                source: '1008937426439151648',
                value: 1,
                target: '1_7170127807963612'
            },
            {
                source: '1_7170127807963612',
                value: 1,
                target: '1_7170127924206360'
            },
            {
                source: '1_7170127807963612',
                value: 1,
                target: '1_7170127930871449'
            },
            {
                source: '1_7170127807963612',
                value: 1,
                target: '1_7170127937154830'
            },
            {
                source: '1_7170127807963612',
                value: 1,
                target: '1_7170127943294606'
            },
            {
                source: '1_7170127807963612',
                value: 1,
                target: '1_7170127948608441'
            },
            {
                source: '1008937426439151648',
                value: 1,
                target: '1_7170128072330356'
            },
            {
                source: '1_7170128072330356',
                value: 1,
                target: '1_7170128072344001'
            },
            {
                source: '1_7170128072330356',
                value: 1,
                target: '1_7170128072346183'
            },
            {
                source: '1008937426439151648',
                value: 1,
                target: '1_7170128072353815'
            },
            {
                source: '1008937426439151648',
                value: 1,
                target: '1_7170128443777671'
            },
            {
                source: '1008937426439151648',
                value: 1,
                target: '1_7170128522789636'
            },
            {
                source: '1_7170128522789636',
                value: 1,
                target: '1_1031468354713464911'
            },
            {
                source: '1_7170128522789636',
                value: 1,
                target: '1_1031468354373709875'
            },
            {
                source: '1_7170128522789636',
                value: 1,
                target: '1_1031468354713464917'
            },
            {
                source: '1_7170128522789636',
                value: 1,
                target: '1_1031468355141263390'
            },
            {
                source: '1_7170128522789636',
                value: 1,
                target: '1_1031468354918940782'
            },
            {
                source: '1008937426439151648',
                value: 1,
                target: '1_7170128705298856'
            },
            {
                source: '1_7170128705298856',
                value: 1,
                target: '1_7170128705317972'
            },
            {
                source: '1_7170128705298856',
                value: 1,
                target: '1_7170128705320700'
            },
            {
                source: '1_7170128705298856',
                value: 1,
                target: '1_7170128705321547'
            },
            {
                source: '1_7170128705298856',
                value: 1,
                target: '1_7170128705322238'
            },
            {
                source: '1008938503825825874',
                value: 1,
                target: '7170124835824829'
            },
            {
                source: '7170124835824829',
                value: 1,
                target: '1008937201171468320'
            },
            {
                source: '1008937201171468320',
                value: 1,
                target: '23_7170159787941736'
            },
            {
                source: '23_7170159787941736',
                value: 1,
                target: '23_1007587857545568482'
            },
            {
                source: '23_7170159787941736',
                value: 1,
                target: '23_1044994168289521811'
            },
            {
                source: '23_7170159787941736',
                value: 1,
                target: '23_1045506902689116299'
            },
            {
                source: '23_7170159787941736',
                value: 1,
                target: '23_1007587857562341473'
            },
            {
                source: '23_7170159787941736',
                value: 1,
                target: '23_1007587857545568487'
            },
            {
                source: '1008937201171468320',
                value: 1,
                target: '23_7170160129224505'
            },
            {
                source: '23_7170160129224505',
                value: 1,
                target: '23_7170160129264878'
            },
            {
                source: '23_7170160129224505',
                value: 1,
                target: '23_7170160129268545'
            },
            {
                source: '23_7170160129224505',
                value: 1,
                target: '23_7170160129270280'
            },
            {
                source: '23_7170160129224505',
                value: 1,
                target: '23_7170160129272093'
            },
            {
                source: '1008937201171468320',
                value: 1,
                target: '23_7170160245185153'
            },
            {
                source: '23_7170160245185153',
                value: 1,
                target: '23_7170160245214524'
            },
            {
                source: '23_7170160245185153',
                value: 1,
                target: '23_7170160245217232'
            },
            {
                source: '23_7170160245185153',
                value: 1,
                target: '23_7170160245218422'
            },
            {
                source: '23_7170160245185153',
                value: 1,
                target: '23_7170160245219273'
            },
            {
                source: '23_7170160245185153',
                value: 1,
                target: '23_7170160245220133'
            },
            {
                source: '1008937201171468320',
                value: 1,
                target: '23_7170160245226607'
            },
            {
                source: '23_7170160245226607',
                value: 1,
                target: '23_7170160361309599'
            },
            {
                source: '23_7170160245226607',
                value: 1,
                target: '23_7170160368630941'
            },
            {
                source: '23_7170160245226607',
                value: 1,
                target: '23_7170160374768238'
            },
            {
                source: '23_7170160245226607',
                value: 1,
                target: '23_7170160381191652'
            },
            {
                source: '23_7170160245226607',
                value: 1,
                target: '23_7170160386363786'
            },
            {
                source: '1008937201171468320',
                value: 1,
                target: '23_7170160507997879'
            },
            {
                source: '23_7170160507997879',
                value: 1,
                target: '23_7170160508017105'
            },
            {
                source: '23_7170160507997879',
                value: 1,
                target: '23_7170160508019265'
            },
            {
                source: '1008937201171468320',
                value: 1,
                target: '23_7170160508026063'
            },
            {
                source: '1008937201171468320',
                value: 1,
                target: '23_7170160928510872'
            },
            {
                source: '1008937201171468320',
                value: 1,
                target: '23_7170161044377737'
            },
            {
                source: '23_7170161044377737',
                value: 1,
                target: '23_1031468354713464917'
            },
            {
                source: '23_7170161044377737',
                value: 1,
                target: '23_1031468354814115910'
            },
            {
                source: '23_7170161044377737',
                value: 1,
                target: '23_1031468355036397629'
            },
            {
                source: '23_7170161044377737',
                value: 1,
                target: '23_1031468354918940782'
            },
            {
                source: '23_7170161044377737',
                value: 1,
                target: '23_1031468355271299221'
            },
            {
                source: '1008937201171468320',
                value: 1,
                target: '23_7170161227292612'
            },
            {
                source: '23_7170161227292612',
                value: 1,
                target: '23_7170161227312998'
            },
            {
                source: '23_7170161227292612',
                value: 1,
                target: '23_7170161227316237'
            },
            {
                source: '7170124835824829',
                value: 1,
                target: '1008936261286654001'
            },
            {
                source: '1008936261286654001',
                value: 1,
                target: '2_7170128725895296'
            },
            {
                source: '2_7170128725895296',
                value: 1,
                target: '2_1007587991058653307'
            },
            {
                source: '2_7170128725895296',
                value: 1,
                target: '2_1007587991058653306'
            },
            {
                source: '2_7170128725895296',
                value: 1,
                target: '2_1007587991058653305'
            },
            {
                source: '2_7170128725895296',
                value: 1,
                target: '2_1007587991058653303'
            },
            {
                source: '2_7170128725895296',
                value: 1,
                target: '2_1007587991058653313'
            },
            {
                source: '1008936261286654001',
                value: 1,
                target: '2_7170129003957886'
            },
            {
                source: '2_7170129003957886',
                value: 1,
                target: '2_7170129003997355'
            },
            {
                source: '2_7170129003957886',
                value: 1,
                target: '2_7170129004015036'
            },
            {
                source: '2_7170129003957886',
                value: 1,
                target: '2_7170129004017515'
            },
            {
                source: '2_7170129003957886',
                value: 1,
                target: '2_7170129004019448'
            },
            {
                source: '1008936261286654001',
                value: 1,
                target: '2_7170129119989598'
            },
            {
                source: '2_7170129119989598',
                value: 1,
                target: '2_7170129120033683'
            },
            {
                source: '2_7170129119989598',
                value: 1,
                target: '2_7170129120036744'
            },
            {
                source: '2_7170129119989598',
                value: 1,
                target: '2_7170129120037640'
            },
            {
                source: '2_7170129119989598',
                value: 1,
                target: '2_7170129120038628'
            },
            {
                source: '2_7170129119989598',
                value: 1,
                target: '2_7170129120039407'
            },
            {
                source: '1008936261286654001',
                value: 1,
                target: '2_7170129120047930'
            },
            {
                source: '2_7170129120047930',
                value: 1,
                target: '2_7170129236053229'
            },
            {
                source: '2_7170129120047930',
                value: 1,
                target: '2_7170129243551069'
            },
            {
                source: '2_7170129120047930',
                value: 1,
                target: '2_7170129249601591'
            },
            {
                source: '2_7170129120047930',
                value: 1,
                target: '2_7170129256389123'
            },
            {
                source: '2_7170129120047930',
                value: 1,
                target: '2_7170129262606110'
            },
            {
                source: '1008936261286654001',
                value: 1,
                target: '2_7170129384522645'
            },
            {
                source: '2_7170129384522645',
                value: 1,
                target: '2_7170129384536673'
            },
            {
                source: '2_7170129384522645',
                value: 1,
                target: '2_7170129384538914'
            },
            {
                source: '1008936261286654001',
                value: 1,
                target: '2_7170129384547296'
            },
            {
                source: '1008936261286654001',
                value: 1,
                target: '2_7170129881203058'
            },
            {
                source: '1008936261286654001',
                value: 1,
                target: '2_7170129957342225'
            },
            {
                source: '2_7170129957342225',
                value: 1,
                target: '2_1031468354713464917'
            },
            {
                source: '2_7170129957342225',
                value: 1,
                target: '2_1031468354918940782'
            },
            {
                source: '2_7170129957342225',
                value: 1,
                target: '2_1031468355271299158'
            },
            {
                source: '2_7170129957342225',
                value: 1,
                target: '2_1031468354373709875'
            },
            {
                source: '2_7170129957342225',
                value: 1,
                target: '2_1031468354814115896'
            },
            {
                source: '1008936261286654001',
                value: 1,
                target: '2_7170130131575867'
            },
            {
                source: '2_7170130131575867',
                value: 1,
                target: '2_7170130131590673'
            },
            {
                source: '2_7170130131575867',
                value: 1,
                target: '2_7170130131593045'
            },
            {
                source: '2_7170130131575867',
                value: 1,
                target: '2_7170130131594099'
            },
            {
                source: '7170124835824829',
                value: 1,
                target: '1008938755635040295'
            },
            {
                source: '1008938755635040295',
                value: 1,
                target: '56_7170208696193453'
            },
            {
                source: '56_7170208696193453',
                value: 1,
                target: '56_1044994293804048532'
            },
            {
                source: '56_7170208696193453',
                value: 1,
                target: '56_1011842175962480710'
            },
            {
                source: '56_7170208696193453',
                value: 1,
                target: '56_1007588091872952343'
            },
            {
                source: '56_7170208696193453',
                value: 1,
                target: '56_1007588091856199783'
            },
            {
                source: '56_7170208696193453',
                value: 1,
                target: '56_1045506931466215486'
            },
            {
                source: '1008938755635040295',
                value: 1,
                target: '56_7170208960309322'
            },
            {
                source: '56_7170208960309322',
                value: 1,
                target: '56_7170208960347459'
            },
            {
                source: '56_7170208960309322',
                value: 1,
                target: '56_7170208960352002'
            },
            {
                source: '56_7170208960309322',
                value: 1,
                target: '56_7170208960354389'
            },
            {
                source: '56_7170208960309322',
                value: 1,
                target: '56_7170208960355846'
            },
            {
                source: '1008938755635040295',
                value: 1,
                target: '56_7170209078092413'
            },
            {
                source: '56_7170209078092413',
                value: 1,
                target: '56_7170209078125309'
            },
            {
                source: '56_7170209078092413',
                value: 1,
                target: '56_7170209078128034'
            },
            {
                source: '56_7170209078092413',
                value: 1,
                target: '56_7170209078129126'
            },
            {
                source: '56_7170209078092413',
                value: 1,
                target: '56_7170209078129931'
            },
            {
                source: '56_7170209078092413',
                value: 1,
                target: '56_7170209078130929'
            },
            {
                source: '1008938755635040295',
                value: 1,
                target: '56_7170209078133635'
            },
            {
                source: '56_7170209078133635',
                value: 1,
                target: '56_7170209194407749'
            },
            {
                source: '56_7170209078133635',
                value: 1,
                target: '56_7170209201270665'
            },
            {
                source: '56_7170209078133635',
                value: 1,
                target: '56_7170209207298314'
            },
            {
                source: '56_7170209078133635',
                value: 1,
                target: '56_7170209212968085'
            },
            {
                source: '56_7170209078133635',
                value: 1,
                target: '56_7170209220781902'
            },
            {
                source: '1008938755635040295',
                value: 1,
                target: '56_7170209343916347'
            },
            {
                source: '56_7170209343916347',
                value: 1,
                target: '56_7170209343928214'
            },
            {
                source: '56_7170209343916347',
                value: 1,
                target: '56_7170209343930519'
            },
            {
                source: '1008938755635040295',
                value: 1,
                target: '56_7170209343933270'
            },
            {
                source: '1008938755635040295',
                value: 1,
                target: '56_7170209810432416'
            },
            {
                source: '1008938755635040295',
                value: 1,
                target: '56_7170209896226007'
            },
            {
                source: '56_7170209896226007',
                value: 1,
                target: '56_1031468354814115900'
            },
            {
                source: '56_7170209896226007',
                value: 1,
                target: '56_1031468354713464917'
            },
            {
                source: '56_7170209896226007',
                value: 1,
                target: '56_1031468355271299221'
            },
            {
                source: '56_7170209896226007',
                value: 1,
                target: '56_1031468354918940782'
            },
            {
                source: '56_7170209896226007',
                value: 1,
                target: '56_1031468355271299238'
            },
            {
                source: '1008938755635040295',
                value: 1,
                target: '56_7170210079482772'
            },
            {
                source: '56_7170210079482772',
                value: 1,
                target: '56_7170210079502327'
            }
        ]
    },

    // 眉州东坡（王府井店）
    // https://brain.meituan.com/brain-api/v2/getPoi3dGraph?subjectId=1008936154810036313&nearByPoiCount=3&simPoiCount=3&dishCount=2&tagCountPerPoi=2&envDistributionCount=1&topPoiListSize=2&tagPoiCount=2&envPoiCount=2
    '1008936154810036313': {
        nodes: [
            {
                depth: '2',
                rootId: '1008937085891010634',
                name: '快速方便',
                id: '77_1031468354814115945',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '2',
                rootId: '1063129407759102074',
                name: '夫妻肺片',
                id: '106_1063833908182835284',
                isleaf: '0',
                type: 'Food.Dish',
                group: 9
            },
            {
                depth: '2',
                rootId: '1008937085891010634',
                name: '性价比高',
                id: '77_1031468354814115949',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '2',
                rootId: '1063129407759102074',
                name: '普通 31%',
                id: '106_30318822409885723',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1000
            },
            {
                depth: '2',
                rootId: '1008936196505604180',
                name: '女 59%',
                id: '123_30318858860205251',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1600
            },
            {
                depth: '2',
                rootId: '1008937085891010634',
                name: '菜品不错 20%',
                id: '77_30318758499972325',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1500
            },
            {
                depth: '2',
                rootId: '1008937987695734905',
                name: '35-45岁 23%',
                id: '44_30318677033442980',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1700
            },
            {
                depth: '2',
                rootId: '1008938620507164753',
                name: '快速方便 10%',
                id: '57_30318710111578567',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1500
            },
            {
                depth: '2',
                rootId: '1008939929524265093',
                name: '撸串圣地 15%',
                id: '47_30318684643582195',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1500
            },
            {
                depth: '2',
                rootId: '1134885965492412506',
                name: '肚丝鸡蛋炒饭',
                id: '36_1135224785085698063',
                isleaf: '1',
                type: 'Food.Dish',
                group: 8
            },
            {
                depth: '2',
                rootId: '1008938620507164753',
                name: '35-45岁 28%',
                id: '57_30318710020592744',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1700
            },
            {
                depth: '2',
                rootId: '1063129407759102074',
                name: '笋丝',
                id: '106_1125440144644526139',
                isleaf: '0',
                type: 'Food.Dish',
                group: 5
            },
            {
                depth: '2',
                rootId: '1008939929524265093',
                name: '鲜香',
                id: '47_1031468354713464923',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '1',
                rootId: '1008939929524265093',
                name: '相似餐厅',
                id: '47_30318684795102579',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 2000
            },
            {
                depth: '2',
                rootId: '1008939929524265093',
                name: '味道赞',
                id: '47_1031468354713464917',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '1',
                rootId: '1008939929524265093',
                name: '环境偏好',
                id: '47_30318684637035309',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1500
            },
            {
                depth: '2',
                rootId: '1088493651933266052',
                name: '银耳羹',
                id: '117_1126165069181251685',
                isleaf: '0',
                type: 'Food.Dish',
                group: 7
            },
            {
                depth: '2',
                rootId: '1008936270543454330',
                name: '精选餐厅',
                id: '132_1031468355141263394',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '2',
                rootId: '1008936154810036313',
                name: '高档 4%',
                id: '30318563180217907',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1000
            },
            {
                depth: '1',
                rootId: '1088493651933266052',
                name: '用户常驻城市',
                id: '117_30318846403177801',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1900
            },
            {
                depth: '2',
                rootId: '1008936196505604180',
                name: '鸡丝凉面',
                id: '123_1108407359861960839',
                isleaf: '0',
                type: 'Food.Dish',
                group: 6
            },
            {
                depth: '1',
                rootId: '1008937987695734905',
                name: '附近餐厅',
                id: '44_30318677760973840',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 2100
            },
            {
                depth: '2',
                rootId: '1008939929524265093',
                name: '鱼香',
                id: '47_1031468355367759999',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '1',
                rootId: '1008937110784213055',
                name: '环境偏好',
                id: '58_30318712639349502',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1500
            },
            {
                depth: '2',
                rootId: '1008936270543454330',
                name: '有酒有肉 9%',
                id: '132_30318881012345994',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1500
            },
            {
                depth: '2',
                rootId: '1063129407759102074',
                name: '素鹅',
                id: '106_1063833903581663364',
                isleaf: '0',
                type: 'Food.Dish',
                group: 7
            },
            {
                depth: '1',
                rootId: '1008937110784213055',
                name: '相似餐厅',
                id: '58_30318712805553779',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 2000
            },
            {
                depth: '2',
                rootId: '1008937987695734905',
                name: '无辣不欢 12%',
                id: '44_30318677130270564',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1500
            },
            {
                depth: '2',
                rootId: '1008938620507164753',
                name: '糯米饭',
                id: '57_1044994308802932904',
                isleaf: '0',
                type: 'Food.Dish',
                group: 6
            },
            {
                depth: '2',
                rootId: '1141762677031338067',
                name: '砂锅方便面',
                id: '38_1142106913715019845',
                isleaf: '0',
                type: 'Food.Dish',
                group: 9
            },
            {
                depth: '2',
                rootId: '1008937365227454569',
                name: '实惠 12%',
                id: '24_30318628867920690',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1000
            },
            {
                depth: '2',
                rootId: '1008936832483758197',
                name: '实惠 18%',
                id: '9_30318589833717076',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1000
            },
            {
                depth: '2',
                rootId: '1008937987695734905',
                name: '菜品不错 8%',
                id: '44_30318677156674816',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1500
            },
            {
                depth: '2',
                rootId: '1008936853832765530',
                name: '小资 38%',
                id: '37_30318660598799089',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1000
            },
            {
                depth: '2',
                rootId: '1134885965492412506',
                name: '腊肠鸡蛋炒饭',
                id: '36_1135224741766914149',
                isleaf: '1',
                type: 'Food.Dish',
                group: 5
            },
            {
                depth: '2',
                rootId: '1063129407759102074',
                name: '土豪 2%',
                id: '106_30318822409883790',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1000
            },
            {
                depth: '2',
                rootId: '1008936853832765530',
                name: '麻辣',
                id: '37_1031468355271299221',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '2',
                rootId: '1008936832483758197',
                name: '一品冰粉',
                id: '9_1045506528221614168',
                isleaf: '0',
                type: 'Food.Dish',
                group: 8
            },
            {
                depth: '1',
                rootId: '1008937085891010634',
                name: '性别分布',
                id: '77_30318758648670711',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1600
            },
            {
                depth: '2',
                rootId: '1134885965492412506',
                name: '快速方便 13%',
                id: '36_30318659238291776',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1500
            },
            {
                depth: '2',
                rootId: '1088493651933266052',
                name: '鲜香',
                id: '117_1031468355141263446',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '1',
                rootId: '1141762677031338067',
                name: '推荐菜',
                id: '38_30318662426417613',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 900
            },
            {
                depth: '2',
                rootId: '1008936270543454330',
                name: '小资 31%',
                id: '132_30318880892320669',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1000
            },
            {
                depth: '1',
                rootId: '1134885965492412506',
                name: '性别分布',
                id: '36_30318659354295849',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1600
            },
            {
                depth: '2',
                rootId: '1008936832483758197',
                name: '川菜',
                id: '9_1031468354814115910',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '2',
                rootId: '1008937085891010634',
                name: '45岁以上 16%',
                id: '77_30318758486513475',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1700
            },
            {
                depth: '2',
                rootId: '1008937085891010634',
                name: '普通 37%',
                id: '77_30318758493827036',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1000
            },
            {
                depth: '1',
                rootId: '1008937085891010634',
                name: '标签',
                id: '77_30318759505326246',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '2',
                rootId: '1008939929524265093',
                name: '甜味',
                id: '47_1031468355036397670',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '2',
                rootId: '1141762677031338067',
                name: '北京市:北京 50%',
                id: '38_30318663395482927',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1900
            },
            {
                depth: '2',
                rootId: '1008936832483758197',
                name: '鸡丝凉面',
                id: '9_1007587853225439262',
                isleaf: '0',
                type: 'Food.Dish',
                group: 10
            },
            {
                depth: '2',
                rootId: '1008939929524265093',
                name: '麻辣香锅',
                id: '47_1007588218285076523',
                isleaf: '0',
                type: 'Food.Dish',
                group: 3
            },
            {
                depth: '2',
                rootId: '1088493651933266052',
                name: '皮蛋瘦肉粥',
                id: '117_1126165087552286841',
                isleaf: '0',
                type: 'Food.Dish',
                group: 11
            },
            {
                depth: '2',
                rootId: '1008939929524265093',
                name: '辣子鸡',
                id: '47_1007588218280886368',
                isleaf: '0',
                type: 'Food.Dish',
                group: 9
            },
            {
                depth: '2',
                rootId: '1008939929524265093',
                name: '蓑衣黄瓜',
                id: '47_1007588218280886369',
                isleaf: '0',
                type: 'Food.Dish',
                group: 6
            },
            {
                depth: '2',
                rootId: '1008936832483758197',
                name: '菜品不错 23%',
                id: '9_30318589839752762',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1500
            },
            {
                depth: '2',
                rootId: '1008937110784213055',
                name: '高逼格自助餐 7%',
                id: '58_30318712765129407',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1500
            },
            {
                depth: '2',
                rootId: '1008936832483758197',
                name: '16-25岁 2%',
                id: '9_30318589827996698',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1700
            },
            {
                depth: '2',
                rootId: '1008936832483758197',
                name: '三鲜锅巴',
                id: '9_1007587853225439259',
                isleaf: '0',
                type: 'Food.Dish',
                group: 7
            },
            {
                depth: '2',
                rootId: '1141762677031338067',
                name: '卫生不好 11%',
                id: '38_30318662950088501',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1500
            },
            {
                depth: '2',
                rootId: '1008937987695734905',
                name: '女 63%',
                id: '44_30318677190271019',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1600
            },
            {
                depth: '2',
                rootId: '1134885965492412506',
                name: '魔鬼特辣酱',
                id: '36_1144282809565753434',
                isleaf: '0',
                type: 'Food.Dish',
                group: 6
            },
            {
                depth: '2',
                rootId: '1008936154810036313',
                name: '一品东坡肉',
                id: '1007588047111340132',
                isleaf: '0',
                type: 'Food.Dish',
                group: 6
            },
            {
                depth: '2',
                rootId: '1008937987695734905',
                name: '16岁以下 1%',
                id: '44_30318677033431667',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1700
            },
            {
                depth: '2',
                rootId: '1008939929524265093',
                name: '糖醋里脊',
                id: '47_1007588218280886354',
                isleaf: '0',
                type: 'Food.Dish',
                group: 12
            },
            {
                depth: '2',
                rootId: '1008936154810036313',
                name: '江苏省:南京 2%',
                id: '30318565081773865',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1900
            },
            {
                depth: '2',
                rootId: '1008939929524265093',
                name: '鸡丝凉面',
                id: '47_1007588218280886355',
                isleaf: '0',
                type: 'Food.Dish',
                group: 11
            },
            {
                depth: '2',
                rootId: '1008939929524265093',
                name: '干烧鱼',
                id: '47_1007588218280886356',
                isleaf: '0',
                type: 'Food.Dish',
                group: 10
            },
            {
                depth: '2',
                rootId: '1008939929524265093',
                name: '肥肠鱼',
                id: '47_1007588218280886358',
                isleaf: '0',
                type: 'Food.Dish',
                group: 5
            },
            {
                depth: '2',
                rootId: '1008939929524265093',
                name: '水煮鱼',
                id: '47_1007588218280886359',
                isleaf: '0',
                type: 'Food.Dish',
                group: 4
            },
            {
                depth: '1',
                rootId: '1008936270543454330',
                name: '标签',
                id: '132_30318881940817568',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '2',
                rootId: '1063129407759102074',
                name: '无肉不欢 8%',
                id: '106_30318822522398449',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1500
            },
            {
                depth: '1',
                rootId: '1008938620507164753',
                name: '消费水平分布',
                id: '57_30318710024952997',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1800
            },
            {
                depth: '2',
                rootId: '1008937110784213055',
                name: '小资 34%',
                id: '58_30318712639333154',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1000
            },
            {
                depth: '2',
                rootId: '1008939929524265093',
                name: '糖醋排骨',
                id: '47_1007588218280886363',
                isleaf: '0',
                type: 'Food.Dish',
                group: 8
            },
            {
                depth: '2',
                rootId: '1008936154810036313',
                name: '夫妻肺片',
                id: '1007588047111340137',
                isleaf: '0',
                type: 'Food.Dish',
                group: 9
            },
            {
                depth: '2',
                rootId: '1008937987695734905',
                name: '高档 10%',
                id: '44_30318677038282736',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1000
            },
            {
                depth: '2',
                rootId: '1008939929524265093',
                name: '45岁以上 8%',
                id: '47_30318684629927774',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1700
            },
            {
                depth: '1',
                rootId: '1008937085891010634',
                name: '环境偏好',
                id: '77_30318758493842859',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1500
            },
            {
                depth: '2',
                rootId: '1008937085891010634',
                name: '16-25岁 2%',
                id: '77_30318758486515684',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1700
            },
            {
                depth: '2',
                rootId: '1008937365227454569',
                name: '高人气 16%',
                id: '24_30318628931060906',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1500
            },
            {
                depth: '2',
                rootId: '1008936270543454330',
                name: '价格实惠',
                id: '132_1031468354373709885',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '1',
                rootId: '1008936154810036313',
                name: '相似餐厅',
                id: '30318563348726285',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 2000
            },
            {
                depth: '2',
                rootId: '1008936270543454330',
                name: '价格高',
                id: '132_1031468354373709887',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '2',
                rootId: '1008936853832765530',
                name: '土豪 4%',
                id: '37_30318660598796601',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1000
            },
            {
                depth: '2',
                rootId: '1008939929524265093',
                name: '环境优雅',
                id: '47_1031468355036397661',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '2',
                rootId: '1063129407759102074',
                name: '哈肉大红肠',
                id: '106_1129789029227716659',
                isleaf: '1',
                type: 'Food.Dish',
                group: 3
            },
            {
                depth: '2',
                rootId: '1063129407759102074',
                name: '麻辣',
                id: '106_1031468354918940725',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '2',
                rootId: '1008938620507164753',
                name: '浙江省:杭州 1%',
                id: '57_30318711832036568',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1900
            },
            {
                depth: '2',
                rootId: '1008938620507164753',
                name: '广东省:广州 1%',
                id: '57_30318711832037898',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1900
            },
            {
                depth: '0',
                rootId: '1008936270543454330',
                name: '东来顺饭庄（五道口店）',
                id: '1008936270543454330',
                isleaf: '0',
                type: 'Organization.POI',
                group: 1
            },
            {
                depth: '1',
                rootId: '1008936270543454330',
                name: '消费水平分布',
                id: '132_30318880892222390',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1800
            },
            {
                depth: '1',
                rootId: '1008938927878324362',
                name: '标签',
                id: '42_30318673046361323',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '2',
                rootId: '1008936832483758197',
                name: '35-45岁 39%',
                id: '9_30318589827989720',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1700
            },
            {
                depth: '1',
                rootId: '1008936154810036313',
                name: '推荐菜',
                id: '30318562283868170',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 900
            },
            {
                depth: '2',
                rootId: '1088493651933266052',
                name: '撸串圣地 100%',
                id: '117_30318845820770871',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1500
            },
            {
                depth: '2',
                rootId: '1008936196505604180',
                name: '45岁以上 11%',
                id: '123_30318858697257533',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1700
            },
            {
                depth: '2',
                rootId: '1134885965492412506',
                name: '高档 11%',
                id: '36_30318659200032365',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1000
            },
            {
                depth: '2',
                rootId: '1134885965492412506',
                name: '小资 22%',
                id: '36_30318659200034543',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1000
            },
            {
                depth: '2',
                rootId: '1134885965492412506',
                name: '江苏省:苏州 4%',
                id: '36_30318659797048787',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1900
            },
            {
                depth: '2',
                rootId: '1008938620507164753',
                name: '天津市:天津 2%',
                id: '57_30318711832022382',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1900
            },
            {
                depth: '2',
                rootId: '1008936270543454330',
                name: '撸串圣地 14%',
                id: '132_30318880957260286',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1500
            },
            {
                depth: '2',
                rootId: '1008936196505604180',
                name: '菜品不错 17%',
                id: '123_30318858737688230',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1500
            },
            {
                depth: '2',
                rootId: '1008937987695734905',
                name: '自助餐',
                id: '44_1031468355141263437',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '2',
                rootId: '1008938620507164753',
                name: '午餐',
                id: '57_1031468354713464875',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '2',
                rootId: '1008937085891010634',
                name: '酸咸',
                id: '77_1031468355271299233',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '2',
                rootId: '1008937085891010634',
                name: '酸辣',
                id: '77_1031468355271299238',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '2',
                rootId: '1008937085891010634',
                name: '芋艿猪手',
                id: '77_1011842094664294594',
                isleaf: '0',
                type: 'Food.Dish',
                group: 4
            },
            {
                depth: '2',
                rootId: '1134885965492412506',
                name: '浙江省:杭州 4%',
                id: '36_30318659797050604',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1900
            },
            {
                depth: '1',
                rootId: '1141762677031338067',
                name: '相似餐厅',
                id: '38_30318663045146756',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 2000
            },
            {
                depth: '2',
                rootId: '1134885965492412506',
                name: '45岁以上 15%',
                id: '36_30318659193506659',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1700
            },
            {
                depth: '2',
                rootId: '1008937085891010634',
                name: '醪糟汤圆',
                id: '77_1007587633750097930',
                isleaf: '0',
                type: 'Food.Dish',
                group: 7
            },
            {
                depth: '2',
                rootId: '1008936196505604180',
                name: '服务热情',
                id: '123_1031468354918940782',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '1',
                rootId: '1088493651933266052',
                name: '附近餐厅',
                id: '117_30318845890082917',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 2100
            },
            {
                depth: '1',
                rootId: '1008937085891010634',
                name: '附近餐厅',
                id: '77_30318759184713522',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 2100
            },
            {
                depth: '2',
                rootId: '1063129407759102074',
                name: '高档 6%',
                id: '106_30318822409889022',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1000
            },
            {
                depth: '2',
                rootId: '1008937085891010634',
                name: '酸辣粉',
                id: '77_1007587633750097931',
                isleaf: '0',
                type: 'Food.Dish',
                group: 6
            },
            {
                depth: '2',
                rootId: '1008937085891010634',
                name: '凉面',
                id: '77_1007587633750097932',
                isleaf: '0',
                type: 'Food.Dish',
                group: 12
            },
            {
                depth: '2',
                rootId: '1063129407759102074',
                name: '服务热情',
                id: '106_1031468354918940782',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '2',
                rootId: '1008937085891010634',
                name: '菠汁担担面',
                id: '77_1014565076939612250',
                isleaf: '0',
                type: 'Food.Dish',
                group: 5
            },
            {
                depth: '2',
                rootId: '1008937365227454569',
                name: '性价比高',
                id: '24_1031468354814115949',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '2',
                rootId: '1008938620507164753',
                name: '小资 46%',
                id: '57_30318710025089228',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1000
            },
            {
                depth: '2',
                rootId: '1008938927878324362',
                name: '普通 39%',
                id: '42_30318672056628576',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1000
            },
            {
                depth: '2',
                rootId: '1008936196505604180',
                name: '菜品不错',
                id: '123_1031468355271299158',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '2',
                rootId: '1063129407759102074',
                name: '甜味',
                id: '106_1031468355036397670',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '2',
                rootId: '1008937110784213055',
                name: '性价比高',
                id: '58_1031468354814115949',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '2',
                rootId: '1008936853832765530',
                name: '川菜',
                id: '37_1031468354814115910',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '1',
                rootId: '1008936853832765530',
                name: '年龄分布',
                id: '37_30318660590190307',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1700
            },
            {
                depth: '1',
                rootId: '1008937110784213055',
                name: '标签',
                id: '58_30318713674538621',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '2',
                rootId: '1008937110784213055',
                name: '快速方便',
                id: '58_1031468354814115945',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '1',
                rootId: '1008937987695734905',
                name: '标签',
                id: '44_30318678151109039',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '2',
                rootId: '1008936832483758197',
                name: '小资 35%',
                id: '9_30318589833714413',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1000
            },
            {
                depth: '2',
                rootId: '1141762677031338067',
                name: '砂锅土豆粉',
                id: '38_1142106917884166343',
                isleaf: '0',
                type: 'Food.Dish',
                group: 6
            },
            {
                depth: '1',
                rootId: '1008936196505604180',
                name: '相似餐厅',
                id: '123_30318858860212895',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 2000
            },
            {
                depth: '2',
                rootId: '1008936270543454330',
                name: '鲜香',
                id: '132_1031468355367760012',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '2',
                rootId: '1008937085891010634',
                name: '川北凉粉',
                id: '77_1007587633750097925',
                isleaf: '0',
                type: 'Food.Dish',
                group: 3
            },
            {
                depth: '1',
                rootId: '1008936154810036313',
                name: '标签',
                id: '30318564348979920',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '2',
                rootId: '1008937365227454569',
                name: '弄堂小店',
                id: '24_1031468354814115937',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '2',
                rootId: '1008938927878324362',
                name: '菜品不错 18%',
                id: '42_30318672062622516',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1500
            },
            {
                depth: '1',
                rootId: '1008939929524265093',
                name: '年龄分布',
                id: '47_30318684629760902',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1700
            },
            {
                depth: '2',
                rootId: '1008938927878324362',
                name: '古香古色',
                id: '42_1031468354713464897',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '2',
                rootId: '1008936154810036313',
                name: '鲜香',
                id: '1031468354713464923',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '2',
                rootId: '1008937365227454569',
                name: '局气文房烤鸭',
                id: '24_1045506917230764121',
                isleaf: '0',
                type: 'Food.Dish',
                group: 8
            },
            {
                depth: '2',
                rootId: '1008936154810036313',
                name: '体验很棒',
                id: '1031468354373709893',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '1',
                rootId: '1008936196505604180',
                name: '推荐菜',
                id: '123_30318857994570477',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 900
            },
            {
                depth: '2',
                rootId: '1008937085891010634',
                name: '35-45岁 42%',
                id: '77_30318758486510124',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1700
            },
            {
                depth: '1',
                rootId: '1008936196505604180',
                name: '性别分布',
                id: '123_30318858860168847',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1600
            },
            {
                depth: '0',
                rootId: '1008938620507164753',
                name: '桃园眷村（三里屯店）',
                id: '1008938620507164753',
                isleaf: '0',
                type: 'Organization.POI',
                group: 1
            },
            {
                depth: '2',
                rootId: '1008937987695734905',
                name: '16-25岁 12%',
                id: '44_30318677033445602',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1700
            },
            {
                depth: '2',
                rootId: '1008937085891010634',
                name: '撸串圣地 12%',
                id: '77_30318758554824676',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1500
            },
            {
                depth: '2',
                rootId: '1008936853832765530',
                name: '酸甜',
                id: '37_1031468355271299236',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '2',
                rootId: '1063129407759102074',
                name: '味道赞',
                id: '106_1031468354713464917',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '2',
                rootId: '1008937085891010634',
                name: '小吃',
                id: '77_1031468354814115900',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '2',
                rootId: '1008938927878324362',
                name: '广东省:深圳 2%',
                id: '42_30318673760408141',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1900
            },
            {
                depth: '1',
                rootId: '1008937085891010634',
                name: '消费水平分布',
                id: '77_30318758493694024',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1800
            },
            {
                depth: '0',
                rootId: '1008937085891010634',
                name: '渝乡人家（复兴门百盛店）',
                id: '1008937085891010634',
                isleaf: '0',
                type: 'Organization.POI',
                group: 1
            },
            {
                depth: '2',
                rootId: '1008937110784213055',
                name: '男 33%',
                id: '58_30318712805539652',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1600
            },
            {
                depth: '1',
                rootId: '1008936832483758197',
                name: '环境偏好',
                id: '9_30318589833725960',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1500
            },
            {
                depth: '2',
                rootId: '1008937365227454569',
                name: '广东省:深圳 1%',
                id: '24_30318630743411572',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1900
            },
            {
                depth: '2',
                rootId: '1008937085891010634',
                name: '葱油饼',
                id: '77_1007587633750097940',
                isleaf: '0',
                type: 'Food.Dish',
                group: 8
            },
            {
                depth: '2',
                rootId: '1063129407759102074',
                name: '25-35岁 60%',
                id: '106_30318822405450556',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1700
            },
            {
                depth: '2',
                rootId: '1008938620507164753',
                name: '轻食餐厅 16%',
                id: '57_30318710029664923',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1500
            },
            {
                depth: '2',
                rootId: '1008937110784213055',
                name: '环境优雅 11%',
                id: '58_30318712736902238',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1500
            },
            {
                depth: '2',
                rootId: '1008936853832765530',
                name: '普通 37%',
                id: '37_30318660598791779',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1000
            },
            {
                depth: '2',
                rootId: '1008937085891010634',
                name: '川菜',
                id: '77_1031468354814115910',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '2',
                rootId: '1134885965492412506',
                name: '35-45岁 14%',
                id: '36_30318659193501164',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1700
            },
            {
                depth: '1',
                rootId: '1008936832483758197',
                name: '用户常驻城市',
                id: '9_30318591530224398',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1900
            },
            {
                depth: '2',
                rootId: '1134885965492412506',
                name: '煎火腿',
                id: '36_1135224788596314185',
                isleaf: '0',
                type: 'Food.Dish',
                group: 9
            },
            {
                depth: '2',
                rootId: '1008936196505604180',
                name: '菜品精致',
                id: '123_1031468355271299168',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '2',
                rootId: '1008936270543454330',
                name: '牛肉丸盘子（碎）',
                id: '132_1045506419853398113',
                isleaf: '0',
                type: 'Food.Dish',
                group: 4
            },
            {
                depth: '1',
                rootId: '1008938620507164753',
                name: '标签',
                id: '57_30318711168622091',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '2',
                rootId: '1063129407759102074',
                name: '无辣不欢 30%',
                id: '106_30318822414368995',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1500
            },
            {
                depth: '2',
                rootId: '1008937365227454569',
                name: '25-35岁 45%',
                id: '24_30318628861425521',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1700
            },
            {
                depth: '2',
                rootId: '1008937085891010634',
                name: '麻辣',
                id: '77_1031468355271299221',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '2',
                rootId: '1008936154810036313',
                name: '16-25岁 10%',
                id: '30318563174191765',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1700
            },
            {
                depth: '1',
                rootId: '1008936154810036313',
                name: '环境偏好',
                id: '30318563180256086',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1500
            },
            {
                depth: '2',
                rootId: '1008938927878324362',
                name: '北京菜',
                id: '42_1031468354713464871',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '2',
                rootId: '1134885965492412506',
                name: '弄堂小店 8%',
                id: '36_30318659293738898',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1500
            },
            {
                depth: '2',
                rootId: '1008936196505604180',
                name: '网红奶茶',
                id: '123_1031468355141263412',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '1',
                rootId: '1134885965492412506',
                name: '消费水平分布',
                id: '36_30318659199849769',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1800
            },
            {
                depth: '2',
                rootId: '1008936270543454330',
                name: '涮肉',
                id: '132_1045507004375761004',
                isleaf: '0',
                type: 'Food.Dish',
                group: 8
            },
            {
                depth: '1',
                rootId: '1008936270543454330',
                name: '附近餐厅',
                id: '132_30318881596393430',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 2100
            },
            {
                depth: '1',
                rootId: '1063129407759102074',
                name: '用户常驻城市',
                id: '106_30318823181985722',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1900
            },
            {
                depth: '2',
                rootId: '1008938927878324362',
                name: '35-45岁 38%',
                id: '42_30318672050542604',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1700
            },
            {
                depth: '2',
                rootId: '1008937110784213055',
                name: '小吃',
                id: '58_1031468354814115900',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '2',
                rootId: '1008937365227454569',
                name: '撸串圣地 7%',
                id: '24_30318628987164715',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1500
            },
            {
                depth: '2',
                rootId: '1008936853832765530',
                name: '性价比高',
                id: '37_1031468354814115949',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '2',
                rootId: '1008938620507164753',
                name: '北京市:北京 88%',
                id: '57_30318711832014948',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1900
            },
            {
                depth: '2',
                rootId: '1008939929524265093',
                name: '北京市:北京 96%',
                id: '47_30318686391028111',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1900
            },
            {
                depth: '1',
                rootId: '1008939929524265093',
                name: '性别分布',
                id: '47_30318684795044301',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1600
            },
            {
                depth: '2',
                rootId: '1141762677031338067',
                name: '土豪 50%',
                id: '38_30318662884637805',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1000
            },
            {
                depth: '1',
                rootId: '1008938620507164753',
                name: '年龄分布',
                id: '57_30318710020423721',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1700
            },
            {
                depth: '2',
                rootId: '1063129407759102074',
                name: '北京市:北京 100%',
                id: '106_30318823182032805',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1900
            },
            {
                depth: '2',
                rootId: '1008937110784213055',
                name: '麻辣',
                id: '58_1031468355271299221',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '2',
                rootId: '1008937365227454569',
                name: '女 62%',
                id: '24_30318629023027875',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1600
            },
            {
                depth: '2',
                rootId: '1008936853832765530',
                name: '上菜快',
                id: '37_1031468354373709836',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '2',
                rootId: '1008936270543454330',
                name: '午餐',
                id: '132_1031468354713464875',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '1',
                rootId: '1063129407759102074',
                name: '性别分布',
                id: '106_30318822558298561',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1600
            },
            {
                depth: '2',
                rootId: '1008937987695734905',
                name: '撸串圣地 16%',
                id: '44_30318677043523427',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1500
            },
            {
                depth: '2',
                rootId: '1008937987695734905',
                name: '火锅小料',
                id: '44_1045506576053493867',
                isleaf: '0',
                type: 'Food.Dish',
                group: 5
            },
            {
                depth: '2',
                rootId: '1008936196505604180',
                name: '北京市:北京 100%',
                id: '123_30318860408379275',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1900
            },
            {
                depth: '2',
                rootId: '1008938620507164753',
                name: '价格高',
                id: '57_1031468354373709887',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '1',
                rootId: '1088493651933266052',
                name: '年龄分布',
                id: '117_30318845804384665',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1700
            },
            {
                depth: '2',
                rootId: '1008936832483758197',
                name: '上菜快',
                id: '9_1031468354373709836',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '2',
                rootId: '1008937365227454569',
                name: '午餐',
                id: '24_1031468354713464875',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '2',
                rootId: '1008938927878324362',
                name: '土豪 3%',
                id: '42_30318672056626579',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1000
            },
            {
                depth: '2',
                rootId: '1008937987695734905',
                name: '服务热情',
                id: '44_1031468354918940782',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '2',
                rootId: '1008937365227454569',
                name: '北京菜',
                id: '24_1031468354713464871',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '2',
                rootId: '1063129407759102074',
                name: '实惠 19%',
                id: '106_30318822409887452',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1000
            },
            {
                depth: '2',
                rootId: '1008936853832765530',
                name: '快速方便 10%',
                id: '37_30318660663182606',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1500
            },
            {
                depth: '2',
                rootId: '1008936832483758197',
                name: '菜品精致',
                id: '9_1031468355271299168',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '2',
                rootId: '1008937110784213055',
                name: '排骨汤',
                id: '58_1007588124374618402',
                isleaf: '0',
                type: 'Food.Dish',
                group: 7
            },
            {
                depth: '2',
                rootId: '1008937110784213055',
                name: '杨枝甘露',
                id: '58_1007588124374618401',
                isleaf: '0',
                type: 'Food.Dish',
                group: 8
            },
            {
                depth: '2',
                rootId: '1008936196505604180',
                name: '食材新鲜',
                id: '123_1031468355367759972',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '2',
                rootId: '1008937110784213055',
                name: '四川小笼包',
                id: '58_1007588124374618404',
                isleaf: '0',
                type: 'Food.Dish',
                group: 10
            },
            {
                depth: '2',
                rootId: '1008936196505604180',
                name: '江湖毛血旺',
                id: '123_1065645408904077352',
                isleaf: '0',
                type: 'Food.Dish',
                group: 4
            },
            {
                depth: '2',
                rootId: '1008936154810036313',
                name: '上海市:上海 6%',
                id: '30318565081753571',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1900
            },
            {
                depth: '2',
                rootId: '1134885965492412506',
                name: '肉丝鸡蛋炒河粉',
                id: '36_1135224773077368912',
                isleaf: '0',
                type: 'Food.Dish',
                group: 7
            },
            {
                depth: '2',
                rootId: '1008936270543454330',
                name: '45岁以上 7%',
                id: '132_30318880886129760',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1700
            },
            {
                depth: '2',
                rootId: '1008938620507164753',
                name: '女 73%',
                id: '57_30318710173771103',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1600
            },
            {
                depth: '2',
                rootId: '1008939929524265093',
                name: '普通 43%',
                id: '47_30318684637028452',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1000
            },
            {
                depth: '2',
                rootId: '1008938620507164753',
                name: '亲子餐厅',
                id: '57_1031468354373709875',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '2',
                rootId: '1008938620507164753',
                name: '卤肉饭',
                id: '57_1045507282290356327',
                isleaf: '0',
                type: 'Food.Dish',
                group: 3
            },
            {
                depth: '2',
                rootId: '1008937365227454569',
                name: '菜品不错',
                id: '24_1031468355271299158',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '2',
                rootId: '1008939929524265093',
                name: '价格实惠',
                id: '47_1031468354373709885',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '2',
                rootId: '1008939929524265093',
                name: '亲子餐厅',
                id: '47_1031468354373709875',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '2',
                rootId: '1008938620507164753',
                name: '实惠 6%',
                id: '57_30318710025079581',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1000
            },
            {
                depth: '0',
                rootId: '1008936853832765530',
                name: '峨嵋酒家（牡丹园店）',
                id: '1008936853832765530',
                isleaf: '0',
                type: 'Organization.POI',
                group: 1
            },
            {
                depth: '2',
                rootId: '1008936270543454330',
                name: '环境一般',
                id: '132_1031468355036397660',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '2',
                rootId: '1008936270543454330',
                name: '环境吵闹',
                id: '132_1031468355036397662',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '0',
                rootId: '1008938927878324362',
                name: '花家怡园（四合院总店）',
                id: '1008938927878324362',
                isleaf: '0',
                type: 'Organization.POI',
                group: 1
            },
            {
                depth: '1',
                rootId: '1008937365227454569',
                name: '推荐菜',
                id: '24_30318628048539203',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 900
            },
            {
                depth: '2',
                rootId: '1008936270543454330',
                name: '环境优雅',
                id: '132_1031468355036397661',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '2',
                rootId: '1008938927878324362',
                name: '撸串圣地 11%',
                id: '42_30318672126569332',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1500
            },
            {
                depth: '2',
                rootId: '1008936853832765530',
                name: '美味蛋挞',
                id: '37_1007587721784332383',
                isleaf: '0',
                type: 'Food.Dish',
                group: 12
            },
            {
                depth: '2',
                rootId: '1008938927878324362',
                name: '广东省:广州 1%',
                id: '42_30318673760411576',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1900
            },
            {
                depth: '2',
                rootId: '1008937987695734905',
                name: '环境优雅 14%',
                id: '44_30318677070779917',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1500
            },
            {
                depth: '0',
                rootId: '1008939929524265093',
                name: '川府热盆景',
                id: '1008939929524265093',
                isleaf: '0',
                type: 'Organization.POI',
                group: 1
            },
            {
                depth: '2',
                rootId: '1008938620507164753',
                name: '45岁以上 6%',
                id: '57_30318710020596223',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1700
            },
            {
                depth: '2',
                rootId: '1008938927878324362',
                name: '菜品精致 16%',
                id: '42_30318672094708104',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1500
            },
            {
                depth: '2',
                rootId: '1008937987695734905',
                name: '紫龙招牌老肉片',
                id: '44_1007588293245665342',
                isleaf: '0',
                type: 'Food.Dish',
                group: 9
            },
            {
                depth: '2',
                rootId: '1008936270543454330',
                name: '上海市:上海 5%',
                id: '132_30318882577237945',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1900
            },
            {
                depth: '2',
                rootId: '1063129407759102074',
                name: '猪蹄',
                id: '106_1115655665243652244',
                isleaf: '0',
                type: 'Food.Dish',
                group: 4
            },
            {
                depth: '2',
                rootId: '1008936853832765530',
                name: '宫保鸡丁',
                id: '37_1007587721729831072',
                isleaf: '0',
                type: 'Food.Dish',
                group: 4
            },
            {
                depth: '2',
                rootId: '1008937365227454569',
                name: '上菜快',
                id: '24_1031468354373709836',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '2',
                rootId: '1008936853832765530',
                name: '鸡丝凉面',
                id: '37_1007587721729831074',
                isleaf: '0',
                type: 'Food.Dish',
                group: 7
            },
            {
                depth: '2',
                rootId: '1008939929524265093',
                name: '老字号 9%',
                id: '47_30318684729974860',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1500
            },
            {
                depth: '2',
                rootId: '1008936853832765530',
                name: '精品宫保鸡丁',
                id: '37_1007587721729831076',
                isleaf: '0',
                type: 'Food.Dish',
                group: 10
            },
            {
                depth: '1',
                rootId: '1008936196505604180',
                name: '标签',
                id: '123_30318859762596987',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '2',
                rootId: '1008936832483758197',
                name: '聚餐',
                id: '9_1031468355141263428',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '2',
                rootId: '1008937110784213055',
                name: '45岁以上 20%',
                id: '58_30318712631312041',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1700
            },
            {
                depth: '2',
                rootId: '1008936196505604180',
                name: '普通 40%',
                id: '123_30318858704086459',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1000
            },
            {
                depth: '2',
                rootId: '1008936154810036313',
                name: '45岁以上 19%',
                id: '30318563174134008',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1700
            },
            {
                depth: '2',
                rootId: '1008937365227454569',
                name: '菜品精致 18%',
                id: '24_30318628899950559',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1500
            },
            {
                depth: '2',
                rootId: '1141762677031338067',
                name: '快速方便 11%',
                id: '38_30318662889302392',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1500
            },
            {
                depth: '2',
                rootId: '1008937987695734905',
                name: '冰粉',
                id: '44_1007588293245665353',
                isleaf: '0',
                type: 'Food.Dish',
                group: 10
            },
            {
                depth: '1',
                rootId: '1008937085891010634',
                name: '用户常驻城市',
                id: '77_30318760158216253',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1900
            },
            {
                depth: '2',
                rootId: '1008936853832765530',
                name: '亲子餐厅',
                id: '37_1031468354373709875',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '2',
                rootId: '1008936853832765530',
                name: '35-45岁 38%',
                id: '37_30318660590460573',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1700
            },
            {
                depth: '2',
                rootId: '1008936832483758197',
                name: '午餐',
                id: '9_1031468354713464875',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '2',
                rootId: '1008938620507164753',
                name: '高档 16%',
                id: '57_30318710025083825',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1000
            },
            {
                depth: '2',
                rootId: '1088493651933266052',
                name: '味道赞',
                id: '117_1031468354713464917',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '2',
                rootId: '1134885965492412506',
                name: '肉丝鸡蛋炒饭',
                id: '36_1135224736695980126',
                isleaf: '1',
                type: 'Food.Dish',
                group: 12
            },
            {
                depth: '2',
                rootId: '1008936853832765530',
                name: '担担面',
                id: '37_1007587721729831084',
                isleaf: '0',
                type: 'Food.Dish',
                group: 8
            },
            {
                depth: '2',
                rootId: '1008937110784213055',
                name: '土豪 3%',
                id: '58_30318712639342655',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1000
            },
            {
                depth: '2',
                rootId: '1008936853832765530',
                name: '樟茶鸭',
                id: '37_1007587721729831088',
                isleaf: '0',
                type: 'Food.Dish',
                group: 11
            },
            {
                depth: '2',
                rootId: '1063129407759102074',
                name: '藕片',
                id: '106_1125440153767129159',
                isleaf: '1',
                type: 'Food.Dish',
                group: 8
            },
            {
                depth: '1',
                rootId: '1008936154810036313',
                name: '消费水平分布',
                id: '30318563179951520',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1800
            },
            {
                depth: '2',
                rootId: '1008936154810036313',
                name: '老字号 6%',
                id: '30318563313464049',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1500
            },
            {
                depth: '2',
                rootId: '1008936853832765530',
                name: '毛血旺',
                id: '37_1007587721729831080',
                isleaf: '0',
                type: 'Food.Dish',
                group: 3
            },
            {
                depth: '1',
                rootId: '1008937987695734905',
                name: '用户常驻城市',
                id: '44_30318678799108160',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1900
            },
            {
                depth: '2',
                rootId: '1008937085891010634',
                name: '快速方便 9%',
                id: '77_30318758586323171',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1500
            },
            {
                depth: '2',
                rootId: '1141762677031338067',
                name: '炒饼',
                id: '38_1142106917338914928',
                isleaf: '0',
                type: 'Food.Dish',
                group: 3
            },
            {
                depth: '2',
                rootId: '1008937987695734905',
                name: '菜品健康',
                id: '44_1031468355271299163',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '2',
                rootId: '1008938927878324362',
                name: '小资 41%',
                id: '42_30318672056631719',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1000
            },
            {
                depth: '2',
                rootId: '1008939929524265093',
                name: '35-45岁 30%',
                id: '47_30318684629924606',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1700
            },
            {
                depth: '2',
                rootId: '1008937987695734905',
                name: '上菜快',
                id: '44_1031468354373709836',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '2',
                rootId: '1134885965492412506',
                name: '肚丝炒面',
                id: '36_1135224824042389571',
                isleaf: '0',
                type: 'Food.Dish',
                group: 11
            },
            {
                depth: '2',
                rootId: '1008936853832765530',
                name: '酸辣汤',
                id: '37_1007587721729831094',
                isleaf: '0',
                type: 'Food.Dish',
                group: 5
            },
            {
                depth: '2',
                rootId: '1008936853832765530',
                name: '老字号',
                id: '37_1031468355141263424',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '2',
                rootId: '1008938620507164753',
                name: '网红奶茶',
                id: '57_1031468355141263412',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '2',
                rootId: '1008938620507164753',
                name: '网红店',
                id: '57_1031468355141263413',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '1',
                rootId: '1008938620507164753',
                name: '性别分布',
                id: '57_30318710173746161',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1600
            },
            {
                depth: '1',
                rootId: '1088493651933266052',
                name: '性别分布',
                id: '117_30318845860184239',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1600
            },
            {
                depth: '2',
                rootId: '1008936853832765530',
                name: '聚餐',
                id: '37_1031468355141263428',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '1',
                rootId: '1063129407759102074',
                name: '相似餐厅',
                id: '106_30318822558332324',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 2000
            },
            {
                depth: '2',
                rootId: '1008936196505604180',
                name: '环境一般',
                id: '123_1031468355036397660',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '2',
                rootId: '1008936196505604180',
                name: '环境优雅',
                id: '123_1031468355036397661',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '2',
                rootId: '1008936196505604180',
                name: '环境吵闹',
                id: '123_1031468355036397662',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '1',
                rootId: '1008937365227454569',
                name: '用户常驻城市',
                id: '24_30318630743349357',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1900
            },
            {
                depth: '2',
                rootId: '1008937987695734905',
                name: '素食自助餐',
                id: '44_1031468355141263403',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '2',
                rootId: '1008936196505604180',
                name: '高人气',
                id: '123_1031468355367759987',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '2',
                rootId: '1008939929524265093',
                name: '上菜快',
                id: '47_1031468354373709836',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '2',
                rootId: '1008937987695734905',
                name: '猪蹄',
                id: '44_1007588293245665382',
                isleaf: '0',
                type: 'Food.Dish',
                group: 3
            },
            {
                depth: '1',
                rootId: '1008936154810036313',
                name: '性别分布',
                id: '30318563348637083',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1600
            },
            {
                depth: '2',
                rootId: '1008937365227454569',
                name: '环境优雅 10%',
                id: '24_30318628959941632',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1500
            },
            {
                depth: '2',
                rootId: '1008937365227454569',
                name: '服务热情',
                id: '24_1031468354918940782',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '1',
                rootId: '1141762677031338067',
                name: '标签',
                id: '38_30318663390583594',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '2',
                rootId: '1008939929524265093',
                name: '酸菜鱼',
                id: '47_1007588218314432572',
                isleaf: '0',
                type: 'Food.Dish',
                group: 7
            },
            {
                depth: '2',
                rootId: '1141762677031338067',
                name: '25-35岁 100%',
                id: '38_30318662879276958',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1700
            },
            {
                depth: '2',
                rootId: '1134885965492412506',
                name: '25-35岁 71%',
                id: '36_30318659193493739',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1700
            },
            {
                depth: '2',
                rootId: '1134885965492412506',
                name: '男 71%',
                id: '36_30318659354333879',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1600
            },
            {
                depth: '2',
                rootId: '1008936196505604180',
                name: '酸辣',
                id: '123_1031468355271299238',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '1',
                rootId: '1141762677031338067',
                name: '年龄分布',
                id: '38_30318662879049997',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1700
            },
            {
                depth: '2',
                rootId: '1008937365227454569',
                name: '菜品精致',
                id: '24_1031468355271299168',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '1',
                rootId: '1008938620507164753',
                name: '相似餐厅',
                id: '57_30318710173775951',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 2000
            },
            {
                depth: '2',
                rootId: '1008937987695734905',
                name: '小资 41%',
                id: '44_30318677038297305',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1000
            },
            {
                depth: '2',
                rootId: '1008937365227454569',
                name: '网红奶茶',
                id: '24_1031468355141263412',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '2',
                rootId: '1008939929524265093',
                name: '无辣不欢 9%',
                id: '47_30318684761237635',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1500
            },
            {
                depth: '2',
                rootId: '1008937987695734905',
                name: '菜品不错',
                id: '44_1031468355271299158',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '1',
                rootId: '1134885965492412506',
                name: '用户常驻城市',
                id: '36_30318659796987542',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1900
            },
            {
                depth: '2',
                rootId: '1008936270543454330',
                name: '味道赞',
                id: '132_1031468354713464917',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '2',
                rootId: '1008937110784213055',
                name: '普通 37%',
                id: '58_30318712639339009',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1000
            },
            {
                depth: '0',
                rootId: '1008936196505604180',
                name: '龙人居·水煮三峡鱼（南礼士路店）',
                id: '1008936196505604180',
                isleaf: '0',
                type: 'Organization.POI',
                group: 1
            },
            {
                depth: '2',
                rootId: '1008937365227454569',
                name: '亲子餐厅',
                id: '24_1031468354373709875',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '2',
                rootId: '1008936196505604180',
                name: '午餐',
                id: '123_1031468354713464875',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '1',
                rootId: '1008937110784213055',
                name: '附近餐厅',
                id: '58_30318713366387335',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 2100
            },
            {
                depth: '2',
                rootId: '1008936196505604180',
                name: '麻辣',
                id: '123_1031468355271299221',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '2',
                rootId: '1008939929524265093',
                name: '女 67%',
                id: '47_30318684795096583',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1600
            },
            {
                depth: '2',
                rootId: '1008938927878324362',
                name: '花家月饼',
                id: '42_1007588095693979790',
                isleaf: '0',
                type: 'Food.Dish',
                group: 3
            },
            {
                depth: '2',
                rootId: '1008936853832765530',
                name: '糖醋排骨',
                id: '37_1045506345928814674',
                isleaf: '0',
                type: 'Food.Dish',
                group: 6
            },
            {
                depth: '2',
                rootId: '1008937987695734905',
                name: '性价比高',
                id: '44_1031468354814115949',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '2',
                rootId: '1008937085891010634',
                name: '无辣不欢 9%',
                id: '77_30318758614365964',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1500
            },
            {
                depth: '2',
                rootId: '1008937987695734905',
                name: '快速方便',
                id: '44_1031468354814115945',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '2',
                rootId: '1008937365227454569',
                name: '芥末',
                id: '24_1031468355141263447',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '2',
                rootId: '1008936196505604180',
                name: '土豪 3%',
                id: '123_30318858704092269',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1000
            },
            {
                depth: '2',
                rootId: '1008937365227454569',
                name: '双皮奶',
                id: '24_1044629373002477649',
                isleaf: '0',
                type: 'Food.Dish',
                group: 3
            },
            {
                depth: '2',
                rootId: '1063129407759102074',
                name: '女 54%',
                id: '106_30318822558321871',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1600
            },
            {
                depth: '2',
                rootId: '1008936154810036313',
                name: '浙江省:杭州 1%',
                id: '30318565081779797',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1900
            },
            {
                depth: '2',
                rootId: '1008937365227454569',
                name: '16-25岁 10%',
                id: '24_30318628861421738',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1700
            },
            {
                depth: '2',
                rootId: '1008937365227454569',
                name: '价格实惠',
                id: '24_1031468354373709885',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '2',
                rootId: '1008937085891010634',
                name: '精选餐厅',
                id: '77_1031468355141263394',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '1',
                rootId: '1088493651933266052',
                name: '相似餐厅',
                id: '117_30318845860198178',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 2000
            },
            {
                depth: '2',
                rootId: '1008936154810036313',
                name: '土豪 1%',
                id: '30318563180228065',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1000
            },
            {
                depth: '2',
                rootId: '1008939929524265093',
                name: '菜品不错',
                id: '47_1031468355271299158',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '2',
                rootId: '1008937110784213055',
                name: '鲜香',
                id: '58_1031468354713464923',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '2',
                rootId: '1008937987695734905',
                name: '土豪 2%',
                id: '44_30318677038294214',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1000
            },
            {
                depth: '1',
                rootId: '1008939929524265093',
                name: '推荐菜',
                id: '47_30318683945516956',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 900
            },
            {
                depth: '2',
                rootId: '1008937085891010634',
                name: '25-35岁 40%',
                id: '77_30318758486503492',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1700
            },
            {
                depth: '2',
                rootId: '1008938927878324362',
                name: '25-35岁 44%',
                id: '42_30318672050544690',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1700
            },
            {
                depth: '1',
                rootId: '1008937987695734905',
                name: '相似餐厅',
                id: '44_30318677190277586',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 2000
            },
            {
                depth: '2',
                rootId: '1008936196505604180',
                name: '弄堂小店 8%',
                id: '123_30318858795986600',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1500
            },
            {
                depth: '2',
                rootId: '1008936270543454330',
                name: '4-6人套餐',
                id: '132_1031468354369515571',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '2',
                rootId: '1008938620507164753',
                name: '25-35岁 54%',
                id: '57_30318710020599783',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1700
            },
            {
                depth: '2',
                rootId: '1008937110784213055',
                name: '菜品不错 17%',
                id: '58_30318712677478910',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1500
            },
            {
                depth: '1',
                rootId: '1088493651933266052',
                name: '推荐菜',
                id: '117_30318845295734505',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 900
            },
            {
                depth: '2',
                rootId: '1008939929524265093',
                name: '午餐',
                id: '47_1031468354713464875',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '1',
                rootId: '1008937365227454569',
                name: '环境偏好',
                id: '24_30318628867938477',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1500
            },
            {
                depth: '2',
                rootId: '1063129407759102074',
                name: '快速方便 8%',
                id: '106_30318822495827904',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1500
            },
            {
                depth: '2',
                rootId: '1008936270543454330',
                name: '广东省:广州 2%',
                id: '132_30318882577239960',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1900
            },
            {
                depth: '2',
                rootId: '1008936853832765530',
                name: '北京市:北京 100%',
                id: '37_30318662405599641',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1900
            },
            {
                depth: '1',
                rootId: '1008937365227454569',
                name: '标签',
                id: '24_30318630089422043',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '2',
                rootId: '1008936853832765530',
                name: '午餐',
                id: '37_1031468354713464875',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '2',
                rootId: '1008936196505604180',
                name: '无辣不欢 21%',
                id: '123_30318858710610348',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1500
            },
            {
                depth: '2',
                rootId: '1063129407759102074',
                name: '鸭翅',
                id: '106_1063833930769166456',
                isleaf: '0',
                type: 'Food.Dish',
                group: 10
            },
            {
                depth: '2',
                rootId: '1008938620507164753',
                name: '服务热情',
                id: '57_1031468354918940782',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '2',
                rootId: '1008936154810036313',
                name: '广东省:深圳 1%',
                id: '30318565081777116',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1900
            },
            {
                depth: '2',
                rootId: '1008936832483758197',
                name: '早餐',
                id: '9_1031468354918940740',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '2',
                rootId: '1008937365227454569',
                name: '天津市:天津 3%',
                id: '24_30318630743408329',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1900
            },
            {
                depth: '2',
                rootId: '1008938620507164753',
                name: '菜品健康 11%',
                id: '57_30318710056592530',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1500
            },
            {
                depth: '2',
                rootId: '1008936853832765530',
                name: '撸串圣地 11%',
                id: '37_30318660635787483',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1500
            },
            {
                depth: '1',
                rootId: '1008936853832765530',
                name: '用户常驻城市',
                id: '37_30318662405549137',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1900
            },
            {
                depth: '2',
                rootId: '1008936270543454330',
                name: '北京市:北京 82%',
                id: '132_30318882577235367',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1900
            },
            {
                depth: '2',
                rootId: '1008939929524265093',
                name: '服务热情',
                id: '47_1031468354918940782',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '1',
                rootId: '1088493651933266052',
                name: '标签',
                id: '117_30318846205352512',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '1',
                rootId: '1008937987695734905',
                name: '消费水平分布',
                id: '44_30318677038111520',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1800
            },
            {
                depth: '2',
                rootId: '1008937987695734905',
                name: '川菜',
                id: '44_1031468354814115910',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '2',
                rootId: '1008936270543454330',
                name: '四川省:成都 1%',
                id: '132_30318882577240945',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1900
            },
            {
                depth: '1',
                rootId: '1063129407759102074',
                name: '消费水平分布',
                id: '106_30318822409803589',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1800
            },
            {
                depth: '2',
                rootId: '1008938620507164753',
                name: '土豪 4%',
                id: '57_30318710025085681',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1000
            },
            {
                depth: '2',
                rootId: '1008936832483758197',
                name: '价格实惠',
                id: '9_1031468354373709885',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '2',
                rootId: '1008936196505604180',
                name: '男 41%',
                id: '123_30318858860200724',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1600
            },
            {
                depth: '2',
                rootId: '1008937987695734905',
                name: '嫩羊肉',
                id: '44_1045507118599303180',
                isleaf: '0',
                type: 'Food.Dish',
                group: 11
            },
            {
                depth: '2',
                rootId: '1008937365227454569',
                name: '煲仔饭',
                id: '24_1044994228268069055',
                isleaf: '0',
                type: 'Food.Dish',
                group: 7
            },
            {
                depth: '1',
                rootId: '1008937987695734905',
                name: '推荐菜',
                id: '44_30318676383519339',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 900
            },
            {
                depth: '1',
                rootId: '1008937365227454569',
                name: '性别分布',
                id: '24_30318629022970160',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1600
            },
            {
                depth: '2',
                rootId: '1141762677031338067',
                name: '无肉不欢 11%',
                id: '38_30318662979600607',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1500
            },
            {
                depth: '2',
                rootId: '1008938620507164753',
                name: '16-25岁 12%',
                id: '57_30318710020586437',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1700
            },
            {
                depth: '2',
                rootId: '1008936270543454330',
                name: '高人气',
                id: '132_1031468355367759987',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '2',
                rootId: '1008939929524265093',
                name: '网红奶茶',
                id: '47_1031468355141263412',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '2',
                rootId: '1134885965492412506',
                name: '环境优雅 8%',
                id: '36_30318659265890713',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1500
            },
            {
                depth: '2',
                rootId: '1008938620507164753',
                name: '萃藻绿豆糕',
                id: '57_1073980735330726037',
                isleaf: '0',
                type: 'Food.Dish',
                group: 8
            },
            {
                depth: '2',
                rootId: '1008937110784213055',
                name: '35-45岁 42%',
                id: '58_30318712631319904',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1700
            },
            {
                depth: '2',
                rootId: '1008937365227454569',
                name: '腊八粥',
                id: '24_1044994228268069052',
                isleaf: '0',
                type: 'Food.Dish',
                group: 11
            },
            {
                depth: '2',
                rootId: '1008936853832765530',
                name: '男 39%',
                id: '37_30318660763312555',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1600
            },
            {
                depth: '2',
                rootId: '1008936832483758197',
                name: '亲子餐厅',
                id: '9_1031468354373709875',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '1',
                rootId: '1008936154810036313',
                name: '附近餐厅',
                id: '30318564006786556',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 2100
            },
            {
                depth: '2',
                rootId: '1008936832483758197',
                name: '北京市:北京 98%',
                id: '9_30318591530290502',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1900
            },
            {
                depth: '2',
                rootId: '1008936196505604180',
                name: '水煮三峡鱼',
                id: '123_1007587597830103160',
                isleaf: '0',
                type: 'Food.Dish',
                group: 5
            },
            {
                depth: '2',
                rootId: '1008938927878324362',
                name: '鲜香',
                id: '42_1031468355036397638',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '2',
                rootId: '1008938620507164753',
                name: '上菜快',
                id: '57_1031468354373709836',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '2',
                rootId: '1008937110784213055',
                name: '女 67%',
                id: '58_30318712805544783',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1600
            },
            {
                depth: '2',
                rootId: '1008938620507164753',
                name: '小吃',
                id: '57_1031468354814115900',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '1',
                rootId: '1063129407759102074',
                name: '环境偏好',
                id: '106_30318822409894371',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1500
            },
            {
                depth: '2',
                rootId: '1008936196505604180',
                name: '担担面',
                id: '123_1034848705309589601',
                isleaf: '0',
                type: 'Food.Dish',
                group: 12
            },
            {
                depth: '2',
                rootId: '1008936270543454330',
                name: '食材新鲜',
                id: '132_1031468355367759972',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '2',
                rootId: '1008939929524265093',
                name: '上海市:上海 2%',
                id: '47_30318686391034125',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1900
            },
            {
                depth: '2',
                rootId: '1008937365227454569',
                name: '卤煮火烧',
                id: '24_1045506355219157051',
                isleaf: '0',
                type: 'Food.Dish',
                group: 5
            },
            {
                depth: '2',
                rootId: '1008938620507164753',
                name: '晚餐',
                id: '57_1031468354918940743',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '1',
                rootId: '1008937110784213055',
                name: '年龄分布',
                id: '58_30318712631137454',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1700
            },
            {
                depth: '2',
                rootId: '1008938620507164753',
                name: '早餐',
                id: '57_1031468354918940740',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '2',
                rootId: '1008937085891010634',
                name: '男 36%',
                id: '77_30318758648704148',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1600
            },
            {
                depth: '2',
                rootId: '1008936832483758197',
                name: '菜品不错',
                id: '9_1031468355271299158',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '2',
                rootId: '1063129407759102074',
                name: '撸串圣地 14%',
                id: '106_30318822441992036',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1500
            },
            {
                depth: '2',
                rootId: '1141762677031338067',
                name: '凉皮',
                id: '38_1142106922103664740',
                isleaf: '0',
                type: 'Food.Dish',
                group: 5
            },
            {
                depth: '2',
                rootId: '1008937085891010634',
                name: '辣子鸡丁',
                id: '77_1045506299531378791',
                isleaf: '0',
                type: 'Food.Dish',
                group: 11
            },
            {
                depth: '2',
                rootId: '1008936270543454330',
                name: '女 51%',
                id: '132_30318881046230851',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1600
            },
            {
                depth: '2',
                rootId: '1008936832483758197',
                name: '服务热情',
                id: '9_1031468354918940782',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '2',
                rootId: '1008936270543454330',
                name: '火锅',
                id: '132_1031468355036397629',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '2',
                rootId: '1141762677031338067',
                name: '炒河粉',
                id: '38_1142106924007841929',
                isleaf: '0',
                type: 'Food.Dish',
                group: 11
            },
            {
                depth: '2',
                rootId: '1008936270543454330',
                name: '普通 43%',
                id: '132_30318880892322635',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1000
            },
            {
                depth: '2',
                rootId: '1008936832483758197',
                name: '高档 8%',
                id: '9_30318589833707635',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1000
            },
            {
                depth: '2',
                rootId: '1008937365227454569',
                name: '油爆虾',
                id: '24_1044994228268069031',
                isleaf: '0',
                type: 'Food.Dish',
                group: 9
            },
            {
                depth: '2',
                rootId: '1008937365227454569',
                name: '土豪 2%',
                id: '24_30318628867929517',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1000
            },
            {
                depth: '2',
                rootId: '1008937110784213055',
                name: '精选餐厅',
                id: '58_1031468355141263394',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '1',
                rootId: '1008936832483758197',
                name: '消费水平分布',
                id: '9_30318589833557800',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1800
            },
            {
                depth: '1',
                rootId: '1008938620507164753',
                name: '附近餐厅',
                id: '57_30318710787402799',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 2100
            },
            {
                depth: '1',
                rootId: '1008936853832765530',
                name: '消费水平分布',
                id: '37_30318660598555730',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1800
            },
            {
                depth: '2',
                rootId: '1008937110784213055',
                name: '粤式早茶',
                id: '58_1031468355141263390',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '2',
                rootId: '1008937987695734905',
                name: '男 37%',
                id: '44_30318677190265782',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1600
            },
            {
                depth: '2',
                rootId: '1008936832483758197',
                name: '快速方便',
                id: '9_1031468354814115945',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '2',
                rootId: '1008939929524265093',
                name: '土豪 2%',
                id: '47_30318684637026419',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1000
            },
            {
                depth: '2',
                rootId: '1088493651933266052',
                name: '食材新鲜',
                id: '117_1031468355367759972',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '2',
                rootId: '1008936832483758197',
                name: '性价比高',
                id: '9_1031468354814115949',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '2',
                rootId: '1008938927878324362',
                name: '免费点心',
                id: '42_1031468354373709905',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '1',
                rootId: '1008936270543454330',
                name: '性别分布',
                id: '132_30318881046203248',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1600
            },
            {
                depth: '2',
                rootId: '1008937365227454569',
                name: '小资 35%',
                id: '24_30318628867931816',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1000
            },
            {
                depth: '1',
                rootId: '1008938927878324362',
                name: '年龄分布',
                id: '42_30318672050275115',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1700
            },
            {
                depth: '1',
                rootId: '1088493651933266052',
                name: '消费水平分布',
                id: '117_30318845812671410',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1800
            },
            {
                depth: '2',
                rootId: '1008936270543454330',
                name: '环境优雅 10%',
                id: '132_30318880984159682',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1500
            },
            {
                depth: '2',
                rootId: '1088493651933266052',
                name: '韭菜鸡蛋馅饼',
                id: '117_1126165042316742802',
                isleaf: '0',
                type: 'Food.Dish',
                group: 8
            },
            {
                depth: '2',
                rootId: '1008937085891010634',
                name: '风味云腿月饼',
                id: '77_1007587633792045222',
                isleaf: '0',
                type: 'Food.Dish',
                group: 10
            },
            {
                depth: '2',
                rootId: '1008937365227454569',
                name: '创意菜品',
                id: '24_1031468354713464862',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '2',
                rootId: '1008936270543454330',
                name: '麻辣',
                id: '132_1031468355271299221',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '2',
                rootId: '1008936853832765530',
                name: '高档 8%',
                id: '37_30318660598794383',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1000
            },
            {
                depth: '2',
                rootId: '1008936832483758197',
                name: '鸿运年糕',
                id: '9_1007587853347070144',
                isleaf: '0',
                type: 'Food.Dish',
                group: 9
            },
            {
                depth: '2',
                rootId: '1008938927878324362',
                name: '朋友聚餐',
                id: '42_1031468354918940778',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '2',
                rootId: '1008936196505604180',
                name: '价格高',
                id: '123_1031468354373709887',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '2',
                rootId: '1008936832483758197',
                name: '男 40%',
                id: '9_30318589991237399',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1600
            },
            {
                depth: '2',
                rootId: '1008937365227454569',
                name: '35-45岁 32%',
                id: '24_30318628861418297',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1700
            },
            {
                depth: '2',
                rootId: '1008938620507164753',
                name: '味道赞',
                id: '57_1031468354713464917',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '2',
                rootId: '1008936853832765530',
                name: '高人气',
                id: '37_1031468355367759987',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '2',
                rootId: '1088493651933266052',
                name: '豆沙包',
                id: '117_1107318961814380666',
                isleaf: '0',
                type: 'Food.Dish',
                group: 12
            },
            {
                depth: '2',
                rootId: '1008937987695734905',
                name: '精选餐厅',
                id: '44_1031468355141263394',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '2',
                rootId: '1063129407759102074',
                name: '常推新菜',
                id: '106_1031468354814115921',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '2',
                rootId: '1008938927878324362',
                name: '甜味',
                id: '42_1031468355036397670',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '2',
                rootId: '1008939929524265093',
                name: '25-35岁 56%',
                id: '47_30318684629929897',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1700
            },
            {
                depth: '2',
                rootId: '1008936853832765530',
                name: '鲜香',
                id: '37_1031468354713464923',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '2',
                rootId: '1008938927878324362',
                name: '有舞台表演',
                id: '42_1031468354918940768',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '1',
                rootId: '1008938620507164753',
                name: '推荐菜',
                id: '57_30318709393223438',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 900
            },
            {
                depth: '2',
                rootId: '1008936832483758197',
                name: '天津市:天津 1%',
                id: '9_30318591530296387',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1900
            },
            {
                depth: '2',
                rootId: '1008937085891010634',
                name: '味道赞',
                id: '77_1031468354713464917',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '2',
                rootId: '1088493651933266052',
                name: '酸豆角肉包',
                id: '117_1126165122646061126',
                isleaf: '1',
                type: 'Food.Dish',
                group: 6
            },
            {
                depth: '2',
                rootId: '1008937365227454569',
                name: '精选餐厅',
                id: '24_1031468355141263394',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '2',
                rootId: '1008937987695734905',
                name: '食材新鲜 13%',
                id: '44_30318677098517739',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1500
            },
            {
                depth: '1',
                rootId: '1008937365227454569',
                name: '附近餐厅',
                id: '24_30318629682558124',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 2100
            },
            {
                depth: '1',
                rootId: '1008938927878324362',
                name: '推荐菜',
                id: '42_30318671260486534',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 900
            },
            {
                depth: '2',
                rootId: '1141762677031338067',
                name: '砂锅酸辣米线',
                id: '38_1142106917439561893',
                isleaf: '1',
                type: 'Food.Dish',
                group: 8
            },
            {
                depth: '2',
                rootId: '1008936832483758197',
                name: '土豪 2%',
                id: '9_30318589833719368',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1000
            },
            {
                depth: '2',
                rootId: '1008938620507164753',
                name: '高人气',
                id: '57_1031468355367759987',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '2',
                rootId: '1141762677031338067',
                name: '凉面',
                id: '38_1142106912553173105',
                isleaf: '0',
                type: 'Food.Dish',
                group: 4
            },
            {
                depth: '2',
                rootId: '1008938620507164753',
                name: '文艺清新',
                id: '57_1031468354918940716',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '2',
                rootId: '1008938620507164753',
                name: '文艺咖啡厅',
                id: '57_1031468354918940715',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '1',
                rootId: '1008938927878324362',
                name: '消费水平分布',
                id: '42_30318672056472333',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1800
            },
            {
                depth: '2',
                rootId: '1008936270543454330',
                name: '35-45岁 19%',
                id: '132_30318880886142156',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1700
            },
            {
                depth: '2',
                rootId: '1008936853832765530',
                name: '环境优雅 9%',
                id: '37_30318660694785143',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1500
            },
            {
                depth: '2',
                rootId: '1008938927878324362',
                name: '45岁以上 12%',
                id: '42_30318672050532075',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1700
            },
            {
                depth: '2',
                rootId: '1141762677031338067',
                name: '炒牛筋面',
                id: '38_1142106920614658078',
                isleaf: '1',
                type: 'Food.Dish',
                group: 7
            },
            {
                depth: '1',
                rootId: '1008936270543454330',
                name: '环境偏好',
                id: '132_30318880892331669',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1500
            },
            {
                depth: '2',
                rootId: '1008937085891010634',
                name: '鲜香',
                id: '77_1031468354713464923',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '2',
                rootId: '1008938927878324362',
                name: '八旗小羊排',
                id: '42_1007588095656239244',
                isleaf: '0',
                type: 'Food.Dish',
                group: 12
            },
            {
                depth: '2',
                rootId: '1008938927878324362',
                name: '豌豆黄',
                id: '42_1007588095656239243',
                isleaf: '0',
                type: 'Food.Dish',
                group: 6
            },
            {
                depth: '0',
                rootId: '1008937987695734905',
                name: '紫龍火锅（富力广场店）',
                id: '1008937987695734905',
                isleaf: '0',
                type: 'Organization.POI',
                group: 1
            },
            {
                depth: '2',
                rootId: '1008938927878324362',
                name: '香辣蟹',
                id: '42_1007588095656239241',
                isleaf: '0',
                type: 'Food.Dish',
                group: 7
            },
            {
                depth: '1',
                rootId: '1008936853832765530',
                name: '环境偏好',
                id: '37_30318660598804604',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1500
            },
            {
                depth: '2',
                rootId: '1008938927878324362',
                name: '宫保鸡丁',
                id: '42_1007588095656239245',
                isleaf: '0',
                type: 'Food.Dish',
                group: 11
            },
            {
                depth: '2',
                rootId: '1008936853832765530',
                name: '女 61%',
                id: '37_30318660763316933',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1600
            },
            {
                depth: '1',
                rootId: '1008936154810036313',
                name: '年龄分布',
                id: '30318563159461703',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1700
            },
            {
                depth: '1',
                rootId: '1008937085891010634',
                name: '相似餐厅',
                id: '77_30318758648722385',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 2000
            },
            {
                depth: '2',
                rootId: '1008936270543454330',
                name: '火锅',
                id: '132_1007587654646104147',
                isleaf: '0',
                type: 'Food.Dish',
                group: 3
            },
            {
                depth: '2',
                rootId: '1008938620507164753',
                name: '深夜食堂',
                id: '57_1031468355036397607',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '2',
                rootId: '1008937987695734905',
                name: '北京市:北京 98%',
                id: '44_30318678799164252',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1900
            },
            {
                depth: '1',
                rootId: '1008937365227454569',
                name: '相似餐厅',
                id: '24_30318629023033551',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 2000
            },
            {
                depth: '2',
                rootId: '1008936832483758197',
                name: '女 60%',
                id: '9_30318589991241624',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1600
            },
            {
                depth: '2',
                rootId: '1008938927878324362',
                name: '四合院',
                id: '42_1031468354713464931',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '2',
                rootId: '1008936196505604180',
                name: '25-35岁 52%',
                id: '123_30318858697251970',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1700
            },
            {
                depth: '2',
                rootId: '1008937365227454569',
                name: '高档 9%',
                id: '24_30318628867933649',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1000
            },
            {
                depth: '2',
                rootId: '1008938927878324362',
                name: '环境优雅',
                id: '42_1031468355036397661',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '2',
                rootId: '1008938927878324362',
                name: '酸梅汤',
                id: '42_1007588095656239236',
                isleaf: '0',
                type: 'Food.Dish',
                group: 8
            },
            {
                depth: '2',
                rootId: '1008938927878324362',
                name: '八爷烤鸭',
                id: '42_1007588095656239235',
                isleaf: '0',
                type: 'Food.Dish',
                group: 9
            },
            {
                depth: '2',
                rootId: '1008936270543454330',
                name: '锡盟羔羊肉',
                id: '132_1007587654646104153',
                isleaf: '0',
                type: 'Food.Dish',
                group: 5
            },
            {
                depth: '2',
                rootId: '1008936154810036313',
                name: '实惠 13%',
                id: '30318563180232383',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1000
            },
            {
                depth: '2',
                rootId: '1008936270543454330',
                name: '水煮鱼',
                id: '132_1007587654646104155',
                isleaf: '0',
                type: 'Food.Dish',
                group: 12
            },
            {
                depth: '2',
                rootId: '1008938927878324362',
                name: '怡园养生佛跳墙',
                id: '42_1007588095656239238',
                isleaf: '0',
                type: 'Food.Dish',
                group: 4
            },
            {
                depth: '2',
                rootId: '1008936154810036313',
                name: '小资 36%',
                id: '30318563180236987',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1000
            },
            {
                depth: '2',
                rootId: '1008938927878324362',
                name: '宴请',
                id: '42_1031468354814115895',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '2',
                rootId: '1008936270543454330',
                name: '北京烤鸭',
                id: '132_1007587654646104150',
                isleaf: '0',
                type: 'Food.Dish',
                group: 7
            },
            {
                depth: '2',
                rootId: '1008936270543454330',
                name: '酸梅汤',
                id: '132_1007587654646104151',
                isleaf: '0',
                type: 'Food.Dish',
                group: 6
            },
            {
                depth: '0',
                rootId: '1008937110784213055',
                name: '眉州小吃（国奥村店）',
                id: '1008937110784213055',
                isleaf: '0',
                type: 'Organization.POI',
                group: 1
            },
            {
                depth: '1',
                rootId: '1008936270543454330',
                name: '推荐菜',
                id: '132_30318880111039901',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 900
            },
            {
                depth: '2',
                rootId: '1134885965492412506',
                name: '老字号 8%',
                id: '36_30318659320352894',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1500
            },
            {
                depth: '2',
                rootId: '1008936196505604180',
                name: '撸串圣地 14%',
                id: '123_30318858764613563',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1500
            },
            {
                depth: '1',
                rootId: '1008937365227454569',
                name: '年龄分布',
                id: '24_30318628861238008',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1700
            },
            {
                depth: '1',
                rootId: '1008936832483758197',
                name: '性别分布',
                id: '9_30318589991204663',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1600
            },
            {
                depth: '2',
                rootId: '1008939929524265093',
                name: '酸咸',
                id: '47_1031468355271299233',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '2',
                rootId: '1008938927878324362',
                name: '菜品不错',
                id: '42_1031468355271299158',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '2',
                rootId: '1008939929524265093',
                name: '酸辣',
                id: '47_1031468355271299238',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '2',
                rootId: '1008939929524265093',
                name: '酸甜',
                id: '47_1031468355271299236',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '2',
                rootId: '1008937987695734905',
                name: '普通 39%',
                id: '44_30318677038280415',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1000
            },
            {
                depth: '2',
                rootId: '1008938927878324362',
                name: '北京市:北京 81%',
                id: '42_30318673760386537',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1900
            },
            {
                depth: '2',
                rootId: '1008936196505604180',
                name: '原只木瓜炖雪蛤',
                id: '123_1007587597863632992',
                isleaf: '0',
                type: 'Food.Dish',
                group: 7
            },
            {
                depth: '2',
                rootId: '1008936832483758197',
                name: '环境优雅 14%',
                id: '9_30318589899064040',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1500
            },
            {
                depth: '2',
                rootId: '1008938620507164753',
                name: '普通 28%',
                id: '57_30318710025087516',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1000
            },
            {
                depth: '2',
                rootId: '1008936832483758197',
                name: '眉州小笼包',
                id: '9_1007587853347070083',
                isleaf: '0',
                type: 'Food.Dish',
                group: 4
            },
            {
                depth: '2',
                rootId: '1008936154810036313',
                name: '北京市:北京 83%',
                id: '30318565081738513',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1900
            },
            {
                depth: '2',
                rootId: '1008936853832765530',
                name: '峨嵋麻辣香锅',
                id: '37_1007587721784332413',
                isleaf: '0',
                type: 'Food.Dish',
                group: 9
            },
            {
                depth: '2',
                rootId: '1008939929524265093',
                name: '川菜',
                id: '47_1031468354814115910',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '2',
                rootId: '1008937085891010634',
                name: '上海市:上海 1%',
                id: '77_30318760158271476',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1900
            },
            {
                depth: '1',
                rootId: '1008936853832765530',
                name: '推荐菜',
                id: '37_30318659822286861',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 900
            },
            {
                depth: '2',
                rootId: '1008939929524265093',
                name: '麻辣',
                id: '47_1031468355271299221',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '1',
                rootId: '1008936154810036313',
                name: '用户常驻城市',
                id: '30318565081536274',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1900
            },
            {
                depth: '1',
                rootId: '1008936832483758197',
                name: '推荐菜',
                id: '9_30318589092591619',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 900
            },
            {
                depth: '2',
                rootId: '1141762677031338067',
                name: '高档 50%',
                id: '38_30318662884630443',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1000
            },
            {
                depth: '2',
                rootId: '1008939929524265093',
                name: '16-25岁 6%',
                id: '47_30318684629918940',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1700
            },
            {
                depth: '2',
                rootId: '1134885965492412506',
                name: '北京市:北京 88%',
                id: '36_30318659797041166',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1900
            },
            {
                depth: '2',
                rootId: '1008936853832765530',
                name: '无辣不欢 8%',
                id: '37_30318660725873435',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1500
            },
            {
                depth: '2',
                rootId: '1008938927878324362',
                name: '16-25岁 6%',
                id: '42_30318672050539981',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1700
            },
            {
                depth: '2',
                rootId: '1141762677031338067',
                name: '手冲咖啡 11%',
                id: '38_30318663008376386',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1500
            },
            {
                depth: '2',
                rootId: '1008939929524265093',
                name: '性价比高',
                id: '47_1031468354814115949',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '2',
                rootId: '1008938927878324362',
                name: '实惠 5%',
                id: '42_30318672056621220',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1000
            },
            {
                depth: '2',
                rootId: '1008938927878324362',
                name: '复古',
                id: '42_1031468354717659145',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '1',
                rootId: '1008936832483758197',
                name: '附近餐厅',
                id: '9_30318590548267588',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 2100
            },
            {
                depth: '2',
                rootId: '1008937110784213055',
                name: '味道赞',
                id: '58_1031468354713464917',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '0',
                rootId: '1088493651933266052',
                name: '巴比功夫鲜包',
                id: '1088493651933266052',
                isleaf: '0',
                type: 'Organization.POI',
                group: 1
            },
            {
                depth: '2',
                rootId: '1008937085891010634',
                name: '老坛酸菜鱼',
                id: '77_1045507111569612906',
                isleaf: '0',
                type: 'Food.Dish',
                group: 9
            },
            {
                depth: '1',
                rootId: '1134885965492412506',
                name: '环境偏好',
                id: '36_30318659200043365',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1500
            },
            {
                depth: '2',
                rootId: '1008936270543454330',
                name: '高档 5%',
                id: '132_30318880892314065',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1000
            },
            {
                depth: '1',
                rootId: '1008938927878324362',
                name: '用户常驻城市',
                id: '42_30318673760328809',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1900
            },
            {
                depth: '2',
                rootId: '1008938927878324362',
                name: '服务热情',
                id: '42_1031468354918940782',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '2',
                rootId: '1008937365227454569',
                name: '复古',
                id: '24_1031468354717659145',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '2',
                rootId: '1008936832483758197',
                name: '撸串圣地 16%',
                id: '9_30318589871282707',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1500
            },
            {
                depth: '2',
                rootId: '1008936832483758197',
                name: '深夜食堂',
                id: '9_1031468355036397607',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '1',
                rootId: '1008937987695734905',
                name: '性别分布',
                id: '44_30318677190228794',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1600
            },
            {
                depth: '2',
                rootId: '1008938620507164753',
                name: '鲜香',
                id: '57_1031468354713464923',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '2',
                rootId: '1008936270543454330',
                name: '鱼香三文鱼茄夹',
                id: '132_1007587654671294528',
                isleaf: '0',
                type: 'Food.Dish',
                group: 9
            },
            {
                depth: '2',
                rootId: '1008938927878324362',
                name: '菜品精致',
                id: '42_1031468355271299168',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '2',
                rootId: '1008938927878324362',
                name: '弄堂小店 10%',
                id: '42_30318672153873116',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1500
            },
            {
                depth: '1',
                rootId: '1141762677031338067',
                name: '消费水平分布',
                id: '38_30318662884379897',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1800
            },
            {
                depth: '2',
                rootId: '1008936270543454330',
                name: '精品烤鸭',
                id: '132_1007587654671294526',
                isleaf: '0',
                type: 'Food.Dish',
                group: 11
            },
            {
                depth: '2',
                rootId: '1008938927878324362',
                name: '高档 12%',
                id: '42_30318672056630183',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1000
            },
            {
                depth: '2',
                rootId: '1008936196505604180',
                name: '猪蹄儿',
                id: '123_1044629367428231320',
                isleaf: '0',
                type: 'Food.Dish',
                group: 9
            },
            {
                depth: '2',
                rootId: '1008938927878324362',
                name: '浙江省:杭州 1%',
                id: '42_30318673760409967',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1900
            },
            {
                depth: '2',
                rootId: '1088493651933266052',
                name: '牛肉包',
                id: '117_1126165074617061504',
                isleaf: '0',
                type: 'Food.Dish',
                group: 4
            },
            {
                depth: '2',
                rootId: '1008939929524265093',
                name: '弄堂小店 13%',
                id: '47_30318684674719586',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1500
            },
            {
                depth: '2',
                rootId: '1008937987695734905',
                name: '亲子餐厅',
                id: '44_1031468354373709875',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '1',
                rootId: '1008938927878324362',
                name: '相似餐厅',
                id: '42_30318672219932300',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 2000
            },
            {
                depth: '2',
                rootId: '1008936270543454330',
                name: '老字号',
                id: '132_1031468355141263424',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '2',
                rootId: '1008936853832765530',
                name: '菜品不错',
                id: '37_1031468355271299158',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '2',
                rootId: '1008937110784213055',
                name: '北京市:北京 98%',
                id: '58_30318714306554899',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1900
            },
            {
                depth: '2',
                rootId: '1008938620507164753',
                name: '奶茶',
                id: '57_1044629621833764964',
                isleaf: '0',
                type: 'Food.Dish',
                group: 11
            },
            {
                depth: '2',
                rootId: '1008938927878324362',
                name: '动感三文鱼',
                id: '42_1045506930048499831',
                isleaf: '0',
                type: 'Food.Dish',
                group: 5
            },
            {
                depth: '0',
                rootId: '1008936832483758197',
                name: '眉州东坡酒楼（恋日店）',
                id: '1008936832483758197',
                isleaf: '0',
                type: 'Organization.POI',
                group: 1
            },
            {
                depth: '2',
                rootId: '1008937085891010634',
                name: '服务热情',
                id: '77_1031468354918940782',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '2',
                rootId: '1008939929524265093',
                name: '天津市:天津 1%',
                id: '47_30318686391036055',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1900
            },
            {
                depth: '2',
                rootId: '1008938620507164753',
                name: '小笼包',
                id: '57_1007587945051349126',
                isleaf: '0',
                type: 'Food.Dish',
                group: 5
            },
            {
                depth: '2',
                rootId: '1008937110784213055',
                name: '早茶',
                id: '58_1031468354918940739',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '2',
                rootId: '1008937110784213055',
                name: '高人气',
                id: '58_1031468355367759987',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '2',
                rootId: '1141762677031338067',
                name: '男 80%',
                id: '38_30318663045136830',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1600
            },
            {
                depth: '2',
                rootId: '1008936853832765530',
                name: '菜品精致',
                id: '37_1031468355271299168',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '2',
                rootId: '1008937110784213055',
                name: '晚餐',
                id: '58_1031468354918940743',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '2',
                rootId: '1008937110784213055',
                name: '早餐',
                id: '58_1031468354918940740',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '2',
                rootId: '1008938620507164753',
                name: '男 27%',
                id: '57_30318710173767330',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1600
            },
            {
                depth: '2',
                rootId: '1008937365227454569',
                name: '45岁以上 13%',
                id: '24_30318628861411253',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1700
            },
            {
                depth: '2',
                rootId: '1088493651933266052',
                name: '普通 100%',
                id: '117_30318845812789167',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1000
            },
            {
                depth: '2',
                rootId: '1008936154810036313',
                name: '女 61%',
                id: '30318563348699045',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1600
            },
            {
                depth: '1',
                rootId: '1008939929524265093',
                name: '用户常驻城市',
                id: '47_30318686390959182',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1900
            },
            {
                depth: '2',
                rootId: '1008937110784213055',
                name: '糖醋排骨',
                id: '58_1007588124429123662',
                isleaf: '0',
                type: 'Food.Dish',
                group: 6
            },
            {
                depth: '2',
                rootId: '1008937085891010634',
                name: '环境优雅',
                id: '77_1031468355036397661',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '2',
                rootId: '1008937085891010634',
                name: '环境吵闹',
                id: '77_1031468355036397662',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '0',
                rootId: '1134885965492412506',
                name: '无敌炒饼（第五档口东华门美食城店）',
                id: '1134885965492412506',
                isleaf: '0',
                type: 'Organization.POI',
                group: 1
            },
            {
                depth: '2',
                rootId: '1008937110784213055',
                name: '甜水面',
                id: '58_1007588124412387408',
                isleaf: '0',
                type: 'Food.Dish',
                group: 12
            },
            {
                depth: '1',
                rootId: '1008936853832765530',
                name: '标签',
                id: '37_30318661691861798',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '0',
                rootId: '1141762677031338067',
                name: '陕西汉中风味小吃（第七档口东华门美食城店）',
                id: '1141762677031338067',
                isleaf: '0',
                type: 'Organization.POI',
                group: 1
            },
            {
                depth: '2',
                rootId: '1008937085891010634',
                name: '环境优雅 13%',
                id: '77_30318758527886528',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1500
            },
            {
                depth: '2',
                rootId: '1008937987695734905',
                name: '价格实惠',
                id: '44_1031468354373709885',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '2',
                rootId: '1008937987695734905',
                name: '味道赞',
                id: '44_1031468354713464917',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '2',
                rootId: '1008938620507164753',
                name: '炒肝',
                id: '57_1044629621833764959',
                isleaf: '0',
                type: 'Food.Dish',
                group: 7
            },
            {
                depth: '2',
                rootId: '1008936196505604180',
                name: '上菜快',
                id: '123_1031468354373709836',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '1',
                rootId: '1008936853832765530',
                name: '性别分布',
                id: '37_30318660763278313',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1600
            },
            {
                depth: '1',
                rootId: '1008936832483758197',
                name: '年龄分布',
                id: '9_30318589827805019',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1700
            },
            {
                depth: '2',
                rootId: '1008936832483758197',
                name: '传统地道毛血旺',
                id: '9_1007587853191909527',
                isleaf: '0',
                type: 'Food.Dish',
                group: 12
            },
            {
                depth: '1',
                rootId: '1141762677031338067',
                name: '环境偏好',
                id: '38_30318662884643166',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1500
            },
            {
                depth: '2',
                rootId: '1008936832483758197',
                name: '眉州棒棒鸡',
                id: '9_1007587853191909526',
                isleaf: '0',
                type: 'Food.Dish',
                group: 11
            },
            {
                depth: '2',
                rootId: '1008937085891010634',
                name: '土豪 3%',
                id: '77_30318758493836433',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1000
            },
            {
                depth: '2',
                rootId: '1008936832483758197',
                name: '超肥回锅肉',
                id: '9_1007587853191909525',
                isleaf: '0',
                type: 'Food.Dish',
                group: 3
            },
            {
                depth: '2',
                rootId: '1063129407759102074',
                name: '16-25岁 6%',
                id: '106_30318822405459698',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1700
            },
            {
                depth: '2',
                rootId: '1008936196505604180',
                name: '秘制酸梅汤',
                id: '123_1007587597809115224',
                isleaf: '0',
                type: 'Food.Dish',
                group: 11
            },
            {
                depth: '2',
                rootId: '1008936196505604180',
                name: '宫保鸡丁',
                id: '123_1007587597809115222',
                isleaf: '0',
                type: 'Food.Dish',
                group: 10
            },
            {
                depth: '1',
                rootId: '1088493651933266052',
                name: '环境偏好',
                id: '117_30318845812806365',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1500
            },
            {
                depth: '2',
                rootId: '1008936154810036313',
                name: '普通 46%',
                id: '30318563180240430',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1000
            },
            {
                depth: '2',
                rootId: '1008936196505604180',
                name: '16-25岁 6%',
                id: '123_30318858697245868',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1700
            },
            {
                depth: '1',
                rootId: '1008939929524265093',
                name: '附近餐厅',
                id: '47_30318685371161043',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 2100
            },
            {
                depth: '2',
                rootId: '1008937365227454569',
                name: '环境优雅',
                id: '24_1031468355036397661',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '2',
                rootId: '1008936853832765530',
                name: '朋友聚餐',
                id: '37_1031468354918940778',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '2',
                rootId: '1008936196505604180',
                name: '35-45岁 31%',
                id: '123_30318858697254578',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1700
            },
            {
                depth: '2',
                rootId: '1134885965492412506',
                name: '普通 44%',
                id: '36_30318659200025754',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1000
            },
            {
                depth: '2',
                rootId: '1008936832483758197',
                name: '精选餐厅',
                id: '9_1031468355141263394',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '2',
                rootId: '1008938620507164753',
                name: '撸串圣地 9%',
                id: '57_30318710142191354',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1500
            },
            {
                depth: '1',
                rootId: '1008936832483758197',
                name: '标签',
                id: '9_30318590868616828',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '2',
                rootId: '1008937365227454569',
                name: '普通 42%',
                id: '24_30318628867926905',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1000
            },
            {
                depth: '2',
                rootId: '1008936270543454330',
                name: '25-35岁 53%',
                id: '132_30318880886144701',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1700
            },
            {
                depth: '2',
                rootId: '1008936196505604180',
                name: '高档 10%',
                id: '123_30318858704080526',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1000
            },
            {
                depth: '1',
                rootId: '1008936196505604180',
                name: '环境偏好',
                id: '123_30318858704098299',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1500
            },
            {
                depth: '1',
                rootId: '1008936270543454330',
                name: '年龄分布',
                id: '132_30318880885969868',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1700
            },
            {
                depth: '1',
                rootId: '1063129407759102074',
                name: '推荐菜',
                id: '106_30318821965358789',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 900
            },
            {
                depth: '2',
                rootId: '1008937110784213055',
                name: '25-35岁 33%',
                id: '58_30318712631322614',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1700
            },
            {
                depth: '1',
                rootId: '1008939929524265093',
                name: '标签',
                id: '47_30318685746074893',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '2',
                rootId: '1008937110784213055',
                name: '环境优雅',
                id: '58_1031468355036397661',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '2',
                rootId: '1008938927878324362',
                name: '女 60%',
                id: '42_30318672219921698',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1600
            },
            {
                depth: '2',
                rootId: '1008936832483758197',
                name: '普通 37%',
                id: '9_30318589833721233',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1000
            },
            {
                depth: '2',
                rootId: '1008936853832765530',
                name: '服务热情',
                id: '37_1031468354918940782',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '1',
                rootId: '1008938927878324362',
                name: '附近餐厅',
                id: '42_30318672728228199',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 2100
            },
            {
                depth: '2',
                rootId: '1008936154810036313',
                name: '35-45岁 31%',
                id: '30318563174178688',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1700
            },
            {
                depth: '1',
                rootId: '1008937987695734905',
                name: '年龄分布',
                id: '44_30318677033253094',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1700
            },
            {
                depth: '2',
                rootId: '1008936270543454330',
                name: '实惠 19%',
                id: '132_30318880892326435',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1000
            },
            {
                depth: '2',
                rootId: '1141762677031338067',
                name: '有舞台表演 11%',
                id: '38_30318662918139963',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1500
            },
            {
                depth: '1',
                rootId: '1134885965492412506',
                name: '年龄分布',
                id: '36_30318659193318752',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1700
            },
            {
                depth: '2',
                rootId: '1008936196505604180',
                name: '实惠 4%',
                id: '123_30318858704090347',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1000
            },
            {
                depth: '2',
                rootId: '1008938620507164753',
                name: '豆腐脑',
                id: '57_1007587945051349113',
                isleaf: '0',
                type: 'Food.Dish',
                group: 4
            },
            {
                depth: '2',
                rootId: '1008937110784213055',
                name: '快速方便 19%',
                id: '58_30318712645735643',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1500
            },
            {
                depth: '2',
                rootId: '1008938620507164753',
                name: '鸭血粉丝汤',
                id: '57_1007587945051349109',
                isleaf: '0',
                type: 'Food.Dish',
                group: 10
            },
            {
                depth: '2',
                rootId: '1008936853832765530',
                name: '环境吵闹',
                id: '37_1031468355036397662',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '2',
                rootId: '1008936196505604180',
                name: '亲子餐厅',
                id: '123_1031468354373709875',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '2',
                rootId: '1008936853832765530',
                name: '环境优雅',
                id: '37_1031468355036397661',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '1',
                rootId: '1008938620507164753',
                name: '环境偏好',
                id: '57_30318710025092950',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1500
            },
            {
                depth: '2',
                rootId: '1008938620507164753',
                name: '精选餐厅',
                id: '57_1031468355141263394',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '1',
                rootId: '1008936196505604180',
                name: '附近餐厅',
                id: '123_30318859415465981',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 2100
            },
            {
                depth: '2',
                rootId: '1141762677031338067',
                name: '女 20%',
                id: '38_30318663045141123',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1600
            },
            {
                depth: '2',
                rootId: '1008938927878324362',
                name: '上海市:上海 8%',
                id: '42_30318673760392160',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1900
            },
            {
                depth: '2',
                rootId: '1008936853832765530',
                name: '45岁以上 28%',
                id: '37_30318660590447776',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1700
            },
            {
                depth: '2',
                rootId: '1008937365227454569',
                name: '高人气',
                id: '24_1031468355367759987',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '2',
                rootId: '1008936853832765530',
                name: '甜味',
                id: '37_1031468355036397670',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '2',
                rootId: '1008937085891010634',
                name: '聚餐',
                id: '77_1031468355141263428',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '1',
                rootId: '1008936196505604180',
                name: '用户常驻城市',
                id: '123_30318860408186117',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1900
            },
            {
                depth: '2',
                rootId: '1008936196505604180',
                name: '味道赞',
                id: '123_1031468354713464917',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '0',
                rootId: '1008936154810036313',
                name: '眉州东坡（王府井店）',
                id: '1008936154810036313',
                isleaf: '0',
                type: 'Organization.POI',
                group: 1
            },
            {
                depth: '2',
                rootId: '1008937365227454569',
                name: '菜品不错 19%',
                id: '24_30318628872908490',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1500
            },
            {
                depth: '2',
                rootId: '1008937085891010634',
                name: '亲子餐厅',
                id: '77_1031468354373709875',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '2',
                rootId: '1008937365227454569',
                name: '上海市:上海 9%',
                id: '24_30318630743406692',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1900
            },
            {
                depth: '2',
                rootId: '1008936196505604180',
                name: '快速方便 6%',
                id: '123_30318858826886966',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1500
            },
            {
                depth: '2',
                rootId: '1008936196505604180',
                name: '鲜香',
                id: '123_1031468354713464923',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '2',
                rootId: '1008937110784213055',
                name: '菜品不错',
                id: '58_1031468355271299158',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '2',
                rootId: '1008936270543454330',
                name: '土豪 2%',
                id: '132_30318880892324556',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1000
            },
            {
                depth: '2',
                rootId: '1008936270543454330',
                name: '广东省:深圳 2%',
                id: '132_30318882577238934',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1900
            },
            {
                depth: '2',
                rootId: '1134885965492412506',
                name: '撸串圣地 25%',
                id: '36_30318659206709708',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1500
            },
            {
                depth: '2',
                rootId: '1008937987695734905',
                name: '凉菜',
                id: '44_1031468354713464856',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '1',
                rootId: '1008936270543454330',
                name: '用户常驻城市',
                id: '132_30318882577208051',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1900
            },
            {
                depth: '2',
                rootId: '1008936270543454330',
                name: '男 49%',
                id: '132_30318881046226804',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1600
            },
            {
                depth: '2',
                rootId: '1008937987695734905',
                name: '甜味',
                id: '44_1031468355036397670',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '2',
                rootId: '1008939929524265093',
                name: '小资 40%',
                id: '47_30318684637030415',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1000
            },
            {
                depth: '2',
                rootId: '1008936853832765530',
                name: '实惠 13%',
                id: '37_30318660598785335',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1000
            },
            {
                depth: '2',
                rootId: '1008939929524265093',
                name: '高档 8%',
                id: '47_30318684637018535',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1000
            },
            {
                depth: '2',
                rootId: '1008937085891010634',
                name: '价格高',
                id: '77_1031468354373709887',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '2',
                rootId: '1008937110784213055',
                name: '鸡丝凉面',
                id: '58_1007588124353626272',
                isleaf: '0',
                type: 'Food.Dish',
                group: 9
            },
            {
                depth: '1',
                rootId: '1134885965492412506',
                name: '标签',
                id: '36_30318659776546513',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '2',
                rootId: '1134885965492412506',
                name: '牛肉鸡蛋炒饼',
                id: '36_1135224789783314523',
                isleaf: '1',
                type: 'Food.Dish',
                group: 3
            },
            {
                depth: '2',
                rootId: '1008936270543454330',
                name: '服务热情',
                id: '132_1031468354918940782',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '2',
                rootId: '1008937110784213055',
                name: '菜品精致',
                id: '58_1031468355271299168',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '1',
                rootId: '1134885965492412506',
                name: '相似餐厅',
                id: '36_30318659354340298',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 2000
            },
            {
                depth: '2',
                rootId: '1008936853832765530',
                name: '16-25岁 3%',
                id: '37_30318660590462692',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1700
            },
            {
                depth: '1',
                rootId: '1063129407759102074',
                name: '标签',
                id: '106_30318822945427484',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '2',
                rootId: '1063129407759102074',
                name: '麻辣鸡爪',
                id: '106_1063833990244356163',
                isleaf: '0',
                type: 'Food.Dish',
                group: 6
            },
            {
                depth: '2',
                rootId: '1008938927878324362',
                name: '精选餐厅',
                id: '42_1031468355141263394',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '2',
                rootId: '1008936832483758197',
                name: '45岁以上 22%',
                id: '9_30318589827993608',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1700
            },
            {
                depth: '2',
                rootId: '1008937365227454569',
                name: '毛血旺',
                id: '24_1007587810284183721',
                isleaf: '0',
                type: 'Food.Dish',
                group: 10
            },
            {
                depth: '2',
                rootId: '1008937987695734905',
                name: '环境优雅',
                id: '44_1031468355036397661',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '2',
                rootId: '1008937110784213055',
                name: '上菜快',
                id: '58_1031468354373709836',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '2',
                rootId: '1134885965492412506',
                name: '女 29%',
                id: '36_30318659354329220',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1600
            },
            {
                depth: '2',
                rootId: '1008936270543454330',
                name: '菜品不错 14%',
                id: '132_30318880898809445',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1500
            },
            {
                depth: '2',
                rootId: '1008938620507164753',
                name: '上海市:上海 2%',
                id: '57_30318711832020335',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1900
            },
            {
                depth: '2',
                rootId: '1008937987695734905',
                name: '麻辣',
                id: '44_1031468355271299221',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '2',
                rootId: '1008937365227454569',
                name: '蓑衣黄瓜',
                id: '24_1007587810284183727',
                isleaf: '0',
                type: 'Food.Dish',
                group: 4
            },
            {
                depth: '2',
                rootId: '1088493651933266052',
                name: '早餐',
                id: '117_1031468354918940740',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '2',
                rootId: '1008936196505604180',
                name: '快速方便',
                id: '123_1031468354814115945',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '2',
                rootId: '1063129407759102074',
                name: '有舞台表演 8%',
                id: '106_30318822469333678',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1500
            },
            {
                depth: '2',
                rootId: '1088493651933266052',
                name: '茶叶蛋',
                id: '117_1126165111229182059',
                isleaf: '0',
                type: 'Food.Dish',
                group: 9
            },
            {
                depth: '2',
                rootId: '1008936196505604180',
                name: '性价比高',
                id: '123_1031468354814115949',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '2',
                rootId: '1008937110784213055',
                name: '上海市:上海 1%',
                id: '58_30318714306559295',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1900
            },
            {
                depth: '2',
                rootId: '1008937365227454569',
                name: '甜味',
                id: '24_1031468355036397670',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '2',
                rootId: '1134885965492412506',
                name: '实惠 17%',
                id: '36_30318659200036235',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1000
            },
            {
                depth: '2',
                rootId: '1063129407759102074',
                name: '男 46%',
                id: '106_30318822558325987',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1600
            },
            {
                depth: '2',
                rootId: '1008937987695734905',
                name: '午餐',
                id: '44_1031468354713464875',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '2',
                rootId: '1008938620507164753',
                name: '有露台 11%',
                id: '57_30318710083640798',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1500
            },
            {
                depth: '2',
                rootId: '1008937085891010634',
                name: '菜品精致',
                id: '77_1031468355271299168',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '2',
                rootId: '1008937110784213055',
                name: '担担面',
                id: '58_1007588124353626243',
                isleaf: '0',
                type: 'Food.Dish',
                group: 5
            },
            {
                depth: '2',
                rootId: '1008937987695734905',
                name: '银耳羹',
                id: '44_1007588293249900590',
                isleaf: '0',
                type: 'Food.Dish',
                group: 7
            },
            {
                depth: '1',
                rootId: '1008938620507164753',
                name: '用户常驻城市',
                id: '57_30318711831967496',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1900
            },
            {
                depth: '2',
                rootId: '1008938927878324362',
                name: '体验很棒',
                id: '42_1031468354373709893',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '1',
                rootId: '1008939929524265093',
                name: '消费水平分布',
                id: '47_30318684636848025',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1800
            },
            {
                depth: '2',
                rootId: '1088493651933266052',
                name: '经典豆浆',
                id: '117_1126165057126809689',
                isleaf: '0',
                type: 'Food.Dish',
                group: 3
            },
            {
                depth: '2',
                rootId: '1008937085891010634',
                name: '上菜快',
                id: '77_1031468354373709836',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '2',
                rootId: '1008936270543454330',
                name: '菜品不错',
                id: '132_1031468355271299158',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '2',
                rootId: '1008937987695734905',
                name: '口水鸡',
                id: '44_1007588293249900597',
                isleaf: '0',
                type: 'Food.Dish',
                group: 8
            },
            {
                depth: '2',
                rootId: '1063129407759102074',
                name: '鱼豆腐',
                id: '106_1125440102617620521',
                isleaf: '0',
                type: 'Food.Dish',
                group: 11
            },
            {
                depth: '2',
                rootId: '1008937085891010634',
                name: '菜品不错',
                id: '77_1031468355271299158',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '2',
                rootId: '1008937110784213055',
                name: '服务热情',
                id: '58_1031468354918940782',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '2',
                rootId: '1088493651933266052',
                name: '性价比高',
                id: '117_1031468354814115949',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '1',
                rootId: '1141762677031338067',
                name: '性别分布',
                id: '38_30318663045105210',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1600
            },
            {
                depth: '2',
                rootId: '1008937085891010634',
                name: '北京市:北京 98%',
                id: '77_30318760158266327',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1900
            },
            {
                depth: '2',
                rootId: '1008937365227454569',
                name: '兔爷土豆泥',
                id: '24_1007587810275774531',
                isleaf: '0',
                type: 'Food.Dish',
                group: 12
            },
            {
                depth: '1',
                rootId: '1134885965492412506',
                name: '附近餐厅',
                id: '36_30318659385310080',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 2100
            },
            {
                depth: '2',
                rootId: '1063129407759102074',
                name: '重口味',
                id: '106_1031468355271299241',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '2',
                rootId: '1008938927878324362',
                name: '价格高',
                id: '42_1031468354373709887',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '2',
                rootId: '1141762677031338067',
                name: '江苏省:南京 50%',
                id: '38_30318663395486857',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1900
            },
            {
                depth: '2',
                rootId: '1008937110784213055',
                name: '豉汁蒸凤爪',
                id: '58_1007588124353626268',
                isleaf: '0',
                type: 'Food.Dish',
                group: 4
            },
            {
                depth: '2',
                rootId: '1008937110784213055',
                name: '亲子餐厅',
                id: '58_1031468354373709875',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '2',
                rootId: '1008937110784213055',
                name: '16-25岁 5%',
                id: '58_30318712631325044',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1700
            },
            {
                depth: '2',
                rootId: '1008938927878324362',
                name: '岭南蛋挞',
                id: '42_1007588095765278856',
                isleaf: '0',
                type: 'Food.Dish',
                group: 10
            },
            {
                depth: '2',
                rootId: '1008936832483758197',
                name: '快速方便 12%',
                id: '9_30318589929737135',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1500
            },
            {
                depth: '2',
                rootId: '1088493651933266052',
                name: '服务热情',
                id: '117_1031468354918940782',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '0',
                rootId: '1063129407759102074',
                name: '紫燕百味鸡（霍营店）',
                id: '1063129407759102074',
                isleaf: '0',
                type: 'Organization.POI',
                group: 1
            },
            {
                depth: '2',
                rootId: '1008939929524265093',
                name: '糖醋',
                id: '47_1031468355141263398',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '2',
                rootId: '1008937987695734905',
                name: '串串',
                id: '44_1044629715345756296',
                isleaf: '0',
                type: 'Food.Dish',
                group: 6
            },
            {
                depth: '2',
                rootId: '1008939929524265093',
                name: '精选餐厅',
                id: '47_1031468355141263394',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '2',
                rootId: '1008937987695734905',
                name: '宫保鸡丁',
                id: '44_1044629715345756294',
                isleaf: '0',
                type: 'Food.Dish',
                group: 4
            },
            {
                depth: '2',
                rootId: '1134885965492412506',
                name: '黑龙江省:鸡西 4%',
                id: '36_30318659797046183',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1900
            },
            {
                depth: '2',
                rootId: '1008938927878324362',
                name: '亲子餐厅',
                id: '42_1031468354373709875',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '2',
                rootId: '1008936196505604180',
                name: '开心凉粉',
                id: '123_1007587597825908789',
                isleaf: '0',
                type: 'Food.Dish',
                group: 3
            },
            {
                depth: '1',
                rootId: '1063129407759102074',
                name: '年龄分布',
                id: '106_30318822405330351',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1700
            },
            {
                depth: '2',
                rootId: '1008936196505604180',
                name: '小资 43%',
                id: '123_30318858704088546',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1000
            },
            {
                depth: '2',
                rootId: '1008937110784213055',
                name: '红糖软糍粑',
                id: '58_1007588124353626257',
                isleaf: '0',
                type: 'Food.Dish',
                group: 3
            },
            {
                depth: '2',
                rootId: '1008937987695734905',
                name: '小龙虾',
                id: '44_1044629715345756289',
                isleaf: '0',
                type: 'Food.Dish',
                group: 12
            },
            {
                depth: '1',
                rootId: '1008937110784213055',
                name: '性别分布',
                id: '58_30318712805510252',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1600
            },
            {
                depth: '1',
                rootId: '1134885965492412506',
                name: '推荐菜',
                id: '36_30318658752077972',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 900
            },
            {
                depth: '2',
                rootId: '1008936853832765530',
                name: '菜品不错 25%',
                id: '37_30318660608081101',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1500
            },
            {
                depth: '2',
                rootId: '1008938927878324362',
                name: '环境优雅 10%',
                id: '42_30318672181548905',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1500
            },
            {
                depth: '1',
                rootId: '1008937110784213055',
                name: '消费水平分布',
                id: '58_30318712639191275',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1800
            },
            {
                depth: '2',
                rootId: '1008936196505604180',
                name: '川菜',
                id: '123_1031468354814115910',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '2',
                rootId: '1008937085891010634',
                name: '小资 42%',
                id: '77_30318758493837962',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1000
            },
            {
                depth: '2',
                rootId: '1008937110784213055',
                name: '撸串圣地 12%',
                id: '58_30318712709037625',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1500
            },
            {
                depth: '2',
                rootId: '1008937110784213055',
                name: '价格实惠',
                id: '58_1031468354373709885',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '2',
                rootId: '1008936270543454330',
                name: '无辣不欢 14%',
                id: '132_30318880925690158',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1500
            },
            {
                depth: '2',
                rootId: '1008936154810036313',
                name: '男 39%',
                id: '30318563348694132',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1600
            },
            {
                depth: '2',
                rootId: '1008936270543454330',
                name: '性价比高',
                id: '132_1031468354814115949',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '2',
                rootId: '1008937365227454569',
                name: '味道赞',
                id: '24_1031468354713464917',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '2',
                rootId: '1008936270543454330',
                name: '亲子餐厅',
                id: '132_1031468354373709875',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '1',
                rootId: '1008936832483758197',
                name: '相似餐厅',
                id: '9_30318589991247912',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 2000
            },
            {
                depth: '2',
                rootId: '1008936154810036313',
                name: '25-35岁 40%',
                id: '30318563174185578',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1700
            },
            {
                depth: '1',
                rootId: '1008937110784213055',
                name: '推荐菜',
                id: '58_30318711858580677',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 900
            },
            {
                depth: '2',
                rootId: '1134885965492412506',
                name: '腊肉炒饭',
                id: '36_1135224741783699583',
                isleaf: '0',
                type: 'Food.Dish',
                group: 10
            },
            {
                depth: '2',
                rootId: '1008937085891010634',
                name: '午餐',
                id: '77_1031468354713464875',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '2',
                rootId: '1008936832483758197',
                name: '环境优雅',
                id: '9_1031468355036397661',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '2',
                rootId: '1008937987695734905',
                name: '实惠 8%',
                id: '44_30318677038273894',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1000
            },
            {
                depth: '2',
                rootId: '1008936832483758197',
                name: '地道鱼香肉丝',
                id: '9_1027976810542956579',
                isleaf: '0',
                type: 'Food.Dish',
                group: 5
            },
            {
                depth: '1',
                rootId: '1008938927878324362',
                name: '环境偏好',
                id: '42_30318672056636669',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1500
            },
            {
                depth: '0',
                rootId: '1008937365227454569',
                name: '局气（西单店）',
                id: '1008937365227454569',
                isleaf: '0',
                type: 'Organization.POI',
                group: 1
            },
            {
                depth: '2',
                rootId: '1134885965492412506',
                name: '腊肠炒饼',
                id: '36_1135224750872727664',
                isleaf: '1',
                type: 'Food.Dish',
                group: 4
            },
            {
                depth: '2',
                rootId: '1008937987695734905',
                name: '上海市:上海 1%',
                id: '44_30318678799181063',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1900
            },
            {
                depth: '1',
                rootId: '1008936270543454330',
                name: '相似餐厅',
                id: '132_30318881046237328',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 2000
            },
            {
                depth: '2',
                rootId: '1008937365227454569',
                name: '鲜香',
                id: '24_1031468354713464923',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '2',
                rootId: '1008936832483758197',
                name: '家庭聚餐',
                id: '9_1031468354814115897',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '1',
                rootId: '1008936196505604180',
                name: '消费水平分布',
                id: '123_30318858703951972',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1800
            },
            {
                depth: '1',
                rootId: '1141762677031338067',
                name: '附近餐厅',
                id: '38_30318663076446848',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 2100
            },
            {
                depth: '2',
                rootId: '1008938620507164753',
                name: '酸辣汤',
                id: '57_1044994308802932862',
                isleaf: '0',
                type: 'Food.Dish',
                group: 12
            },
            {
                depth: '2',
                rootId: '1008939929524265093',
                name: '快速方便 10%',
                id: '47_30318684702102161',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1500
            },
            {
                depth: '2',
                rootId: '1008937085891010634',
                name: '实惠 8%',
                id: '77_30318758493832886',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1000
            },
            {
                depth: '1',
                rootId: '1008937987695734905',
                name: '环境偏好',
                id: '44_30318677038302831',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1500
            },
            {
                depth: '2',
                rootId: '1063129407759102074',
                name: '鸭锁骨',
                id: '106_1067094696733483125',
                isleaf: '0',
                type: 'Food.Dish',
                group: 12
            },
            {
                depth: '2',
                rootId: '1008938927878324362',
                name: '性价比高',
                id: '42_1031468354814115949',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '2',
                rootId: '1008937365227454569',
                name: '北京市:北京 78%',
                id: '24_30318630743401810',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1900
            },
            {
                depth: '2',
                rootId: '1008936832483758197',
                name: '鲜香',
                id: '9_1031468354713464923',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '2',
                rootId: '1088493651933266052',
                name: '鲜肉粽',
                id: '117_1126165074528972913',
                isleaf: '0',
                type: 'Food.Dish',
                group: 10
            },
            {
                depth: '2',
                rootId: '1008936832483758197',
                name: '麻辣',
                id: '9_1031468355271299221',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '2',
                rootId: '1008937365227454569',
                name: '男 38%',
                id: '24_30318629023022942',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1600
            },
            {
                depth: '2',
                rootId: '1008936270543454330',
                name: '上菜快',
                id: '132_1031468354373709836',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '2',
                rootId: '1008936853832765530',
                name: '25-35岁 31%',
                id: '37_30318660590457921',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1700
            },
            {
                depth: '1',
                rootId: '1008937085891010634',
                name: '推荐菜',
                id: '77_30318757732834437',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 900
            },
            {
                depth: '2',
                rootId: '1008936832483758197',
                name: '无辣不欢 7%',
                id: '9_30318589958528410',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1500
            },
            {
                depth: '1',
                rootId: '1008938927878324362',
                name: '性别分布',
                id: '42_30318672219883617',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1600
            },
            {
                depth: '2',
                rootId: '1008936832483758197',
                name: '味道赞',
                id: '9_1031468354713464917',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '1',
                rootId: '1008936853832765530',
                name: '附近餐厅',
                id: '37_30318661311521697',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 2100
            },
            {
                depth: '2',
                rootId: '1008938620507164753',
                name: '拿破仑',
                id: '57_1044994308802932888',
                isleaf: '0',
                type: 'Food.Dish',
                group: 9
            },
            {
                depth: '2',
                rootId: '1134885965492412506',
                name: '土豪 6%',
                id: '36_30318659200038023',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1000
            },
            {
                depth: '2',
                rootId: '1008937110784213055',
                name: '实惠 16%',
                id: '58_30318712639341041',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1000
            },
            {
                depth: '2',
                rootId: '1063129407759102074',
                name: '35-45岁 34%',
                id: '106_30318822405456647',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1700
            },
            {
                depth: '2',
                rootId: '1063129407759102074',
                name: '小资 42%',
                id: '106_30318822409879084',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1000
            },
            {
                depth: '2',
                rootId: '1008937110784213055',
                name: '高档 10%',
                id: '58_30318712639344317',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1000
            },
            {
                depth: '2',
                rootId: '1008938620507164753',
                name: '环境优雅',
                id: '57_1031468355036397661',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '1',
                rootId: '1008937110784213055',
                name: '用户常驻城市',
                id: '58_30318714306512144',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1900
            },
            {
                depth: '2',
                rootId: '1008937085891010634',
                name: '高档 10%',
                id: '77_30318758493834883',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1000
            },
            {
                depth: '2',
                rootId: '1008936832483758197',
                name: '25-35岁 37%',
                id: '9_30318589827981479',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1700
            },
            {
                depth: '2',
                rootId: '1008938620507164753',
                name: '麻辣',
                id: '57_1031468355271299221',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '2',
                rootId: '1008938927878324362',
                name: '男 40%',
                id: '42_30318672219926111',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1600
            },
            {
                depth: '2',
                rootId: '1008938927878324362',
                name: '麻辣',
                id: '42_1031468354918940725',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '2',
                rootId: '1008936853832765530',
                name: '精选餐厅',
                id: '37_1031468355141263394',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '2',
                rootId: '1008936270543454330',
                name: '16-25岁 21%',
                id: '132_30318880886138703',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1700
            },
            {
                depth: '2',
                rootId: '1008936853832765530',
                name: '糖醋',
                id: '37_1031468355141263398',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '2',
                rootId: '1008938620507164753',
                name: '甜味',
                id: '57_1031468355036397670',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '2',
                rootId: '1008937987695734905',
                name: '火锅',
                id: '44_1031468355036397629',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '2',
                rootId: '1008936196505604180',
                name: '龙人居水煮三峡鱼',
                id: '123_1123628760017432712',
                isleaf: '0',
                type: 'Food.Dish',
                group: 8
            },
            {
                depth: '1',
                rootId: '1008936196505604180',
                name: '年龄分布',
                id: '123_30318858697122680',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1700
            },
            {
                depth: '2',
                rootId: '1008939929524265093',
                name: '实惠 7%',
                id: '47_30318684637024574',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1000
            },
            {
                depth: '2',
                rootId: '1008936832483758197',
                name: '甜味',
                id: '9_1031468355036397670',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '2',
                rootId: '1141762677031338067',
                name: '肉夹馍',
                id: '38_1142106919033380876',
                isleaf: '0',
                type: 'Food.Dish',
                group: 12
            },
            {
                depth: '2',
                rootId: '1008937365227454569',
                name: '疙瘩汤',
                id: '24_1007587810275774581',
                isleaf: '0',
                type: 'Food.Dish',
                group: 6
            },
            {
                depth: '2',
                rootId: '1008937110784213055',
                name: '麻辣香锅',
                id: '58_1007588124374618372',
                isleaf: '0',
                type: 'Food.Dish',
                group: 11
            },
            {
                depth: '2',
                rootId: '1008937987695734905',
                name: '食材新鲜',
                id: '44_1031468355367759972',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '1',
                rootId: '1063129407759102074',
                name: '附近餐厅',
                id: '106_30318822593191493',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 2100
            },
            {
                depth: '2',
                rootId: '1008936832483758197',
                name: '精品烤鸭',
                id: '9_1045506332351807533',
                isleaf: '0',
                type: 'Food.Dish',
                group: 6
            },
            {
                depth: '1',
                rootId: '1008937085891010634',
                name: '年龄分布',
                id: '77_30318758486364003',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1700
            },
            {
                depth: '2',
                rootId: '1008937987695734905',
                name: '45岁以上 7%',
                id: '44_30318677033439660',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1700
            },
            {
                depth: '2',
                rootId: '1008937365227454569',
                name: '浙江省:杭州 2%',
                id: '24_30318630743409979',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1900
            },
            {
                depth: '2',
                rootId: '1008937085891010634',
                name: '女 64%',
                id: '77_30318758648715121',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1600
            },
            {
                depth: '1',
                rootId: '1008936853832765530',
                name: '相似餐厅',
                id: '37_30318660763323309',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 2000
            },
            {
                depth: '1',
                rootId: '1141762677031338067',
                name: '用户常驻城市',
                id: '38_30318663395450824',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1900
            },
            {
                depth: '2',
                rootId: '1141762677031338067',
                name: '砂锅麻辣粉',
                id: '38_1142106917066276981',
                isleaf: '1',
                type: 'Food.Dish',
                group: 10
            },
            {
                depth: '1',
                rootId: '1008937365227454569',
                name: '消费水平分布',
                id: '24_30318628867720747',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1800
            },
            {
                depth: '2',
                rootId: '1088493651933266052',
                name: '北京市:北京 100%',
                id: '117_30318846403205378',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1900
            },
            {
                depth: '2',
                rootId: '1008936270543454330',
                name: '（小）月饼内部员工优惠价',
                id: '132_1007587654646116444',
                isleaf: '0',
                type: 'Food.Dish',
                group: 10
            },
            {
                depth: '2',
                rootId: '1008937110784213055',
                name: '午餐',
                id: '58_1031468354713464875',
                isleaf: '0',
                type: 'Tag.TagInfo',
                group: 1400
            },
            {
                depth: '2',
                rootId: '1088493651933266052',
                name: '香菇油菜',
                id: '117_1116017939212927075',
                isleaf: '0',
                type: 'Food.Dish',
                group: 5
            },
            {
                depth: '2',
                rootId: '1008939929524265093',
                name: '男 33%',
                id: '47_30318684795092026',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1600
            },
            {
                depth: '2',
                rootId: '1008937987695734905',
                name: '25-35岁 57%',
                id: '44_30318677033448119',
                isleaf: '1',
                type: 'Tag.TagInfo',
                group: 1700
            }
        ],
        links: [
            {
                source: '1008936154810036313',
                value: 1,
                target: '30318563180256086'
            },
            {
                source: '30318563180256086',
                value: 1,
                target: '30318563313464049'
            },
            {
                source: '30318563313464049',
                value: 1,
                target: '1008936853832765530'
            },
            {
                source: '1008936853832765530',
                value: 1,
                target: '37_30318659822286861'
            },
            {
                source: '37_30318659822286861',
                value: 1,
                target: '37_1007587721729831080'
            },
            {
                source: '37_30318659822286861',
                value: 1,
                target: '37_1007587721729831072'
            },
            {
                source: '37_30318659822286861',
                value: 1,
                target: '37_1007587721729831094'
            },
            {
                source: '37_30318659822286861',
                value: 1,
                target: '37_1045506345928814674'
            },
            {
                source: '37_30318659822286861',
                value: 1,
                target: '37_1007587721729831074'
            },
            {
                source: '37_30318659822286861',
                value: 1,
                target: '37_1007587721729831084'
            },
            {
                source: '37_30318659822286861',
                value: 1,
                target: '37_1007587721784332413'
            },
            {
                source: '37_30318659822286861',
                value: 1,
                target: '37_1007587721729831076'
            },
            {
                source: '37_30318659822286861',
                value: 1,
                target: '37_1007587721729831088'
            },
            {
                source: '37_30318659822286861',
                value: 1,
                target: '37_1007587721784332383'
            },
            {
                source: '1008936853832765530',
                value: 1,
                target: '37_30318660590190307'
            },
            {
                source: '37_30318660590190307',
                value: 1,
                target: '37_30318660590447776'
            },
            {
                source: '37_30318660590190307',
                value: 1,
                target: '37_30318660590457921'
            },
            {
                source: '37_30318660590190307',
                value: 1,
                target: '37_30318660590460573'
            },
            {
                source: '37_30318660590190307',
                value: 1,
                target: '37_30318660590462692'
            },
            {
                source: '1008936853832765530',
                value: 1,
                target: '37_30318660598555730'
            },
            {
                source: '37_30318660598555730',
                value: 1,
                target: '37_30318660598785335'
            },
            {
                source: '37_30318660598555730',
                value: 1,
                target: '37_30318660598791779'
            },
            {
                source: '37_30318660598555730',
                value: 1,
                target: '37_30318660598794383'
            },
            {
                source: '37_30318660598555730',
                value: 1,
                target: '37_30318660598796601'
            },
            {
                source: '37_30318660598555730',
                value: 1,
                target: '37_30318660598799089'
            },
            {
                source: '1008936853832765530',
                value: 1,
                target: '37_30318660598804604'
            },
            {
                source: '37_30318660598804604',
                value: 1,
                target: '37_30318660608081101'
            },
            {
                source: '37_30318660598804604',
                value: 1,
                target: '37_30318660635787483'
            },
            {
                source: '37_30318660598804604',
                value: 1,
                target: '37_30318660663182606'
            },
            {
                source: '37_30318660598804604',
                value: 1,
                target: '37_30318660694785143'
            },
            {
                source: '37_30318660598804604',
                value: 1,
                target: '37_30318660725873435'
            },
            {
                source: '1008936853832765530',
                value: 1,
                target: '37_30318660763278313'
            },
            {
                source: '37_30318660763278313',
                value: 1,
                target: '37_30318660763312555'
            },
            {
                source: '37_30318660763278313',
                value: 1,
                target: '37_30318660763316933'
            },
            {
                source: '1008936853832765530',
                value: 1,
                target: '37_30318660763323309'
            },
            {
                source: '1008936853832765530',
                value: 1,
                target: '37_30318661311521697'
            },
            {
                source: '1008936853832765530',
                value: 1,
                target: '37_30318661691861798'
            },
            {
                source: '37_30318661691861798',
                value: 1,
                target: '37_1031468354918940778'
            },
            {
                source: '37_30318661691861798',
                value: 1,
                target: '37_1031468354918940782'
            },
            {
                source: '37_30318661691861798',
                value: 1,
                target: '37_1031468355271299158'
            },
            {
                source: '37_30318661691861798',
                value: 1,
                target: '37_1031468355271299221'
            },
            {
                source: '37_30318661691861798',
                value: 1,
                target: '37_1031468355036397670'
            },
            {
                source: '37_30318661691861798',
                value: 1,
                target: '37_1031468355036397661'
            },
            {
                source: '37_30318661691861798',
                value: 1,
                target: '37_1031468354373709875'
            },
            {
                source: '37_30318661691861798',
                value: 1,
                target: '37_1031468355141263424'
            },
            {
                source: '37_30318661691861798',
                value: 1,
                target: '37_1031468354814115910'
            },
            {
                source: '37_30318661691861798',
                value: 1,
                target: '37_1031468354713464875'
            },
            {
                source: '37_30318661691861798',
                value: 1,
                target: '37_1031468354373709836'
            },
            {
                source: '37_30318661691861798',
                value: 1,
                target: '37_1031468354814115949'
            },
            {
                source: '37_30318661691861798',
                value: 1,
                target: '37_1031468355141263428'
            },
            {
                source: '37_30318661691861798',
                value: 1,
                target: '37_1031468355271299168'
            },
            {
                source: '37_30318661691861798',
                value: 1,
                target: '37_1031468354713464923'
            },
            {
                source: '37_30318661691861798',
                value: 1,
                target: '37_1031468355036397662'
            },
            {
                source: '37_30318661691861798',
                value: 1,
                target: '37_1031468355141263394'
            },
            {
                source: '37_30318661691861798',
                value: 1,
                target: '37_1031468355141263398'
            },
            {
                source: '37_30318661691861798',
                value: 1,
                target: '37_1031468355271299236'
            },
            {
                source: '37_30318661691861798',
                value: 1,
                target: '37_1031468355367759987'
            },
            {
                source: '1008936853832765530',
                value: 1,
                target: '37_30318662405549137'
            },
            {
                source: '37_30318662405549137',
                value: 1,
                target: '37_30318662405599641'
            },
            {
                source: '30318563313464049',
                value: 1,
                target: '1008936270543454330'
            },
            {
                source: '1008936270543454330',
                value: 1,
                target: '132_30318880111039901'
            },
            {
                source: '132_30318880111039901',
                value: 1,
                target: '132_1007587654646104147'
            },
            {
                source: '132_30318880111039901',
                value: 1,
                target: '132_1045506419853398113'
            },
            {
                source: '132_30318880111039901',
                value: 1,
                target: '132_1007587654646104153'
            },
            {
                source: '132_30318880111039901',
                value: 1,
                target: '132_1007587654646104151'
            },
            {
                source: '132_30318880111039901',
                value: 1,
                target: '132_1007587654646104150'
            },
            {
                source: '132_30318880111039901',
                value: 1,
                target: '132_1045507004375761004'
            },
            {
                source: '132_30318880111039901',
                value: 1,
                target: '132_1007587654671294528'
            },
            {
                source: '132_30318880111039901',
                value: 1,
                target: '132_1007587654646116444'
            },
            {
                source: '132_30318880111039901',
                value: 1,
                target: '132_1007587654671294526'
            },
            {
                source: '132_30318880111039901',
                value: 1,
                target: '132_1007587654646104155'
            },
            {
                source: '1008936270543454330',
                value: 1,
                target: '132_30318880885969868'
            },
            {
                source: '132_30318880885969868',
                value: 1,
                target: '132_30318880886129760'
            },
            {
                source: '132_30318880885969868',
                value: 1,
                target: '132_30318880886138703'
            },
            {
                source: '132_30318880885969868',
                value: 1,
                target: '132_30318880886142156'
            },
            {
                source: '132_30318880885969868',
                value: 1,
                target: '132_30318880886144701'
            },
            {
                source: '1008936270543454330',
                value: 1,
                target: '132_30318880892222390'
            },
            {
                source: '132_30318880892222390',
                value: 1,
                target: '132_30318880892314065'
            },
            {
                source: '132_30318880892222390',
                value: 1,
                target: '132_30318880892320669'
            },
            {
                source: '132_30318880892222390',
                value: 1,
                target: '132_30318880892322635'
            },
            {
                source: '132_30318880892222390',
                value: 1,
                target: '132_30318880892324556'
            },
            {
                source: '132_30318880892222390',
                value: 1,
                target: '132_30318880892326435'
            },
            {
                source: '1008936270543454330',
                value: 1,
                target: '132_30318880892331669'
            },
            {
                source: '132_30318880892331669',
                value: 1,
                target: '132_30318880898809445'
            },
            {
                source: '132_30318880892331669',
                value: 1,
                target: '132_30318880925690158'
            },
            {
                source: '132_30318880892331669',
                value: 1,
                target: '132_30318880957260286'
            },
            {
                source: '132_30318880892331669',
                value: 1,
                target: '132_30318880984159682'
            },
            {
                source: '132_30318880892331669',
                value: 1,
                target: '132_30318881012345994'
            },
            {
                source: '1008936270543454330',
                value: 1,
                target: '132_30318881046203248'
            },
            {
                source: '132_30318881046203248',
                value: 1,
                target: '132_30318881046226804'
            },
            {
                source: '132_30318881046203248',
                value: 1,
                target: '132_30318881046230851'
            },
            {
                source: '1008936270543454330',
                value: 1,
                target: '132_30318881046237328'
            },
            {
                source: '1008936270543454330',
                value: 1,
                target: '132_30318881596393430'
            },
            {
                source: '1008936270543454330',
                value: 1,
                target: '132_30318881940817568'
            },
            {
                source: '132_30318881940817568',
                value: 1,
                target: '132_1031468354713464917'
            },
            {
                source: '132_30318881940817568',
                value: 1,
                target: '132_1031468355036397629'
            },
            {
                source: '132_30318881940817568',
                value: 1,
                target: '132_1031468354814115949'
            },
            {
                source: '132_30318881940817568',
                value: 1,
                target: '132_1031468354918940782'
            },
            {
                source: '132_30318881940817568',
                value: 1,
                target: '132_1031468355141263424'
            },
            {
                source: '132_30318881940817568',
                value: 1,
                target: '132_1031468354373709885'
            },
            {
                source: '132_30318881940817568',
                value: 1,
                target: '132_1031468355367760012'
            },
            {
                source: '132_30318881940817568',
                value: 1,
                target: '132_1031468355036397662'
            },
            {
                source: '132_30318881940817568',
                value: 1,
                target: '132_1031468355367759972'
            },
            {
                source: '132_30318881940817568',
                value: 1,
                target: '132_1031468354369515571'
            },
            {
                source: '132_30318881940817568',
                value: 1,
                target: '132_1031468354373709887'
            },
            {
                source: '132_30318881940817568',
                value: 1,
                target: '132_1031468355271299158'
            },
            {
                source: '132_30318881940817568',
                value: 1,
                target: '132_1031468355367759987'
            },
            {
                source: '132_30318881940817568',
                value: 1,
                target: '132_1031468355036397661'
            },
            {
                source: '132_30318881940817568',
                value: 1,
                target: '132_1031468355036397660'
            },
            {
                source: '132_30318881940817568',
                value: 1,
                target: '132_1031468355141263394'
            },
            {
                source: '132_30318881940817568',
                value: 1,
                target: '132_1031468355271299221'
            },
            {
                source: '132_30318881940817568',
                value: 1,
                target: '132_1031468354373709875'
            },
            {
                source: '132_30318881940817568',
                value: 1,
                target: '132_1031468354373709836'
            },
            {
                source: '132_30318881940817568',
                value: 1,
                target: '132_1031468354713464875'
            },
            {
                source: '1008936270543454330',
                value: 1,
                target: '132_30318882577208051'
            },
            {
                source: '132_30318882577208051',
                value: 1,
                target: '132_30318882577235367'
            },
            {
                source: '132_30318882577208051',
                value: 1,
                target: '132_30318882577237945'
            },
            {
                source: '132_30318882577208051',
                value: 1,
                target: '132_30318882577238934'
            },
            {
                source: '132_30318882577208051',
                value: 1,
                target: '132_30318882577239960'
            },
            {
                source: '132_30318882577208051',
                value: 1,
                target: '132_30318882577240945'
            },
            {
                source: '1008936154810036313',
                value: 1,
                target: '30318562283868170'
            },
            {
                source: '30318562283868170',
                value: 1,
                target: '1007588047111340137'
            },
            {
                source: '1007588047111340137',
                value: 1,
                target: '1008937987695734905'
            },
            {
                source: '1008937987695734905',
                value: 1,
                target: '44_30318676383519339'
            },
            {
                source: '44_30318676383519339',
                value: 1,
                target: '44_1007588293245665382'
            },
            {
                source: '44_30318676383519339',
                value: 1,
                target: '44_1044629715345756294'
            },
            {
                source: '44_30318676383519339',
                value: 1,
                target: '44_1045506576053493867'
            },
            {
                source: '44_30318676383519339',
                value: 1,
                target: '44_1044629715345756296'
            },
            {
                source: '44_30318676383519339',
                value: 1,
                target: '44_1007588293249900590'
            },
            {
                source: '44_30318676383519339',
                value: 1,
                target: '44_1007588293249900597'
            },
            {
                source: '44_30318676383519339',
                value: 1,
                target: '44_1007588293245665342'
            },
            {
                source: '44_30318676383519339',
                value: 1,
                target: '44_1007588293245665353'
            },
            {
                source: '44_30318676383519339',
                value: 1,
                target: '44_1045507118599303180'
            },
            {
                source: '44_30318676383519339',
                value: 1,
                target: '44_1044629715345756289'
            },
            {
                source: '1008937987695734905',
                value: 1,
                target: '44_30318677033253094'
            },
            {
                source: '44_30318677033253094',
                value: 1,
                target: '44_30318677033431667'
            },
            {
                source: '44_30318677033253094',
                value: 1,
                target: '44_30318677033439660'
            },
            {
                source: '44_30318677033253094',
                value: 1,
                target: '44_30318677033442980'
            },
            {
                source: '44_30318677033253094',
                value: 1,
                target: '44_30318677033445602'
            },
            {
                source: '44_30318677033253094',
                value: 1,
                target: '44_30318677033448119'
            },
            {
                source: '1008937987695734905',
                value: 1,
                target: '44_30318677038111520'
            },
            {
                source: '44_30318677038111520',
                value: 1,
                target: '44_30318677038273894'
            },
            {
                source: '44_30318677038111520',
                value: 1,
                target: '44_30318677038280415'
            },
            {
                source: '44_30318677038111520',
                value: 1,
                target: '44_30318677038282736'
            },
            {
                source: '44_30318677038111520',
                value: 1,
                target: '44_30318677038294214'
            },
            {
                source: '44_30318677038111520',
                value: 1,
                target: '44_30318677038297305'
            },
            {
                source: '1008937987695734905',
                value: 1,
                target: '44_30318677038302831'
            },
            {
                source: '44_30318677038302831',
                value: 1,
                target: '44_30318677043523427'
            },
            {
                source: '44_30318677038302831',
                value: 1,
                target: '44_30318677070779917'
            },
            {
                source: '44_30318677038302831',
                value: 1,
                target: '44_30318677098517739'
            },
            {
                source: '44_30318677038302831',
                value: 1,
                target: '44_30318677130270564'
            },
            {
                source: '44_30318677038302831',
                value: 1,
                target: '44_30318677156674816'
            },
            {
                source: '1008937987695734905',
                value: 1,
                target: '44_30318677190228794'
            },
            {
                source: '44_30318677190228794',
                value: 1,
                target: '44_30318677190265782'
            },
            {
                source: '44_30318677190228794',
                value: 1,
                target: '44_30318677190271019'
            },
            {
                source: '1008937987695734905',
                value: 1,
                target: '44_30318677190277586'
            },
            {
                source: '1008937987695734905',
                value: 1,
                target: '44_30318677760973840'
            },
            {
                source: '1008937987695734905',
                value: 1,
                target: '44_30318678151109039'
            },
            {
                source: '44_30318678151109039',
                value: 1,
                target: '44_1031468355036397629'
            },
            {
                source: '44_30318678151109039',
                value: 1,
                target: '44_1031468354713464917'
            },
            {
                source: '44_30318678151109039',
                value: 1,
                target: '44_1031468354918940782'
            },
            {
                source: '44_30318678151109039',
                value: 1,
                target: '44_1031468355036397661'
            },
            {
                source: '44_30318678151109039',
                value: 1,
                target: '44_1031468355271299221'
            },
            {
                source: '44_30318678151109039',
                value: 1,
                target: '44_1031468355367759972'
            },
            {
                source: '44_30318678151109039',
                value: 1,
                target: '44_1031468355141263437'
            },
            {
                source: '44_30318678151109039',
                value: 1,
                target: '44_1031468355141263403'
            },
            {
                source: '44_30318678151109039',
                value: 1,
                target: '44_1031468355271299158'
            },
            {
                source: '44_30318678151109039',
                value: 1,
                target: '44_1031468355036397670'
            },
            {
                source: '44_30318678151109039',
                value: 1,
                target: '44_1031468354713464856'
            },
            {
                source: '44_30318678151109039',
                value: 1,
                target: '44_1031468355271299163'
            },
            {
                source: '44_30318678151109039',
                value: 1,
                target: '44_1031468354814115949'
            },
            {
                source: '44_30318678151109039',
                value: 1,
                target: '44_1031468354713464875'
            },
            {
                source: '44_30318678151109039',
                value: 1,
                target: '44_1031468354373709875'
            },
            {
                source: '44_30318678151109039',
                value: 1,
                target: '44_1031468354814115945'
            },
            {
                source: '44_30318678151109039',
                value: 1,
                target: '44_1031468354814115910'
            },
            {
                source: '44_30318678151109039',
                value: 1,
                target: '44_1031468355141263394'
            },
            {
                source: '44_30318678151109039',
                value: 1,
                target: '44_1031468354373709885'
            },
            {
                source: '44_30318678151109039',
                value: 1,
                target: '44_1031468354373709836'
            },
            {
                source: '1008937987695734905',
                value: 1,
                target: '44_30318678799108160'
            },
            {
                source: '44_30318678799108160',
                value: 1,
                target: '44_30318678799164252'
            },
            {
                source: '44_30318678799108160',
                value: 1,
                target: '44_30318678799181063'
            },
            {
                source: '1007588047111340137',
                value: 1,
                target: '1063129407759102074'
            },
            {
                source: '1063129407759102074',
                value: 1,
                target: '106_30318821965358789'
            },
            {
                source: '106_30318821965358789',
                value: 1,
                target: '106_1129789029227716659'
            },
            {
                source: '106_30318821965358789',
                value: 1,
                target: '106_1115655665243652244'
            },
            {
                source: '106_30318821965358789',
                value: 1,
                target: '106_1125440144644526139'
            },
            {
                source: '106_30318821965358789',
                value: 1,
                target: '106_1063833990244356163'
            },
            {
                source: '106_30318821965358789',
                value: 1,
                target: '106_1063833903581663364'
            },
            {
                source: '106_30318821965358789',
                value: 1,
                target: '106_1125440153767129159'
            },
            {
                source: '106_30318821965358789',
                value: 1,
                target: '106_1063833908182835284'
            },
            {
                source: '106_30318821965358789',
                value: 1,
                target: '106_1063833930769166456'
            },
            {
                source: '106_30318821965358789',
                value: 1,
                target: '106_1125440102617620521'
            },
            {
                source: '106_30318821965358789',
                value: 1,
                target: '106_1067094696733483125'
            },
            {
                source: '1063129407759102074',
                value: 1,
                target: '106_30318822405330351'
            },
            {
                source: '106_30318822405330351',
                value: 1,
                target: '106_30318822405450556'
            },
            {
                source: '106_30318822405330351',
                value: 1,
                target: '106_30318822405456647'
            },
            {
                source: '106_30318822405330351',
                value: 1,
                target: '106_30318822405459698'
            },
            {
                source: '1063129407759102074',
                value: 1,
                target: '106_30318822409803589'
            },
            {
                source: '106_30318822409803589',
                value: 1,
                target: '106_30318822409879084'
            },
            {
                source: '106_30318822409803589',
                value: 1,
                target: '106_30318822409883790'
            },
            {
                source: '106_30318822409803589',
                value: 1,
                target: '106_30318822409885723'
            },
            {
                source: '106_30318822409803589',
                value: 1,
                target: '106_30318822409887452'
            },
            {
                source: '106_30318822409803589',
                value: 1,
                target: '106_30318822409889022'
            },
            {
                source: '1063129407759102074',
                value: 1,
                target: '106_30318822409894371'
            },
            {
                source: '106_30318822409894371',
                value: 1,
                target: '106_30318822414368995'
            },
            {
                source: '106_30318822409894371',
                value: 1,
                target: '106_30318822441992036'
            },
            {
                source: '106_30318822409894371',
                value: 1,
                target: '106_30318822469333678'
            },
            {
                source: '106_30318822409894371',
                value: 1,
                target: '106_30318822495827904'
            },
            {
                source: '106_30318822409894371',
                value: 1,
                target: '106_30318822522398449'
            },
            {
                source: '1063129407759102074',
                value: 1,
                target: '106_30318822558298561'
            },
            {
                source: '106_30318822558298561',
                value: 1,
                target: '106_30318822558321871'
            },
            {
                source: '106_30318822558298561',
                value: 1,
                target: '106_30318822558325987'
            },
            {
                source: '1063129407759102074',
                value: 1,
                target: '106_30318822558332324'
            },
            {
                source: '1063129407759102074',
                value: 1,
                target: '106_30318822593191493'
            },
            {
                source: '1063129407759102074',
                value: 1,
                target: '106_30318822945427484'
            },
            {
                source: '106_30318822945427484',
                value: 1,
                target: '106_1031468354713464917'
            },
            {
                source: '106_30318822945427484',
                value: 1,
                target: '106_1031468354918940782'
            },
            {
                source: '106_30318822945427484',
                value: 1,
                target: '106_1031468354918940725'
            },
            {
                source: '106_30318822945427484',
                value: 1,
                target: '106_1031468355036397670'
            },
            {
                source: '106_30318822945427484',
                value: 1,
                target: '106_1031468355271299241'
            },
            {
                source: '106_30318822945427484',
                value: 1,
                target: '106_1031468354814115921'
            },
            {
                source: '1063129407759102074',
                value: 1,
                target: '106_30318823181985722'
            },
            {
                source: '106_30318823181985722',
                value: 1,
                target: '106_30318823182032805'
            },
            {
                source: '30318562283868170',
                value: 1,
                target: '1007588047111340132'
            },
            {
                source: '1007588047111340132',
                value: 1,
                target: '1008936832483758197'
            },
            {
                source: '1008936832483758197',
                value: 1,
                target: '9_30318589092591619'
            },
            {
                source: '9_30318589092591619',
                value: 1,
                target: '9_1007587853191909525'
            },
            {
                source: '9_30318589092591619',
                value: 1,
                target: '9_1007587853347070083'
            },
            {
                source: '9_30318589092591619',
                value: 1,
                target: '9_1027976810542956579'
            },
            {
                source: '9_30318589092591619',
                value: 1,
                target: '9_1045506332351807533'
            },
            {
                source: '9_30318589092591619',
                value: 1,
                target: '9_1007587853225439259'
            },
            {
                source: '9_30318589092591619',
                value: 1,
                target: '9_1045506528221614168'
            },
            {
                source: '9_30318589092591619',
                value: 1,
                target: '9_1007587853347070144'
            },
            {
                source: '9_30318589092591619',
                value: 1,
                target: '9_1007587853225439262'
            },
            {
                source: '9_30318589092591619',
                value: 1,
                target: '9_1007587853191909526'
            },
            {
                source: '9_30318589092591619',
                value: 1,
                target: '9_1007587853191909527'
            },
            {
                source: '1008936832483758197',
                value: 1,
                target: '9_30318589827805019'
            },
            {
                source: '9_30318589827805019',
                value: 1,
                target: '9_30318589827981479'
            },
            {
                source: '9_30318589827805019',
                value: 1,
                target: '9_30318589827989720'
            },
            {
                source: '9_30318589827805019',
                value: 1,
                target: '9_30318589827993608'
            },
            {
                source: '9_30318589827805019',
                value: 1,
                target: '9_30318589827996698'
            },
            {
                source: '1008936832483758197',
                value: 1,
                target: '9_30318589833557800'
            },
            {
                source: '9_30318589833557800',
                value: 1,
                target: '9_30318589833707635'
            },
            {
                source: '9_30318589833557800',
                value: 1,
                target: '9_30318589833714413'
            },
            {
                source: '9_30318589833557800',
                value: 1,
                target: '9_30318589833717076'
            },
            {
                source: '9_30318589833557800',
                value: 1,
                target: '9_30318589833719368'
            },
            {
                source: '9_30318589833557800',
                value: 1,
                target: '9_30318589833721233'
            },
            {
                source: '1008936832483758197',
                value: 1,
                target: '9_30318589833725960'
            },
            {
                source: '9_30318589833725960',
                value: 1,
                target: '9_30318589839752762'
            },
            {
                source: '9_30318589833725960',
                value: 1,
                target: '9_30318589871282707'
            },
            {
                source: '9_30318589833725960',
                value: 1,
                target: '9_30318589899064040'
            },
            {
                source: '9_30318589833725960',
                value: 1,
                target: '9_30318589929737135'
            },
            {
                source: '9_30318589833725960',
                value: 1,
                target: '9_30318589958528410'
            },
            {
                source: '1008936832483758197',
                value: 1,
                target: '9_30318589991204663'
            },
            {
                source: '9_30318589991204663',
                value: 1,
                target: '9_30318589991237399'
            },
            {
                source: '9_30318589991204663',
                value: 1,
                target: '9_30318589991241624'
            },
            {
                source: '1008936832483758197',
                value: 1,
                target: '9_30318589991247912'
            },
            {
                source: '1008936832483758197',
                value: 1,
                target: '9_30318590548267588'
            },
            {
                source: '1008936832483758197',
                value: 1,
                target: '9_30318590868616828'
            },
            {
                source: '9_30318590868616828',
                value: 1,
                target: '9_1031468354713464917'
            },
            {
                source: '9_30318590868616828',
                value: 1,
                target: '9_1031468354918940782'
            },
            {
                source: '9_30318590868616828',
                value: 1,
                target: '9_1031468355271299158'
            },
            {
                source: '9_30318590868616828',
                value: 1,
                target: '9_1031468355036397661'
            },
            {
                source: '9_30318590868616828',
                value: 1,
                target: '9_1031468355271299221'
            },
            {
                source: '9_30318590868616828',
                value: 1,
                target: '9_1031468354373709836'
            },
            {
                source: '9_30318590868616828',
                value: 1,
                target: '9_1031468354373709875'
            },
            {
                source: '9_30318590868616828',
                value: 1,
                target: '9_1031468355271299168'
            },
            {
                source: '9_30318590868616828',
                value: 1,
                target: '9_1031468354814115949'
            },
            {
                source: '9_30318590868616828',
                value: 1,
                target: '9_1031468354814115910'
            },
            {
                source: '9_30318590868616828',
                value: 1,
                target: '9_1031468354713464875'
            },
            {
                source: '9_30318590868616828',
                value: 1,
                target: '9_1031468354918940740'
            },
            {
                source: '9_30318590868616828',
                value: 1,
                target: '9_1031468355141263428'
            },
            {
                source: '9_30318590868616828',
                value: 1,
                target: '9_1031468355036397607'
            },
            {
                source: '9_30318590868616828',
                value: 1,
                target: '9_1031468355036397670'
            },
            {
                source: '9_30318590868616828',
                value: 1,
                target: '9_1031468354814115945'
            },
            {
                source: '9_30318590868616828',
                value: 1,
                target: '9_1031468354373709885'
            },
            {
                source: '9_30318590868616828',
                value: 1,
                target: '9_1031468354713464923'
            },
            {
                source: '9_30318590868616828',
                value: 1,
                target: '9_1031468355141263394'
            },
            {
                source: '9_30318590868616828',
                value: 1,
                target: '9_1031468354814115897'
            },
            {
                source: '1008936832483758197',
                value: 1,
                target: '9_30318591530224398'
            },
            {
                source: '9_30318591530224398',
                value: 1,
                target: '9_30318591530290502'
            },
            {
                source: '9_30318591530224398',
                value: 1,
                target: '9_30318591530296387'
            },
            {
                source: '1007588047111340132',
                value: 1,
                target: '1008937110784213055'
            },
            {
                source: '1008937110784213055',
                value: 1,
                target: '58_30318711858580677'
            },
            {
                source: '58_30318711858580677',
                value: 1,
                target: '58_1007588124353626257'
            },
            {
                source: '58_30318711858580677',
                value: 1,
                target: '58_1007588124353626268'
            },
            {
                source: '58_30318711858580677',
                value: 1,
                target: '58_1007588124353626243'
            },
            {
                source: '58_30318711858580677',
                value: 1,
                target: '58_1007588124429123662'
            },
            {
                source: '58_30318711858580677',
                value: 1,
                target: '58_1007588124374618402'
            },
            {
                source: '58_30318711858580677',
                value: 1,
                target: '58_1007588124374618401'
            },
            {
                source: '58_30318711858580677',
                value: 1,
                target: '58_1007588124353626272'
            },
            {
                source: '58_30318711858580677',
                value: 1,
                target: '58_1007588124374618404'
            },
            {
                source: '58_30318711858580677',
                value: 1,
                target: '58_1007588124374618372'
            },
            {
                source: '58_30318711858580677',
                value: 1,
                target: '58_1007588124412387408'
            },
            {
                source: '1008937110784213055',
                value: 1,
                target: '58_30318712631137454'
            },
            {
                source: '58_30318712631137454',
                value: 1,
                target: '58_30318712631312041'
            },
            {
                source: '58_30318712631137454',
                value: 1,
                target: '58_30318712631319904'
            },
            {
                source: '58_30318712631137454',
                value: 1,
                target: '58_30318712631322614'
            },
            {
                source: '58_30318712631137454',
                value: 1,
                target: '58_30318712631325044'
            },
            {
                source: '1008937110784213055',
                value: 1,
                target: '58_30318712639191275'
            },
            {
                source: '58_30318712639191275',
                value: 1,
                target: '58_30318712639333154'
            },
            {
                source: '58_30318712639191275',
                value: 1,
                target: '58_30318712639339009'
            },
            {
                source: '58_30318712639191275',
                value: 1,
                target: '58_30318712639341041'
            },
            {
                source: '58_30318712639191275',
                value: 1,
                target: '58_30318712639342655'
            },
            {
                source: '58_30318712639191275',
                value: 1,
                target: '58_30318712639344317'
            },
            {
                source: '1008937110784213055',
                value: 1,
                target: '58_30318712639349502'
            },
            {
                source: '58_30318712639349502',
                value: 1,
                target: '58_30318712645735643'
            },
            {
                source: '58_30318712639349502',
                value: 1,
                target: '58_30318712677478910'
            },
            {
                source: '58_30318712639349502',
                value: 1,
                target: '58_30318712709037625'
            },
            {
                source: '58_30318712639349502',
                value: 1,
                target: '58_30318712736902238'
            },
            {
                source: '58_30318712639349502',
                value: 1,
                target: '58_30318712765129407'
            },
            {
                source: '1008937110784213055',
                value: 1,
                target: '58_30318712805510252'
            },
            {
                source: '58_30318712805510252',
                value: 1,
                target: '58_30318712805539652'
            },
            {
                source: '58_30318712805510252',
                value: 1,
                target: '58_30318712805544783'
            },
            {
                source: '1008937110784213055',
                value: 1,
                target: '58_30318712805553779'
            },
            {
                source: '1008937110784213055',
                value: 1,
                target: '58_30318713366387335'
            },
            {
                source: '1008937110784213055',
                value: 1,
                target: '58_30318713674538621'
            },
            {
                source: '58_30318713674538621',
                value: 1,
                target: '58_1031468354713464917'
            },
            {
                source: '58_30318713674538621',
                value: 1,
                target: '58_1031468354918940782'
            },
            {
                source: '58_30318713674538621',
                value: 1,
                target: '58_1031468354814115900'
            },
            {
                source: '58_30318713674538621',
                value: 1,
                target: '58_1031468354373709836'
            },
            {
                source: '58_30318713674538621',
                value: 1,
                target: '58_1031468355271299221'
            },
            {
                source: '58_30318713674538621',
                value: 1,
                target: '58_1031468355036397661'
            },
            {
                source: '58_30318713674538621',
                value: 1,
                target: '58_1031468354713464875'
            },
            {
                source: '58_30318713674538621',
                value: 1,
                target: '58_1031468354918940740'
            },
            {
                source: '58_30318713674538621',
                value: 1,
                target: '58_1031468354814115949'
            },
            {
                source: '58_30318713674538621',
                value: 1,
                target: '58_1031468355271299158'
            },
            {
                source: '58_30318713674538621',
                value: 1,
                target: '58_1031468355271299168'
            },
            {
                source: '58_30318713674538621',
                value: 1,
                target: '58_1031468354814115945'
            },
            {
                source: '58_30318713674538621',
                value: 1,
                target: '58_1031468354373709875'
            },
            {
                source: '58_30318713674538621',
                value: 1,
                target: '58_1031468354918940739'
            },
            {
                source: '58_30318713674538621',
                value: 1,
                target: '58_1031468355367759987'
            },
            {
                source: '58_30318713674538621',
                value: 1,
                target: '58_1031468354373709885'
            },
            {
                source: '58_30318713674538621',
                value: 1,
                target: '58_1031468355141263394'
            },
            {
                source: '58_30318713674538621',
                value: 1,
                target: '58_1031468354918940743'
            },
            {
                source: '58_30318713674538621',
                value: 1,
                target: '58_1031468355141263390'
            },
            {
                source: '58_30318713674538621',
                value: 1,
                target: '58_1031468354713464923'
            },
            {
                source: '1008937110784213055',
                value: 1,
                target: '58_30318714306512144'
            },
            {
                source: '58_30318714306512144',
                value: 1,
                target: '58_30318714306554899'
            },
            {
                source: '58_30318714306512144',
                value: 1,
                target: '58_30318714306559295'
            },
            {
                source: '1008936154810036313',
                value: 1,
                target: '30318563348726285'
            },
            {
                source: '30318563348726285',
                value: 1,
                target: '1008937085891010634'
            },
            {
                source: '1008937085891010634',
                value: 1,
                target: '77_30318757732834437'
            },
            {
                source: '77_30318757732834437',
                value: 1,
                target: '77_1007587633750097925'
            },
            {
                source: '77_30318757732834437',
                value: 1,
                target: '77_1011842094664294594'
            },
            {
                source: '77_30318757732834437',
                value: 1,
                target: '77_1014565076939612250'
            },
            {
                source: '77_30318757732834437',
                value: 1,
                target: '77_1007587633750097931'
            },
            {
                source: '77_30318757732834437',
                value: 1,
                target: '77_1007587633750097930'
            },
            {
                source: '77_30318757732834437',
                value: 1,
                target: '77_1007587633750097940'
            },
            {
                source: '77_30318757732834437',
                value: 1,
                target: '77_1045507111569612906'
            },
            {
                source: '77_30318757732834437',
                value: 1,
                target: '77_1007587633792045222'
            },
            {
                source: '77_30318757732834437',
                value: 1,
                target: '77_1045506299531378791'
            },
            {
                source: '77_30318757732834437',
                value: 1,
                target: '77_1007587633750097932'
            },
            {
                source: '1008937085891010634',
                value: 1,
                target: '77_30318758486364003'
            },
            {
                source: '77_30318758486364003',
                value: 1,
                target: '77_30318758486503492'
            },
            {
                source: '77_30318758486364003',
                value: 1,
                target: '77_30318758486510124'
            },
            {
                source: '77_30318758486364003',
                value: 1,
                target: '77_30318758486513475'
            },
            {
                source: '77_30318758486364003',
                value: 1,
                target: '77_30318758486515684'
            },
            {
                source: '1008937085891010634',
                value: 1,
                target: '77_30318758493694024'
            },
            {
                source: '77_30318758493694024',
                value: 1,
                target: '77_30318758493827036'
            },
            {
                source: '77_30318758493694024',
                value: 1,
                target: '77_30318758493832886'
            },
            {
                source: '77_30318758493694024',
                value: 1,
                target: '77_30318758493834883'
            },
            {
                source: '77_30318758493694024',
                value: 1,
                target: '77_30318758493836433'
            },
            {
                source: '77_30318758493694024',
                value: 1,
                target: '77_30318758493837962'
            },
            {
                source: '1008937085891010634',
                value: 1,
                target: '77_30318758493842859'
            },
            {
                source: '77_30318758493842859',
                value: 1,
                target: '77_30318758499972325'
            },
            {
                source: '77_30318758493842859',
                value: 1,
                target: '77_30318758527886528'
            },
            {
                source: '77_30318758493842859',
                value: 1,
                target: '77_30318758554824676'
            },
            {
                source: '77_30318758493842859',
                value: 1,
                target: '77_30318758586323171'
            },
            {
                source: '77_30318758493842859',
                value: 1,
                target: '77_30318758614365964'
            },
            {
                source: '1008937085891010634',
                value: 1,
                target: '77_30318758648670711'
            },
            {
                source: '77_30318758648670711',
                value: 1,
                target: '77_30318758648704148'
            },
            {
                source: '77_30318758648670711',
                value: 1,
                target: '77_30318758648715121'
            },
            {
                source: '1008937085891010634',
                value: 1,
                target: '77_30318758648722385'
            },
            {
                source: '1008937085891010634',
                value: 1,
                target: '77_30318759184713522'
            },
            {
                source: '1008937085891010634',
                value: 1,
                target: '77_30318759505326246'
            },
            {
                source: '77_30318759505326246',
                value: 1,
                target: '77_1031468354713464917'
            },
            {
                source: '77_30318759505326246',
                value: 1,
                target: '77_1031468354918940782'
            },
            {
                source: '77_30318759505326246',
                value: 1,
                target: '77_1031468355271299221'
            },
            {
                source: '77_30318759505326246',
                value: 1,
                target: '77_1031468354814115910'
            },
            {
                source: '77_30318759505326246',
                value: 1,
                target: '77_1031468355271299158'
            },
            {
                source: '77_30318759505326246',
                value: 1,
                target: '77_1031468355036397661'
            },
            {
                source: '77_30318759505326246',
                value: 1,
                target: '77_1031468354713464875'
            },
            {
                source: '77_30318759505326246',
                value: 1,
                target: '77_1031468354373709875'
            },
            {
                source: '77_30318759505326246',
                value: 1,
                target: '77_1031468354814115949'
            },
            {
                source: '77_30318759505326246',
                value: 1,
                target: '77_1031468354373709836'
            },
            {
                source: '77_30318759505326246',
                value: 1,
                target: '77_1031468354814115900'
            },
            {
                source: '77_30318759505326246',
                value: 1,
                target: '77_1031468354713464923'
            },
            {
                source: '77_30318759505326246',
                value: 1,
                target: '77_1031468355271299168'
            },
            {
                source: '77_30318759505326246',
                value: 1,
                target: '77_1031468354373709887'
            },
            {
                source: '77_30318759505326246',
                value: 1,
                target: '77_1031468355141263394'
            },
            {
                source: '77_30318759505326246',
                value: 1,
                target: '77_1031468355036397662'
            },
            {
                source: '77_30318759505326246',
                value: 1,
                target: '77_1031468355271299238'
            },
            {
                source: '77_30318759505326246',
                value: 1,
                target: '77_1031468355141263428'
            },
            {
                source: '77_30318759505326246',
                value: 1,
                target: '77_1031468354814115945'
            },
            {
                source: '77_30318759505326246',
                value: 1,
                target: '77_1031468355271299233'
            },
            {
                source: '1008937085891010634',
                value: 1,
                target: '77_30318760158216253'
            },
            {
                source: '77_30318760158216253',
                value: 1,
                target: '77_30318760158266327'
            },
            {
                source: '77_30318760158216253',
                value: 1,
                target: '77_30318760158271476'
            },
            {
                source: '30318563348726285',
                value: 1,
                target: '1008936196505604180'
            },
            {
                source: '1008936196505604180',
                value: 1,
                target: '123_30318857994570477'
            },
            {
                source: '123_30318857994570477',
                value: 1,
                target: '123_1007587597825908789'
            },
            {
                source: '123_30318857994570477',
                value: 1,
                target: '123_1065645408904077352'
            },
            {
                source: '123_30318857994570477',
                value: 1,
                target: '123_1007587597830103160'
            },
            {
                source: '123_30318857994570477',
                value: 1,
                target: '123_1108407359861960839'
            },
            {
                source: '123_30318857994570477',
                value: 1,
                target: '123_1007587597863632992'
            },
            {
                source: '123_30318857994570477',
                value: 1,
                target: '123_1123628760017432712'
            },
            {
                source: '123_30318857994570477',
                value: 1,
                target: '123_1044629367428231320'
            },
            {
                source: '123_30318857994570477',
                value: 1,
                target: '123_1007587597809115222'
            },
            {
                source: '123_30318857994570477',
                value: 1,
                target: '123_1007587597809115224'
            },
            {
                source: '123_30318857994570477',
                value: 1,
                target: '123_1034848705309589601'
            },
            {
                source: '1008936196505604180',
                value: 1,
                target: '123_30318858697122680'
            },
            {
                source: '123_30318858697122680',
                value: 1,
                target: '123_30318858697245868'
            },
            {
                source: '123_30318858697122680',
                value: 1,
                target: '123_30318858697251970'
            },
            {
                source: '123_30318858697122680',
                value: 1,
                target: '123_30318858697254578'
            },
            {
                source: '123_30318858697122680',
                value: 1,
                target: '123_30318858697257533'
            },
            {
                source: '1008936196505604180',
                value: 1,
                target: '123_30318858703951972'
            },
            {
                source: '123_30318858703951972',
                value: 1,
                target: '123_30318858704080526'
            },
            {
                source: '123_30318858703951972',
                value: 1,
                target: '123_30318858704086459'
            },
            {
                source: '123_30318858703951972',
                value: 1,
                target: '123_30318858704088546'
            },
            {
                source: '123_30318858703951972',
                value: 1,
                target: '123_30318858704090347'
            },
            {
                source: '123_30318858703951972',
                value: 1,
                target: '123_30318858704092269'
            },
            {
                source: '1008936196505604180',
                value: 1,
                target: '123_30318858704098299'
            },
            {
                source: '123_30318858704098299',
                value: 1,
                target: '123_30318858710610348'
            },
            {
                source: '123_30318858704098299',
                value: 1,
                target: '123_30318858737688230'
            },
            {
                source: '123_30318858704098299',
                value: 1,
                target: '123_30318858764613563'
            },
            {
                source: '123_30318858704098299',
                value: 1,
                target: '123_30318858795986600'
            },
            {
                source: '123_30318858704098299',
                value: 1,
                target: '123_30318858826886966'
            },
            {
                source: '1008936196505604180',
                value: 1,
                target: '123_30318858860168847'
            },
            {
                source: '123_30318858860168847',
                value: 1,
                target: '123_30318858860200724'
            },
            {
                source: '123_30318858860168847',
                value: 1,
                target: '123_30318858860205251'
            },
            {
                source: '1008936196505604180',
                value: 1,
                target: '123_30318858860212895'
            },
            {
                source: '1008936196505604180',
                value: 1,
                target: '123_30318859415465981'
            },
            {
                source: '1008936196505604180',
                value: 1,
                target: '123_30318859762596987'
            },
            {
                source: '123_30318859762596987',
                value: 1,
                target: '123_1031468354713464917'
            },
            {
                source: '123_30318859762596987',
                value: 1,
                target: '123_1031468354918940782'
            },
            {
                source: '123_30318859762596987',
                value: 1,
                target: '123_1031468355271299221'
            },
            {
                source: '123_30318859762596987',
                value: 1,
                target: '123_1031468354814115910'
            },
            {
                source: '123_30318859762596987',
                value: 1,
                target: '123_1031468355271299158'
            },
            {
                source: '123_30318859762596987',
                value: 1,
                target: '123_1031468354713464875'
            },
            {
                source: '123_30318859762596987',
                value: 1,
                target: '123_1031468354373709875'
            },
            {
                source: '123_30318859762596987',
                value: 1,
                target: '123_1031468355036397661'
            },
            {
                source: '123_30318859762596987',
                value: 1,
                target: '123_1031468354713464923'
            },
            {
                source: '123_30318859762596987',
                value: 1,
                target: '123_1031468354373709836'
            },
            {
                source: '123_30318859762596987',
                value: 1,
                target: '123_1031468354814115949'
            },
            {
                source: '123_30318859762596987',
                value: 1,
                target: '123_1031468355036397660'
            },
            {
                source: '123_30318859762596987',
                value: 1,
                target: '123_1031468355141263412'
            },
            {
                source: '123_30318859762596987',
                value: 1,
                target: '123_1031468355367759987'
            },
            {
                source: '123_30318859762596987',
                value: 1,
                target: '123_1031468355367759972'
            },
            {
                source: '123_30318859762596987',
                value: 1,
                target: '123_1031468355036397662'
            },
            {
                source: '123_30318859762596987',
                value: 1,
                target: '123_1031468355271299238'
            },
            {
                source: '123_30318859762596987',
                value: 1,
                target: '123_1031468354814115945'
            },
            {
                source: '123_30318859762596987',
                value: 1,
                target: '123_1031468355271299168'
            },
            {
                source: '123_30318859762596987',
                value: 1,
                target: '123_1031468354373709887'
            },
            {
                source: '1008936196505604180',
                value: 1,
                target: '123_30318860408186117'
            },
            {
                source: '123_30318860408186117',
                value: 1,
                target: '123_30318860408379275'
            },
            {
                source: '30318563348726285',
                value: 1,
                target: '1008939929524265093'
            },
            {
                source: '1008939929524265093',
                value: 1,
                target: '47_30318683945516956'
            },
            {
                source: '47_30318683945516956',
                value: 1,
                target: '47_1007588218285076523'
            },
            {
                source: '47_30318683945516956',
                value: 1,
                target: '47_1007588218280886359'
            },
            {
                source: '47_30318683945516956',
                value: 1,
                target: '47_1007588218280886358'
            },
            {
                source: '47_30318683945516956',
                value: 1,
                target: '47_1007588218280886369'
            },
            {
                source: '47_30318683945516956',
                value: 1,
                target: '47_1007588218314432572'
            },
            {
                source: '47_30318683945516956',
                value: 1,
                target: '47_1007588218280886363'
            },
            {
                source: '47_30318683945516956',
                value: 1,
                target: '47_1007588218280886368'
            },
            {
                source: '47_30318683945516956',
                value: 1,
                target: '47_1007588218280886356'
            },
            {
                source: '47_30318683945516956',
                value: 1,
                target: '47_1007588218280886355'
            },
            {
                source: '47_30318683945516956',
                value: 1,
                target: '47_1007588218280886354'
            },
            {
                source: '1008939929524265093',
                value: 1,
                target: '47_30318684629760902'
            },
            {
                source: '47_30318684629760902',
                value: 1,
                target: '47_30318684629918940'
            },
            {
                source: '47_30318684629760902',
                value: 1,
                target: '47_30318684629924606'
            },
            {
                source: '47_30318684629760902',
                value: 1,
                target: '47_30318684629927774'
            },
            {
                source: '47_30318684629760902',
                value: 1,
                target: '47_30318684629929897'
            },
            {
                source: '1008939929524265093',
                value: 1,
                target: '47_30318684636848025'
            },
            {
                source: '47_30318684636848025',
                value: 1,
                target: '47_30318684637018535'
            },
            {
                source: '47_30318684636848025',
                value: 1,
                target: '47_30318684637024574'
            },
            {
                source: '47_30318684636848025',
                value: 1,
                target: '47_30318684637026419'
            },
            {
                source: '47_30318684636848025',
                value: 1,
                target: '47_30318684637028452'
            },
            {
                source: '47_30318684636848025',
                value: 1,
                target: '47_30318684637030415'
            },
            {
                source: '1008939929524265093',
                value: 1,
                target: '47_30318684637035309'
            },
            {
                source: '47_30318684637035309',
                value: 1,
                target: '47_30318684643582195'
            },
            {
                source: '47_30318684637035309',
                value: 1,
                target: '47_30318684674719586'
            },
            {
                source: '47_30318684637035309',
                value: 1,
                target: '47_30318684702102161'
            },
            {
                source: '47_30318684637035309',
                value: 1,
                target: '47_30318684729974860'
            },
            {
                source: '47_30318684637035309',
                value: 1,
                target: '47_30318684761237635'
            },
            {
                source: '1008939929524265093',
                value: 1,
                target: '47_30318684795044301'
            },
            {
                source: '47_30318684795044301',
                value: 1,
                target: '47_30318684795092026'
            },
            {
                source: '47_30318684795044301',
                value: 1,
                target: '47_30318684795096583'
            },
            {
                source: '1008939929524265093',
                value: 1,
                target: '47_30318684795102579'
            },
            {
                source: '1008939929524265093',
                value: 1,
                target: '47_30318685371161043'
            },
            {
                source: '1008939929524265093',
                value: 1,
                target: '47_30318685746074893'
            },
            {
                source: '47_30318685746074893',
                value: 1,
                target: '47_1031468354713464917'
            },
            {
                source: '47_30318685746074893',
                value: 1,
                target: '47_1031468354918940782'
            },
            {
                source: '47_30318685746074893',
                value: 1,
                target: '47_1031468355141263398'
            },
            {
                source: '47_30318685746074893',
                value: 1,
                target: '47_1031468355271299221'
            },
            {
                source: '47_30318685746074893',
                value: 1,
                target: '47_1031468354814115949'
            },
            {
                source: '47_30318685746074893',
                value: 1,
                target: '47_1031468354814115910'
            },
            {
                source: '47_30318685746074893',
                value: 1,
                target: '47_1031468354373709836'
            },
            {
                source: '47_30318685746074893',
                value: 1,
                target: '47_1031468354713464875'
            },
            {
                source: '47_30318685746074893',
                value: 1,
                target: '47_1031468354373709875'
            },
            {
                source: '47_30318685746074893',
                value: 1,
                target: '47_1031468355271299158'
            },
            {
                source: '47_30318685746074893',
                value: 1,
                target: '47_1031468355271299233'
            },
            {
                source: '47_30318685746074893',
                value: 1,
                target: '47_1031468355036397670'
            },
            {
                source: '47_30318685746074893',
                value: 1,
                target: '47_1031468355036397661'
            },
            {
                source: '47_30318685746074893',
                value: 1,
                target: '47_1031468355141263412'
            },
            {
                source: '47_30318685746074893',
                value: 1,
                target: '47_1031468354713464923'
            },
            {
                source: '47_30318685746074893',
                value: 1,
                target: '47_1031468355141263394'
            },
            {
                source: '47_30318685746074893',
                value: 1,
                target: '47_1031468355271299236'
            },
            {
                source: '47_30318685746074893',
                value: 1,
                target: '47_1031468354373709885'
            },
            {
                source: '47_30318685746074893',
                value: 1,
                target: '47_1031468355271299238'
            },
            {
                source: '47_30318685746074893',
                value: 1,
                target: '47_1031468355367759999'
            },
            {
                source: '1008939929524265093',
                value: 1,
                target: '47_30318686390959182'
            },
            {
                source: '47_30318686390959182',
                value: 1,
                target: '47_30318686391028111'
            },
            {
                source: '47_30318686390959182',
                value: 1,
                target: '47_30318686391034125'
            },
            {
                source: '47_30318686390959182',
                value: 1,
                target: '47_30318686391036055'
            },
            {
                source: '1008936154810036313',
                value: 1,
                target: '30318563179951520'
            },
            {
                source: '30318563179951520',
                value: 1,
                target: '30318563180240430'
            },
            {
                source: '30318563179951520',
                value: 1,
                target: '30318563180228065'
            },
            {
                source: '30318563179951520',
                value: 1,
                target: '30318563180236987'
            },
            {
                source: '30318563179951520',
                value: 1,
                target: '30318563180232383'
            },
            {
                source: '30318563179951520',
                value: 1,
                target: '30318563180217907'
            },
            {
                source: '1008936154810036313',
                value: 1,
                target: '30318565081536274'
            },
            {
                source: '30318565081536274',
                value: 1,
                target: '30318565081777116'
            },
            {
                source: '30318565081536274',
                value: 1,
                target: '30318565081779797'
            },
            {
                source: '30318565081536274',
                value: 1,
                target: '30318565081753571'
            },
            {
                source: '30318565081536274',
                value: 1,
                target: '30318565081773865'
            },
            {
                source: '30318565081536274',
                value: 1,
                target: '30318565081738513'
            },
            {
                source: '1008936154810036313',
                value: 1,
                target: '30318563159461703'
            },
            {
                source: '30318563159461703',
                value: 1,
                target: '30318563174178688'
            },
            {
                source: '30318563159461703',
                value: 1,
                target: '30318563174185578'
            },
            {
                source: '30318563159461703',
                value: 1,
                target: '30318563174134008'
            },
            {
                source: '30318563159461703',
                value: 1,
                target: '30318563174191765'
            },
            {
                source: '1008936154810036313',
                value: 1,
                target: '30318563348637083'
            },
            {
                source: '30318563348637083',
                value: 1,
                target: '30318563348699045'
            },
            {
                source: '30318563348637083',
                value: 1,
                target: '30318563348694132'
            },
            {
                source: '1008936154810036313',
                value: 1,
                target: '30318564348979920'
            },
            {
                source: '30318564348979920',
                value: 1,
                target: '1031468354373709893'
            },
            {
                source: '1031468354373709893',
                value: 1,
                target: '1008938927878324362'
            },
            {
                source: '1008938927878324362',
                value: 1,
                target: '42_30318671260486534'
            },
            {
                source: '42_30318671260486534',
                value: 1,
                target: '42_1007588095693979790'
            },
            {
                source: '42_30318671260486534',
                value: 1,
                target: '42_1007588095656239238'
            },
            {
                source: '42_30318671260486534',
                value: 1,
                target: '42_1045506930048499831'
            },
            {
                source: '42_30318671260486534',
                value: 1,
                target: '42_1007588095656239243'
            },
            {
                source: '42_30318671260486534',
                value: 1,
                target: '42_1007588095656239241'
            },
            {
                source: '42_30318671260486534',
                value: 1,
                target: '42_1007588095656239236'
            },
            {
                source: '42_30318671260486534',
                value: 1,
                target: '42_1007588095656239235'
            },
            {
                source: '42_30318671260486534',
                value: 1,
                target: '42_1007588095765278856'
            },
            {
                source: '42_30318671260486534',
                value: 1,
                target: '42_1007588095656239245'
            },
            {
                source: '42_30318671260486534',
                value: 1,
                target: '42_1007588095656239244'
            },
            {
                source: '1008938927878324362',
                value: 1,
                target: '42_30318672050275115'
            },
            {
                source: '42_30318672050275115',
                value: 1,
                target: '42_30318672050532075'
            },
            {
                source: '42_30318672050275115',
                value: 1,
                target: '42_30318672050539981'
            },
            {
                source: '42_30318672050275115',
                value: 1,
                target: '42_30318672050542604'
            },
            {
                source: '42_30318672050275115',
                value: 1,
                target: '42_30318672050544690'
            },
            {
                source: '1008938927878324362',
                value: 1,
                target: '42_30318672056472333'
            },
            {
                source: '42_30318672056472333',
                value: 1,
                target: '42_30318672056621220'
            },
            {
                source: '42_30318672056472333',
                value: 1,
                target: '42_30318672056626579'
            },
            {
                source: '42_30318672056472333',
                value: 1,
                target: '42_30318672056628576'
            },
            {
                source: '42_30318672056472333',
                value: 1,
                target: '42_30318672056630183'
            },
            {
                source: '42_30318672056472333',
                value: 1,
                target: '42_30318672056631719'
            },
            {
                source: '1008938927878324362',
                value: 1,
                target: '42_30318672056636669'
            },
            {
                source: '42_30318672056636669',
                value: 1,
                target: '42_30318672062622516'
            },
            {
                source: '42_30318672056636669',
                value: 1,
                target: '42_30318672094708104'
            },
            {
                source: '42_30318672056636669',
                value: 1,
                target: '42_30318672126569332'
            },
            {
                source: '42_30318672056636669',
                value: 1,
                target: '42_30318672153873116'
            },
            {
                source: '42_30318672056636669',
                value: 1,
                target: '42_30318672181548905'
            },
            {
                source: '1008938927878324362',
                value: 1,
                target: '42_30318672219883617'
            },
            {
                source: '42_30318672219883617',
                value: 1,
                target: '42_30318672219921698'
            },
            {
                source: '42_30318672219883617',
                value: 1,
                target: '42_30318672219926111'
            },
            {
                source: '1008938927878324362',
                value: 1,
                target: '42_30318672219932300'
            },
            {
                source: '1008938927878324362',
                value: 1,
                target: '42_30318672728228199'
            },
            {
                source: '1008938927878324362',
                value: 1,
                target: '42_30318673046361323'
            },
            {
                source: '42_30318673046361323',
                value: 1,
                target: '42_1031468354918940778'
            },
            {
                source: '42_30318673046361323',
                value: 1,
                target: '42_1031468354918940782'
            },
            {
                source: '42_30318673046361323',
                value: 1,
                target: '42_1031468355036397661'
            },
            {
                source: '42_30318673046361323',
                value: 1,
                target: '42_1031468354713464931'
            },
            {
                source: '42_30318673046361323',
                value: 1,
                target: '42_1031468355271299168'
            },
            {
                source: '42_30318673046361323',
                value: 1,
                target: '42_1031468355271299158'
            },
            {
                source: '42_30318673046361323',
                value: 1,
                target: '42_1031468354373709875'
            },
            {
                source: '42_30318673046361323',
                value: 1,
                target: '42_1031468355141263394'
            },
            {
                source: '42_30318673046361323',
                value: 1,
                target: '42_1031468354918940768'
            },
            {
                source: '42_30318673046361323',
                value: 1,
                target: '42_1031468354373709887'
            },
            {
                source: '42_30318673046361323',
                value: 1,
                target: '42_1031468354918940725'
            },
            {
                source: '42_30318673046361323',
                value: 1,
                target: '42_1031468355036397670'
            },
            {
                source: '42_30318673046361323',
                value: 1,
                target: '42_1031468354713464871'
            },
            {
                source: '42_30318673046361323',
                value: 1,
                target: '42_1031468354814115895'
            },
            {
                source: '42_30318673046361323',
                value: 1,
                target: '42_1031468354373709893'
            },
            {
                source: '42_30318673046361323',
                value: 1,
                target: '42_1031468355036397638'
            },
            {
                source: '42_30318673046361323',
                value: 1,
                target: '42_1031468354713464897'
            },
            {
                source: '42_30318673046361323',
                value: 1,
                target: '42_1031468354373709905'
            },
            {
                source: '42_30318673046361323',
                value: 1,
                target: '42_1031468354717659145'
            },
            {
                source: '42_30318673046361323',
                value: 1,
                target: '42_1031468354814115949'
            },
            {
                source: '1008938927878324362',
                value: 1,
                target: '42_30318673760328809'
            },
            {
                source: '42_30318673760328809',
                value: 1,
                target: '42_30318673760386537'
            },
            {
                source: '42_30318673760328809',
                value: 1,
                target: '42_30318673760392160'
            },
            {
                source: '42_30318673760328809',
                value: 1,
                target: '42_30318673760408141'
            },
            {
                source: '42_30318673760328809',
                value: 1,
                target: '42_30318673760409967'
            },
            {
                source: '42_30318673760328809',
                value: 1,
                target: '42_30318673760411576'
            },
            {
                source: '30318564348979920',
                value: 1,
                target: '1031468354713464923'
            },
            {
                source: '1031468354713464923',
                value: 1,
                target: '1008937365227454569'
            },
            {
                source: '1008937365227454569',
                value: 1,
                target: '24_30318628048539203'
            },
            {
                source: '24_30318628048539203',
                value: 1,
                target: '24_1044629373002477649'
            },
            {
                source: '24_30318628048539203',
                value: 1,
                target: '24_1007587810284183727'
            },
            {
                source: '24_30318628048539203',
                value: 1,
                target: '24_1045506355219157051'
            },
            {
                source: '24_30318628048539203',
                value: 1,
                target: '24_1007587810275774581'
            },
            {
                source: '24_30318628048539203',
                value: 1,
                target: '24_1044994228268069055'
            },
            {
                source: '24_30318628048539203',
                value: 1,
                target: '24_1045506917230764121'
            },
            {
                source: '24_30318628048539203',
                value: 1,
                target: '24_1044994228268069031'
            },
            {
                source: '24_30318628048539203',
                value: 1,
                target: '24_1007587810284183721'
            },
            {
                source: '24_30318628048539203',
                value: 1,
                target: '24_1044994228268069052'
            },
            {
                source: '24_30318628048539203',
                value: 1,
                target: '24_1007587810275774531'
            },
            {
                source: '1008937365227454569',
                value: 1,
                target: '24_30318628861238008'
            },
            {
                source: '24_30318628861238008',
                value: 1,
                target: '24_30318628861411253'
            },
            {
                source: '24_30318628861238008',
                value: 1,
                target: '24_30318628861418297'
            },
            {
                source: '24_30318628861238008',
                value: 1,
                target: '24_30318628861421738'
            },
            {
                source: '24_30318628861238008',
                value: 1,
                target: '24_30318628861425521'
            },
            {
                source: '1008937365227454569',
                value: 1,
                target: '24_30318628867720747'
            },
            {
                source: '24_30318628867720747',
                value: 1,
                target: '24_30318628867920690'
            },
            {
                source: '24_30318628867720747',
                value: 1,
                target: '24_30318628867926905'
            },
            {
                source: '24_30318628867720747',
                value: 1,
                target: '24_30318628867929517'
            },
            {
                source: '24_30318628867720747',
                value: 1,
                target: '24_30318628867931816'
            },
            {
                source: '24_30318628867720747',
                value: 1,
                target: '24_30318628867933649'
            },
            {
                source: '1008937365227454569',
                value: 1,
                target: '24_30318628867938477'
            },
            {
                source: '24_30318628867938477',
                value: 1,
                target: '24_30318628872908490'
            },
            {
                source: '24_30318628867938477',
                value: 1,
                target: '24_30318628899950559'
            },
            {
                source: '24_30318628867938477',
                value: 1,
                target: '24_30318628931060906'
            },
            {
                source: '24_30318628867938477',
                value: 1,
                target: '24_30318628959941632'
            },
            {
                source: '24_30318628867938477',
                value: 1,
                target: '24_30318628987164715'
            },
            {
                source: '1008937365227454569',
                value: 1,
                target: '24_30318629022970160'
            },
            {
                source: '24_30318629022970160',
                value: 1,
                target: '24_30318629023022942'
            },
            {
                source: '24_30318629022970160',
                value: 1,
                target: '24_30318629023027875'
            },
            {
                source: '1008937365227454569',
                value: 1,
                target: '24_30318629023033551'
            },
            {
                source: '1008937365227454569',
                value: 1,
                target: '24_30318629682558124'
            },
            {
                source: '24_30318629682558124',
                value: 1,
                target: '1008937365227454569'
            },
            {
                source: '1008937365227454569',
                value: 1,
                target: '24_30318630089422043'
            },
            {
                source: '24_30318630089422043',
                value: 1,
                target: '24_1031468354713464917'
            },
            {
                source: '24_30318630089422043',
                value: 1,
                target: '24_1031468354918940782'
            },
            {
                source: '24_30318630089422043',
                value: 1,
                target: '24_1031468355271299168'
            },
            {
                source: '24_30318630089422043',
                value: 1,
                target: '24_1031468355271299158'
            },
            {
                source: '24_30318630089422043',
                value: 1,
                target: '24_1031468355367759987'
            },
            {
                source: '24_30318630089422043',
                value: 1,
                target: '24_1031468355036397661'
            },
            {
                source: '24_30318630089422043',
                value: 1,
                target: '24_1031468354713464871'
            },
            {
                source: '24_30318630089422043',
                value: 1,
                target: '24_1031468355036397670'
            },
            {
                source: '24_30318630089422043',
                value: 1,
                target: '24_1031468354373709875'
            },
            {
                source: '24_30318630089422043',
                value: 1,
                target: '24_1031468355141263412'
            },
            {
                source: '24_30318630089422043',
                value: 1,
                target: '24_1031468354814115937'
            },
            {
                source: '24_30318630089422043',
                value: 1,
                target: '24_1031468354814115949'
            },
            {
                source: '24_30318630089422043',
                value: 1,
                target: '24_1031468354713464923'
            },
            {
                source: '24_30318630089422043',
                value: 1,
                target: '24_1031468354373709836'
            },
            {
                source: '24_30318630089422043',
                value: 1,
                target: '24_1031468355141263394'
            },
            {
                source: '24_30318630089422043',
                value: 1,
                target: '24_1031468355141263447'
            },
            {
                source: '24_30318630089422043',
                value: 1,
                target: '24_1031468354713464875'
            },
            {
                source: '24_30318630089422043',
                value: 1,
                target: '24_1031468354373709885'
            },
            {
                source: '24_30318630089422043',
                value: 1,
                target: '24_1031468354713464862'
            },
            {
                source: '24_30318630089422043',
                value: 1,
                target: '24_1031468354717659145'
            },
            {
                source: '1008937365227454569',
                value: 1,
                target: '24_30318630743349357'
            },
            {
                source: '24_30318630743349357',
                value: 1,
                target: '24_30318630743401810'
            },
            {
                source: '24_30318630743349357',
                value: 1,
                target: '24_30318630743406692'
            },
            {
                source: '24_30318630743349357',
                value: 1,
                target: '24_30318630743408329'
            },
            {
                source: '24_30318630743349357',
                value: 1,
                target: '24_30318630743409979'
            },
            {
                source: '24_30318630743349357',
                value: 1,
                target: '24_30318630743411572'
            },
            {
                source: '1031468354713464923',
                value: 1,
                target: '1008938620507164753'
            },
            {
                source: '1008938620507164753',
                value: 1,
                target: '57_30318709393223438'
            },
            {
                source: '57_30318709393223438',
                value: 1,
                target: '57_1045507282290356327'
            },
            {
                source: '57_30318709393223438',
                value: 1,
                target: '57_1007587945051349113'
            },
            {
                source: '57_30318709393223438',
                value: 1,
                target: '57_1007587945051349126'
            },
            {
                source: '57_30318709393223438',
                value: 1,
                target: '57_1044994308802932904'
            },
            {
                source: '57_30318709393223438',
                value: 1,
                target: '57_1044629621833764959'
            },
            {
                source: '57_30318709393223438',
                value: 1,
                target: '57_1073980735330726037'
            },
            {
                source: '57_30318709393223438',
                value: 1,
                target: '57_1044994308802932888'
            },
            {
                source: '57_30318709393223438',
                value: 1,
                target: '57_1007587945051349109'
            },
            {
                source: '57_30318709393223438',
                value: 1,
                target: '57_1044629621833764964'
            },
            {
                source: '57_30318709393223438',
                value: 1,
                target: '57_1044994308802932862'
            },
            {
                source: '1008938620507164753',
                value: 1,
                target: '57_30318710020423721'
            },
            {
                source: '57_30318710020423721',
                value: 1,
                target: '57_30318710020586437'
            },
            {
                source: '57_30318710020423721',
                value: 1,
                target: '57_30318710020592744'
            },
            {
                source: '57_30318710020423721',
                value: 1,
                target: '57_30318710020596223'
            },
            {
                source: '57_30318710020423721',
                value: 1,
                target: '57_30318710020599783'
            },
            {
                source: '1008938620507164753',
                value: 1,
                target: '57_30318710024952997'
            },
            {
                source: '57_30318710024952997',
                value: 1,
                target: '57_30318710025079581'
            },
            {
                source: '57_30318710024952997',
                value: 1,
                target: '57_30318710025083825'
            },
            {
                source: '57_30318710024952997',
                value: 1,
                target: '57_30318710025085681'
            },
            {
                source: '57_30318710024952997',
                value: 1,
                target: '57_30318710025087516'
            },
            {
                source: '57_30318710024952997',
                value: 1,
                target: '57_30318710025089228'
            },
            {
                source: '1008938620507164753',
                value: 1,
                target: '57_30318710025092950'
            },
            {
                source: '57_30318710025092950',
                value: 1,
                target: '57_30318710029664923'
            },
            {
                source: '57_30318710025092950',
                value: 1,
                target: '57_30318710056592530'
            },
            {
                source: '57_30318710025092950',
                value: 1,
                target: '57_30318710083640798'
            },
            {
                source: '57_30318710025092950',
                value: 1,
                target: '57_30318710111578567'
            },
            {
                source: '57_30318710025092950',
                value: 1,
                target: '57_30318710142191354'
            },
            {
                source: '1008938620507164753',
                value: 1,
                target: '57_30318710173746161'
            },
            {
                source: '57_30318710173746161',
                value: 1,
                target: '57_30318710173767330'
            },
            {
                source: '57_30318710173746161',
                value: 1,
                target: '57_30318710173771103'
            },
            {
                source: '1008938620507164753',
                value: 1,
                target: '57_30318710173775951'
            },
            {
                source: '1008938620507164753',
                value: 1,
                target: '57_30318710787402799'
            },
            {
                source: '1008938620507164753',
                value: 1,
                target: '57_30318711168622091'
            },
            {
                source: '57_30318711168622091',
                value: 1,
                target: '57_1031468354918940740'
            },
            {
                source: '57_30318711168622091',
                value: 1,
                target: '57_1031468354713464917'
            },
            {
                source: '57_30318711168622091',
                value: 1,
                target: '57_1031468354713464923'
            },
            {
                source: '57_30318711168622091',
                value: 1,
                target: '57_1031468355036397670'
            },
            {
                source: '57_30318711168622091',
                value: 1,
                target: '57_1031468355367759987'
            },
            {
                source: '57_30318711168622091',
                value: 1,
                target: '57_1031468355036397661'
            },
            {
                source: '57_30318711168622091',
                value: 1,
                target: '57_1031468355141263412'
            },
            {
                source: '57_30318711168622091',
                value: 1,
                target: '57_1031468354918940782'
            },
            {
                source: '57_30318711168622091',
                value: 1,
                target: '57_1031468354713464875'
            },
            {
                source: '57_30318711168622091',
                value: 1,
                target: '57_1031468355141263394'
            },
            {
                source: '57_30318711168622091',
                value: 1,
                target: '57_1031468354918940716'
            },
            {
                source: '57_30318711168622091',
                value: 1,
                target: '57_1031468354373709875'
            },
            {
                source: '57_30318711168622091',
                value: 1,
                target: '57_1031468354373709887'
            },
            {
                source: '57_30318711168622091',
                value: 1,
                target: '57_1031468354373709836'
            },
            {
                source: '57_30318711168622091',
                value: 1,
                target: '57_1031468354918940743'
            },
            {
                source: '57_30318711168622091',
                value: 1,
                target: '57_1031468355271299221'
            },
            {
                source: '57_30318711168622091',
                value: 1,
                target: '57_1031468354918940715'
            },
            {
                source: '57_30318711168622091',
                value: 1,
                target: '57_1031468355141263413'
            },
            {
                source: '57_30318711168622091',
                value: 1,
                target: '57_1031468354814115900'
            },
            {
                source: '57_30318711168622091',
                value: 1,
                target: '57_1031468355036397607'
            },
            {
                source: '1008938620507164753',
                value: 1,
                target: '57_30318711831967496'
            },
            {
                source: '57_30318711831967496',
                value: 1,
                target: '57_30318711832014948'
            },
            {
                source: '57_30318711831967496',
                value: 1,
                target: '57_30318711832020335'
            },
            {
                source: '57_30318711831967496',
                value: 1,
                target: '57_30318711832022382'
            },
            {
                source: '57_30318711831967496',
                value: 1,
                target: '57_30318711832036568'
            },
            {
                source: '57_30318711831967496',
                value: 1,
                target: '57_30318711832037898'
            },
            {
                source: '1008936154810036313',
                value: 1,
                target: '30318564006786556'
            },
            {
                source: '30318564006786556',
                value: 1,
                target: '1088493651933266052'
            },
            {
                source: '1088493651933266052',
                value: 1,
                target: '117_30318845295734505'
            },
            {
                source: '117_30318845295734505',
                value: 1,
                target: '117_1126165057126809689'
            },
            {
                source: '117_30318845295734505',
                value: 1,
                target: '117_1126165074617061504'
            },
            {
                source: '117_30318845295734505',
                value: 1,
                target: '117_1116017939212927075'
            },
            {
                source: '117_30318845295734505',
                value: 1,
                target: '117_1126165122646061126'
            },
            {
                source: '117_30318845295734505',
                value: 1,
                target: '117_1126165069181251685'
            },
            {
                source: '117_30318845295734505',
                value: 1,
                target: '117_1126165042316742802'
            },
            {
                source: '117_30318845295734505',
                value: 1,
                target: '117_1126165111229182059'
            },
            {
                source: '117_30318845295734505',
                value: 1,
                target: '117_1126165074528972913'
            },
            {
                source: '117_30318845295734505',
                value: 1,
                target: '117_1126165087552286841'
            },
            {
                source: '117_30318845295734505',
                value: 1,
                target: '117_1107318961814380666'
            },
            {
                source: '1088493651933266052',
                value: 1,
                target: '117_30318845804384665'
            },
            {
                source: '1088493651933266052',
                value: 1,
                target: '117_30318845812671410'
            },
            {
                source: '117_30318845812671410',
                value: 1,
                target: '117_30318845812789167'
            },
            {
                source: '1088493651933266052',
                value: 1,
                target: '117_30318845812806365'
            },
            {
                source: '117_30318845812806365',
                value: 1,
                target: '117_30318845820770871'
            },
            {
                source: '1088493651933266052',
                value: 1,
                target: '117_30318845860184239'
            },
            {
                source: '1088493651933266052',
                value: 1,
                target: '117_30318845860198178'
            },
            {
                source: '1088493651933266052',
                value: 1,
                target: '117_30318845890082917'
            },
            {
                source: '1088493651933266052',
                value: 1,
                target: '117_30318846205352512'
            },
            {
                source: '117_30318846205352512',
                value: 1,
                target: '117_1031468354713464917'
            },
            {
                source: '117_30318846205352512',
                value: 1,
                target: '117_1031468354918940782'
            },
            {
                source: '117_30318846205352512',
                value: 1,
                target: '117_1031468354918940740'
            },
            {
                source: '117_30318846205352512',
                value: 1,
                target: '117_1031468354814115949'
            },
            {
                source: '117_30318846205352512',
                value: 1,
                target: '117_1031468355367759972'
            },
            {
                source: '117_30318846205352512',
                value: 1,
                target: '117_1031468355141263446'
            },
            {
                source: '1088493651933266052',
                value: 1,
                target: '117_30318846403177801'
            },
            {
                source: '117_30318846403177801',
                value: 1,
                target: '117_30318846403205378'
            },
            {
                source: '30318564006786556',
                value: 1,
                target: '1134885965492412506'
            },
            {
                source: '1134885965492412506',
                value: 1,
                target: '36_30318658752077972'
            },
            {
                source: '36_30318658752077972',
                value: 1,
                target: '36_1135224789783314523'
            },
            {
                source: '36_30318658752077972',
                value: 1,
                target: '36_1135224750872727664'
            },
            {
                source: '36_30318658752077972',
                value: 1,
                target: '36_1135224741766914149'
            },
            {
                source: '36_30318658752077972',
                value: 1,
                target: '36_1144282809565753434'
            },
            {
                source: '36_30318658752077972',
                value: 1,
                target: '36_1135224773077368912'
            },
            {
                source: '36_30318658752077972',
                value: 1,
                target: '36_1135224785085698063'
            },
            {
                source: '36_30318658752077972',
                value: 1,
                target: '36_1135224788596314185'
            },
            {
                source: '36_30318658752077972',
                value: 1,
                target: '36_1135224741783699583'
            },
            {
                source: '36_30318658752077972',
                value: 1,
                target: '36_1135224824042389571'
            },
            {
                source: '36_30318658752077972',
                value: 1,
                target: '36_1135224736695980126'
            },
            {
                source: '1134885965492412506',
                value: 1,
                target: '36_30318659193318752'
            },
            {
                source: '36_30318659193318752',
                value: 1,
                target: '36_30318659193493739'
            },
            {
                source: '36_30318659193318752',
                value: 1,
                target: '36_30318659193501164'
            },
            {
                source: '36_30318659193318752',
                value: 1,
                target: '36_30318659193506659'
            },
            {
                source: '1134885965492412506',
                value: 1,
                target: '36_30318659199849769'
            },
            {
                source: '36_30318659199849769',
                value: 1,
                target: '36_30318659200025754'
            },
            {
                source: '36_30318659199849769',
                value: 1,
                target: '36_30318659200032365'
            },
            {
                source: '36_30318659199849769',
                value: 1,
                target: '36_30318659200034543'
            },
            {
                source: '36_30318659199849769',
                value: 1,
                target: '36_30318659200036235'
            },
            {
                source: '36_30318659199849769',
                value: 1,
                target: '36_30318659200038023'
            },
            {
                source: '1134885965492412506',
                value: 1,
                target: '36_30318659200043365'
            },
            {
                source: '36_30318659200043365',
                value: 1,
                target: '36_30318659206709708'
            },
            {
                source: '36_30318659200043365',
                value: 1,
                target: '36_30318659238291776'
            },
            {
                source: '36_30318659200043365',
                value: 1,
                target: '36_30318659265890713'
            },
            {
                source: '36_30318659200043365',
                value: 1,
                target: '36_30318659293738898'
            },
            {
                source: '36_30318659200043365',
                value: 1,
                target: '36_30318659320352894'
            },
            {
                source: '1134885965492412506',
                value: 1,
                target: '36_30318659354295849'
            },
            {
                source: '36_30318659354295849',
                value: 1,
                target: '36_30318659354329220'
            },
            {
                source: '36_30318659354295849',
                value: 1,
                target: '36_30318659354333879'
            },
            {
                source: '1134885965492412506',
                value: 1,
                target: '36_30318659354340298'
            },
            {
                source: '1134885965492412506',
                value: 1,
                target: '36_30318659385310080'
            },
            {
                source: '1134885965492412506',
                value: 1,
                target: '36_30318659776546513'
            },
            {
                source: '1134885965492412506',
                value: 1,
                target: '36_30318659796987542'
            },
            {
                source: '36_30318659796987542',
                value: 1,
                target: '36_30318659797041166'
            },
            {
                source: '36_30318659796987542',
                value: 1,
                target: '36_30318659797046183'
            },
            {
                source: '36_30318659796987542',
                value: 1,
                target: '36_30318659797048787'
            },
            {
                source: '36_30318659796987542',
                value: 1,
                target: '36_30318659797050604'
            },
            {
                source: '30318564006786556',
                value: 1,
                target: '1141762677031338067'
            },
            {
                source: '1141762677031338067',
                value: 1,
                target: '38_30318662426417613'
            },
            {
                source: '38_30318662426417613',
                value: 1,
                target: '38_1142106917338914928'
            },
            {
                source: '38_30318662426417613',
                value: 1,
                target: '38_1142106912553173105'
            },
            {
                source: '38_30318662426417613',
                value: 1,
                target: '38_1142106922103664740'
            },
            {
                source: '38_30318662426417613',
                value: 1,
                target: '38_1142106917884166343'
            },
            {
                source: '38_30318662426417613',
                value: 1,
                target: '38_1142106920614658078'
            },
            {
                source: '38_30318662426417613',
                value: 1,
                target: '38_1142106917439561893'
            },
            {
                source: '38_30318662426417613',
                value: 1,
                target: '38_1142106913715019845'
            },
            {
                source: '38_30318662426417613',
                value: 1,
                target: '38_1142106917066276981'
            },
            {
                source: '38_30318662426417613',
                value: 1,
                target: '38_1142106924007841929'
            },
            {
                source: '38_30318662426417613',
                value: 1,
                target: '38_1142106919033380876'
            },
            {
                source: '1141762677031338067',
                value: 1,
                target: '38_30318662879049997'
            },
            {
                source: '38_30318662879049997',
                value: 1,
                target: '38_30318662879276958'
            },
            {
                source: '1141762677031338067',
                value: 1,
                target: '38_30318662884379897'
            },
            {
                source: '38_30318662884379897',
                value: 1,
                target: '38_30318662884630443'
            },
            {
                source: '38_30318662884379897',
                value: 1,
                target: '38_30318662884637805'
            },
            {
                source: '1141762677031338067',
                value: 1,
                target: '38_30318662884643166'
            },
            {
                source: '38_30318662884643166',
                value: 1,
                target: '38_30318662889302392'
            },
            {
                source: '38_30318662884643166',
                value: 1,
                target: '38_30318662918139963'
            },
            {
                source: '38_30318662884643166',
                value: 1,
                target: '38_30318662950088501'
            },
            {
                source: '38_30318662884643166',
                value: 1,
                target: '38_30318662979600607'
            },
            {
                source: '38_30318662884643166',
                value: 1,
                target: '38_30318663008376386'
            },
            {
                source: '1141762677031338067',
                value: 1,
                target: '38_30318663045105210'
            },
            {
                source: '38_30318663045105210',
                value: 1,
                target: '38_30318663045136830'
            },
            {
                source: '38_30318663045105210',
                value: 1,
                target: '38_30318663045141123'
            },
            {
                source: '1141762677031338067',
                value: 1,
                target: '38_30318663045146756'
            },
            {
                source: '1141762677031338067',
                value: 1,
                target: '38_30318663076446848'
            },
            {
                source: '1141762677031338067',
                value: 1,
                target: '38_30318663390583594'
            },
            {
                source: '1141762677031338067',
                value: 1,
                target: '38_30318663395450824'
            },
            {
                source: '38_30318663395450824',
                value: 1,
                target: '38_30318663395482927'
            },
            {
                source: '38_30318663395450824',
                value: 1,
                target: '38_30318663395486857'
            }
        ]
    }
};
